const dictionary = {
	'Customer information not found': 'Datos del cliente no encontrados',
	'Account subscription expired, renew to continue.': 'La suscripción a la cuenta expiró, renuévela para continuar',
	'Account subscription cancelled, renew to continue.': 'Suscripción de cuenta cancelada, renovar para continuar.',

	Warning: 'Aviso',
	'View video': 'Consultar video',
	Yes: 'Sí',
	No: 'No',
	Home: 'Inicio',
	'Frequency and load': 'Frecuencia y carga',
	'Movement frequency': 'Frecuencia del movimiento',
	'Select the maximum number of times the movement is performed per activity and workday':
		'Seleccione la cantidad máxima de veces que se realiza el movimiento por actividad y día de trabajo',
	'Load weight': 'Peso de la carga',
	Men: 'Hombres',
	Women: 'Mujeres',
	'Load transport in pairs?': 'Transporte de carga en parejas?',
	'Load inclination?': '¿Hay inclinación de carga?',
	'Effective load weight': 'Peso efectivo de la carga',
	'Effective load weight tooltip':
		'El peso efectivo de la carga corresponde al esfuerzo físico realmente ejercido. Al inclinar una caja, se aplica el 50% del peso; al transportar en parejas, el 60% afecta a cada persona.',
	'Load handling conditions': 'Condiciones de manejo de carga',
	'Load handled with both hands symmetrically': 'La carga se maneja con ambas manos y de forma simétrica',
	'Load handled temporarily with one hand or asymmetrically with unequal weight distribution':
		'La carga se maneja temporalmente con una mano y/o de forma asimétrica, con distribución desigual del peso entre ambas manos',
	'Load handled predominantly with one hand or has unstable center of balance':
		'La carga se maneja predominantemente con una mano o tiene centro de equilibrio inestable',
	'Partial result': 'Resultado parcial',
	Posture: 'Postura',
	'Body posture': 'Postura corporal',
	'Body posture tooltip':
		'El movimiento puede ocurrir en ambas direcciones; las posturas pueden indicar inicio o término de la operación. Cuando hay varias posturas en la misma opción, todas representan la misma condición.',
	'Select the option that represents the posture at the start and end of the operation':
		'Seleccione la opción que representa las posturas de inicio y término de la operación',
	'Additional factors': 'Factores adicionales',
	'Occasional identifiable trunk twisting and/or lateral bending':
		'Torsión y/o inclinación lateral ocasional del tronco identificable',
	'Frequent or constant identifiable trunk twisting and/or lateral bending':
		'Torsión y/o inclinación lateral frecuente o constante del tronco identificable',
	'Load center and/or hands occasionally away from the body':
		'Centro de carga y/o manos ocasionalmente alejados del cuerpo',
	'Load center and/or hands frequently or constantly away from the body':
		'Centro de carga y/o manos frecuentemente o constantemente alejados del cuerpo',
	'Arms occasionally elevated, with hands between elbow and shoulder level':
		'Brazos ocasionalmente elevados, con las manos entre el nivel del codo y el hombro',
	'Arms frequently or constantly elevated, with hands between elbow and shoulder level':
		'Brazos frecuentemente o constantemente elevados, con las manos entre el nivel del codo y el hombro',
	'Hands occasionally above shoulder height': 'Manos ocasionalmente por encima de la altura del hombro',
	'Hands frequently or constantly above shoulder height':
		'Manos frecuentemente o constantemente por encima de la altura del hombro',

	// KIM-LHC Work Condition
	'Work Condition': 'Condiciones de trabajo',
	'Unfavorable work conditions': 'Condiciones de trabajo desfavorables',
	'Hand/arm position and movements': 'Posición y movimientos de manos/brazos',
	'Occasionally at the limit of range of motion': 'Ocasionalmente en el límite de la amplitud de movimiento',
	'Frequently/constantly at the limit of range of motion':
		'Frecuentemente/constantemente en el límite de la amplitud de movimiento',
	'Force transfer/application': 'Transferencia/aplicación de fuerza',
	Restricted: 'Restringida',
	'Loads difficult to hold / greater holding force required / absence of molded handles / use of work gloves':
		'Cargas difíciles de segurar / mayor fuerza de sustentaón necesaria / ausencia de manijas moldeadas / uso de guantes de trabajo',
	'Considerably hindered': 'Considerablemente dificultada',
	'Loads almost impossible to hold / slippery, soft or sharp edges surfaces / absence or inadequacy of grips / use of work gloves':
		'Cargas casi imposibles de segurar / superficies resbaladizas, blandas o con bordes cortantes / ausencia o insuficiencia de manijas / uso de guantes de trabajo',
	'Adverse environmental conditions': 'Condiciones ambientales adversas',
	'Unfavorable climatic conditions and/or physical loads caused by heat, wind, cold or humidity':
		'Condiciones climáticas desfavorables y/o cargas físicas causadas por calor, viento, frío o humedad',
	'Spatial conditions': 'Condiciones espaciales',
	'Work area less than 1.5 m², moderately dirty floor and slightly uneven floor, slight slope up to 5°, slightly restricted stability, load must be positioned with precision':
		'Área de trabajo menor que 1,5 m², piso moderadamente sucio y ligeramente irregular, pendiente suave de hasta 5°, estabilidad ligeramente restringida, carga debe ser posicionada con precisión',
	Unfavorable: 'Desfavorables',
	'Significantly restricted freedom of movement or insufficient space for movement, work in confined spaces, very dirty, uneven or roughly paved floor, steps/holes, steep slope of 5–10°, restricted stability, load must be positioned with great precision':
		'Libertad de movimiento significativamente restringida o espacio insuficiente para movimiento, trabajo en espacios confinados, piso muy sucio, irregular o grosseiramente pavimentado, escaleras/huecos, pendiente pronunciada de 5–10°, estabilidad restringida, carga debe ser posicionada con gran precisión',
	Clothing: 'Ropas',
	'Additional physical effort due to heavy clothing or equipment that restricts movement (such as, heavy rain protection clothing, full protective clothing, breathing equipment, tool belts or similar)':
		'Esforzo físico adicional debido a ropas o equipos que dificultan los movimientos (por ejemplo, al usar capas de chuva pesadas, ropas de protección integral, equipos de protección respiratoria, cinturones de herramientas o similares)',
	'Holding/carrying': 'Segurar/transportar',
	Difficulty: 'Dificultad',
	'The load must be held for more than 5 to 10 seconds or carried to a distance of more than 2 m to 5 m':
		'La carga debe ser mantenida por más de 5 a 10 segundos o transportada a una distancia de más de 2 m a 5 m',
	'Significant difficulty': 'Dificultad significativa',
	'The load must be held for more than 10 seconds or carried to a distance of more than 5 m':
		'La carga debe ser mantenida por más de 10 segundos o transportada a una distancia superior a 5 m',
	'Hand/arm position and movements occasional': 'Posición y movimientos de mano/brazo ocasionales',
	'Hand/arm position and movements frequent': 'Posición y movimientos de mano/brazo frecuentes',
	'Force transfer/application restricted': 'Transferencia/aplicación de fuerza restringida',
	'Force transfer/application considerably hindered': 'Transferencia/aplicación de fuerza considerablemente afectada',
	'Adverse environmental conditions unfavorable climatic': 'Condiciones ambientales adversas con clima desfavorable',
	'Spatial conditions restricted': 'Condiciones espaciales restringidas',
	'Spatial conditions unfavorable': 'Condiciones espaciales desfavorables',
	Clothes: 'Ropa',
	'Hold/carry difficulty': 'Dificultad para sostener/transportar',
	'Hold/carry significant difficulty': 'Dificultad significativa para sostener/transportar',

	'Ergonomic Work Analysis': 'Análisis Ergonómico del Trabajo',
	'Ergonomic Workplace Analysis': 'Análisis Ergonómico del Lugar de Trabajo',
	'Type of report': 'Tipo de informe',
	until: 'hasta',

	Companies: 'Empresas',
	'Corrupted file': 'Archivo corrompido',
	'Extracted data': 'Datos extraídos',
	'Not processing': 'Sin procesar',
	Processing: 'Procesando',
	Processed: 'Procesada',
	'In queue': 'En fila',

	// Upload
	'Send video': 'Subir video',
	'Add files or drag': 'Agregar archivos o arrastrar',
	'Unsupported file': 'Archivo no soportado',
	'Drop files here': 'Suelte archivos aquí',
	'Unsupported video format': 'Formato de video no compatible',
	and: 'y',
	'is larger than': 'Es mas grande que',
	'Max size': 'Tamaño máximo',
	'Image description': 'Descripción de la imagen',
	'Image description updated successfully': 'Descripción de la imagen actualizada con éxito',
	'Are you sure you want to delete this image?': '¿Realmente quieres eliminar esta imagen?',
	'Image deleted successfully': 'Imagen eliminada con éxito',
	'Error deleting image': 'Error al eliminar la imagen',
	Blur: 'Desenfocar',
	'Are you sure you want to exit? You have an uploads in process.':
		'¿Estás seguro de que quieres salir? Tienes una carga en proceso.',
	' or many files': ' o muchos archivos',
	'Files number exceeded': 'Número de archivos excedidos',
	'Max files': 'Máximo de archivos',
	'User created with success': 'Usuario creado con éxito',
	'File duplicated': 'Archivo duplicado',

	// Select project
	'Select the desired company below': 'Seleccione la empresa deseada',
	'Select the desired industrial site below': 'Seleccione el centro de trabajo deseado',

	'Create a new company': 'Crear una nueva empresa',
	'Create a new industrial site': 'Crear un nuevo centro de trabajo',

	'Enter a name for the company': 'Introduzca un nombre de empresa',
	'Enter a name for the industrial site': 'Introduzca un nombre para el centro de trabajo',

	'Company created successfully': 'Empresa creada con éxito',
	'Industrial site created successfully': 'Centro de trabajo creada con éxito',

	'There are no registered companies': 'No hay empresas registradas',
	'There are no registered industrial sites': 'No hay centro de trabajo registrado',

	'Failed to fetch information': 'Error al obtener información',

	'Congratulations! Now create an industrial site that belongs to this company.':
		'¡Felicidades! Ahora cree el centro de trabajo que pertenece a esta empresa y comience a usar la plataforma',
	'Create industrial site': 'Crear centro de trabajo',

	'Welcome to Kinebot, create your first company': 'Bienvenido a Kinebot, crea tu primera empresa',
	'Create company': 'Crear empresa',

	'Ergonomic tools': 'Herramientas ergonómicas',
	'Select the most suitable tool for your analysis': 'Seleccione la herramienta más adecuada para su análisis',
	'Biomechanical analysis': 'Análisis biomecánico',
	'Load analysis': 'Análisis de carga',
	'Repeatability analysis': 'Análisis de repetibilidad',

	'Go back': 'Regresar',
	Back: 'Regresar',
	Create: 'Crear',

	// Report/UploadList
	Workstation: 'Puesto de trabajo',
	Description: 'Descripción',
	Size: 'Tamaño',
	'Upload date': 'Fecha de carga',
	Status: 'Provincia',
	Sector: 'Sector',
	Actions: 'Acciones',
	'Not assigned': 'No asignado',
	'Heads up!': '¡Aviso!',
	'Heads up! Want to delete this file?': '¡Aviso! ¿Quieres eliminar este archivo?',
	'Heads up! Want to delete this report?': '¡Aviso! ¿Quieres eliminar este reporte?',
	'Heads up! Want to delete this action plan?': '¡Aviso! ¿Quieres eliminar este plan de acción?',
	'Heads up! Want to delete this workstation?': '¡Aviso! ¿Quieres eliminar este puesto de trabajo?',
	'Heads up! Want to delete this line? All workstations related to it will be lost.':
		'¡Aviso! ¿Quieres eliminar esta línea? Se perderán todos los puestos de trabajo relacionados con él.',
	'Heads up! Want to delete this sector? All lines and workstations related to it will be lost.':
		'¡Aviso! ¿Quieres eliminar este sector? Se perderán todas las líneas y puestos de trabajo relacionados con él.',
	'Heads up! Want to delete this industrial site? All sectors, lines and workstations related to it will be lost.':
		'¡Aviso! ¿Quiere eliminar este centro de trabajo? Se perderán todos los sectores, líneas y puestos de trabajo relacionados con él.',
	'Force/Charge movement data': 'Datos de movimiento con fuerza/carga',
	Rating: 'Clasificación',
	Repetitions: 'Repeticiones',
	Legs: 'Piernas',
	Diagnostic: 'Diagnóstico',
	'Analysis results': 'Resultados de analisis',

	'Not found': 'No encontrado',
	'Failed to fetch data': 'Error al obtener los datos',
	//'Risk level of the job': 'Grado de riesgo del trabajo',
	'Average exposure of the workplace': 'Exposición media del lugar de trabajo',
	'Unable to show results.': 'No se pueden mostrar los resultados',

	'Load less than 2 kg (intermittent)': 'Carga menos de 2kg (intermitente)',
	'Load from 2 kg to 10 kg (intermittent)': 'Carga de 2 kg a 10 kg (intermitente)',
	'Load from 2 kg to 10 kg (static or repetitive)': 'Carga de 2 kg a 10 kg (estática o repetitiva)',
	'Bigger load 10 kg of repetitive load or blows': 'Mayor carga 10kg de carga repetitiva o golpe',
	'Legs and feet supported and with equal load distribution':
		'Piernas y pies soportados y con igual distribución de carga',
	'Legs without support': 'Piernas sin apoyo',

	Reports: 'Reportes',
	'Select the data visualization model': 'Seleccione el modelo de visualización de datos',
	Angle: 'Ángulo',
	'Angle in degrees (°)': 'Ángulo en grados (°)',
	'Time in seconds (s)': 'Tiempo en segundos (s)',
	'Movement by score': 'Movimiento por puntuación',
	Parameters: 'Parámetros',

	'Push and pull': 'Empuje y arraste',
	'KIM - Push and pull': 'KIM - Empuje y arraste',

	'KIM - PP Report Results': 'KIM - EA Informe de Resultados',
	meters: 'metros',
	'Temporal distribution': 'Distribución del tiempo',
	Distance: 'Distancia',
	'Vehicle properties': 'Propiedades del vehículo',
	Vehicle: 'Vehículo',
	'Distance or duration': 'Distancia o duración',

	'Select one of the options below': 'Seleccione una de las siguientes opciones',
	'Short distances': 'Distancias cortas',
	'Long distances': 'Distancias largas',
	Time: 'Tiempo',
	Mass: 'Masa',
	Precision: 'Precision',
	'Worker gender': 'Género del trabajador',
	'Pushing / Pulling in pairs': 'Empujando / Arrastando em parejas',
	Male: 'Masculino',
	Female: 'Femenino',
	'By distance': 'Por la distancia',
	'By duration': 'Por la duración',
	'Distance per work day (in meters)': 'Distancia por lo día de trabajo (en metros)',
	'Duration per work day (in minutes)': 'Duración por día de trabajo (en minutos)',
	'≤ 40': '≤ 40',
	'≤ 200': '≤ 200',
	'≤ 400': '≤ 400',
	'≤ 800': '≤ 800',
	'≤ 1,200': '≤ 1.200',
	'≤ 1,800': '≤ 1.800',
	'≤ 2,500': '≤ 2.500',
	'≤ 4,200': '≤ 4.200',
	'≤ 6,300': '≤ 6.300',
	'≤ 8,400': '≤ 8.400',
	'≤ 11,000': '≤ 11.000',
	'≤ 15,000': '≤ 15.000',
	'≤ 20,000': '≤ 20.000',
	'≤ 1': '≤ 1',
	'≤ 5': '≤ 5',
	'≤ 10': '≤ 10',
	'≤ 20': '≤ 20',
	'≤ 30': '≤ 30',
	'≤ 45': '≤ 45',
	'≤ 60': '≤ 60',
	'≤ 100': '≤ 100',
	'≤ 150': '≤ 150',
	'≤ 210': '≤ 210',
	'≤ 270': '≤ 270',
	'≤ 360': '≤ 360',
	'≤ 480': '≤ 480',
	'Select one of the vehicles': 'Seleccione uno de los vehículos',
	Barrows: 'Carretillas',
	Carriages: 'Carruaje',
	'Overhead conveyors': 'Transportadores',
	'Overhead cranes': 'Gruas',
	'Choose an option': 'Elige una opción',
	'Reference image: only swivel castors': 'Imagen de referencia: ruedas móviles solamente',
	'Reference image: with fixed castors or lockable swivel castors':
		'Imagen de referencia: con ruedas fijas o bloqueables',
	'Reference image: pedestrian-controlled': 'Imagen de referencia: controlado por peatones',
	'Driveway condition': 'Estado de la acera',
	'Inclination or stairs': 'Pendiente o escaleras',
	'Select the mass to be transported (in kg)': 'Seleccione la masa a transportar (en kg)',
	'Driveway completely level, smooth, solid, dry, without inclinations':
		'Pavimento completamente nivelado, liso, sólido, seco, sin pendientes',
	'Driveway mostly smooth and level, with small damaged spots/faults, without inclinations':
		'Acera casi lisa y nivelada, con pequeños daños en algunos lugares, sin pendientes',
	'Mixture of cobbles, concrete, asphalt, slight inclinations, dropped kerb':
		'Mezcla de adoquines, hormigón, asfalto, pendientes ligeras, bordillo bajo',
	'Mixture of roughly cobbled, hard sand, slight inclinations, small edges/sills':
		'Mezcla áspera de adoquines, arena dura, pendientes ligeras y bordes/alféizares pequeños',
	'Earth or roughly cobbled driveway, potholes, heavy soiling, slight inclinations, landings, sills':
		'Mezcla áspera de tierra o adoquines, baches, tierra pesada, pendientes pequeñas, descansos, umbrales',
	'Inclinations of 2 ≤ 4° (4 ≤ 8%)': 'Pendientes de 2 ≤ 4° (4 ≤ 8%)',
	'Inclinations of 5 ≤ 10° (9 ≤ 18%)': 'Pendientes de 5 ≤ 10° (9 ≤ 18%)',
	'Stairs, inclinations > 10° (18%)': 'Escaleras, pendientes > 10° (18%)',
	'No significant inclination': 'Sin pendiente relevante',
	'≤ 50': '≤ 50',
	'≤ 300': '≤ 300',
	'≤ 600': '≤ 600',
	'≤ 1,000': '≤ 1.000',
	'≤ 1,300': '≤ 1.300',
	'> 1,300': '> 1.300',
	'Select the appropriate options': 'Seleccione la opción apropiada',
	'Unfavorable working conditions - more than one can be selected':
		'Condiciones laborales desfavorables - se puede seleccionar más de una opción',
	'Unfavorable vehicle properties - more than one can be selected':
		'Propiedades desfavorables del vehículo - se puede seleccionar más de una opción',
	'Unfavorable working conditions': 'Condiciones laborales desfavorables',
	'Unfavorable vehicle properties': 'Propiedades desfavorables del vehículo',
	'Regularly significantly increased starting forces, because transport devices sink into the ground or get wedged':
		'Regularmente se requiere una fuerza considerable para iniciar el movimiento, debido a que el vehículo se hunde en el suelo o se atasca',
	'Frequent stops with breaking': 'Paradas frecuentes con frenado',
	'Frequent stops without breaking': 'Paradas frecuentes sin frenado',
	'Many changes of direction or curves, frequent manouvering':
		'Muchos cambios de dirección o giros, maniobras frecuentes',
	'Load must be positioned precisely and stopped, driveway must be adhered to precisely':
		'La carga debe colocarse y asegurarse con precisión, adhiriéndose a un lugar exacto en la acera',
	'Increased movement speed (approx. 1.0 ≤ 1.3 m/s)': 'Alta velocidad de movimiento (aprox. 1.0 ≤ 1.3 m/s)',
	'None: there are no unfavorable working conditions': 'Ninguna: no existen condiciones laborales desfavorables',
	'No suitable handles or construction parts for applying force': 'No hay manijas o partes aptas para aplicar fuerza',
	'No brake when driving on inclinations > 2° (> 3%)': 'Sin frenos al manipular o inclinarse > 2° (> 3%)',
	'Unadjusted castors (e.g. too small on soft or uneven floor)':
		'Ruedas mal ajustadas (ej.: demasiado pequeño o no coincide con el suelo)',
	'Defective castors (worn-out, rubbing, stiff, air pressure too low)':
		'Ruedas defectuosas (desgastadas, rozando, atascadas, presión de aire demasiado baja)',
	'None: there are no unfavorable properties of the transport devices':
		'Ninguna: no hay propiedades desfavorables del vehículo',

	'Trunk upright or slightly inclined forward, no twisting / Force application height can be selected freely / No hindrance for the legs':
		'Torso erguido o ligeramente inclinado hacia adelante, sin torsión / Fuerza de aplicación a la altura libremente seleccionada / Sin molestias para las piernas',
	'Body inclined towards the direction of movement or slight twisting when pulling the load on one side / Fixed force application height ranging from 0.9 – 1.2 m / No or only slight hindrance for the legs / Predominantly pulling':
		'Cuerpo inclinado en la dirección del movimiento o ligeramente torcido tirando de la carga hacia los lados / Fuerza aplicada a una altura fija de 0,9 - 1,2 m / Sin complicaciones en las piernas o menores / Predominantemente tirando',
	'Awkward body postures caused by fixed force application height < 0.9 or > 1.2 m , lateral force application on one side or significantly obstructed view / Significant hindrance for the legs / Constant twisting and/or lateral inclination of the trunk':
		'Posturas extrañas del cuerpo causadas por fuerza a una altura fija de < 0,9 o > 1,2 m, aplicación de fuerza lateral a un lado o con una visión significativamente obstruida / Complicación considerable para las piernas / Torsión constante y/o flexión lateral del tronco',

	'Trunk upright or slightly inclined forward, no twisting':
		'Torso erguido o ligeramente inclinado hacia adelante, sin torsión',
	'Body inclined towards the direction of movement or slight twisting when pulling the load on one side':
		'Cuerpo inclinado en la dirección del movimiento o ligeramente torcido tirando de la carga hacia los lados',
	'Awkward body postures caused by fixed force application height < 0.9 or > 1.2 m , lateral force application on one side or significantly obstructed view':
		'Posturas extrañas del cuerpo causadas por fuerza a una altura fija de < 0,9 o > 1,2 m, aplicación de fuerza lateral a un lado o con una visión significativamente obstruida',

	'Force application height can be selected freely': 'Fuerza de aplicación a la altura libremente seleccionada',
	'Fixed force application height ranging from 0.9 – 1.2 m': 'Fuerza aplicada a una altura fija de 0,9 - 1,2 m',
	'Significant hindrance for the legs': 'Complicación considerable para las piernas',

	'No hindrance for the legs': 'Sin molestias para las piernas',
	'No or only slight hindrance for the legs': 'Sin complicaciones en las piernas o menores',
	'Constant twisting and/or lateral inclination of the trunk': 'Torsión constante y/o flexión lateral del tronco',
	'Predominantly pulling': 'Predominantemente tirando',

	Postures: 'Posturas',
	'Direction of force': 'Dirección de la fuerza',
	Unfavorable: 'Desfavorable',
	'Score and risk assessment': 'Score y definición de riesgo',
	'Intensity of load: ': 'Intensidad de carga',
	'Probability of physical overload / Possible health consequences: ':
		'Probabilidad de sobrecarga física / Posibles consecuencias para la salud',
	'Probability of physical overload': 'Probabilidad de sobrecarga física',
	'Physical overload is unlikely / No health risk is to be expected.':
		'Sobrecarga física improbable / No se espera riesgo para la salud.',
	'No health risk is to be expected': 'No se espera riesgo para la salud',
	'Physical overload is possible for less resilient persons /  Fatigue, low-grade adaptation problems which can be compensated for during leisure time':
		'La sobrecarga física es posible para personas menos resistentes / Fatiga, problemas menores de adaptación que se pueden compensar con tiempo de descanso',
	'Physical overload is possible for less resilient persons':
		'La sobrecarga física es posible para personas menos resistentes',
	'Fatigue, low-grade adaptation problems which can be compensated for during leisure time':
		'Fatiga, problemas menores de adaptación que se pueden compensar con tiempo de descanso',
	'Physical overload is also possible for normally resilient persons / Disorders (pain), possibly including dysfunctions, reversible in most cases, without morphological manifestation':
		'La sobrecarga física es posible incluso para personas con resistencia normal / Trastornos (dolor), posibilidad de disfunción, reversible en la mayoría de los casos, sin manifestación morfológica',
	'Physical overload is also possible for normally resilient persons':
		'La sobrecarga física es posible incluso para personas con resistencia normal',
	'Disorders (pain), possibly including dysfunctions, reversible in most cases, without morphological manifestation':
		'Trastornos (dolor), posibilidad de disfunción, reversible en la mayoría de los casos, sin manifestación morfológica',
	'Physical overload is likely / More pronounced disorders and/or dysfunctions, structural damage with pathological significance.':
		'Es probable una sobrecarga física / Marcadas alteraciones y/o disfunciones, daño estructural con significado patológico.',
	'More pronounced disorders and/or dysfunctions, structural damage with pathological significance':
		'Marcadas alteraciones y/o disfunciones, daño estructural con significado patológico',
	'Measures: ': 'Mediciones',
	' For less resilient persons, workplace redesign and other prevention measures may be helpful.':
		' Para las personas menos resilientes, cambiar el lugar de trabajo y otras medidas preventivas pueden ser útiles.',
	' Workplace redesign and other prevention measures should be considered.':
		' Se debe considerar cambiar el lugar de trabajo y otras medidas preventivas.',
	' Workplace redesign measures are necessary. Other prevention measures should be considered.':
		'Es necesario cambiar el lugar de trabajo. También se deben considerar otras medidas preventivas.',
	None: 'Ninguna',

	'Manual lifting': 'Levantamiento de cargas',
	'NIOSH / ISO 11228-1 - Manual lifting analysis': 'NIOSH / ISO 11228-1 - Análisis de levantamiento de cargas',

	Information: 'Información',
	'Body parts': 'Partes del cuerpo',
	Charts: 'Gráficos',

	'Industrial Site': 'Centro de trabajo',
	'Collection date': 'Fecha de colección',
	'Risk range': 'Rango de riesgo',
	'Risk Range': 'Rango de riesgo',
	'Day duration': 'Duración del día de trabajo',
	'times/day': 'veces/día',
	'Trunk rotation': 'Rotación del tronco',
	'Load center': 'Centro de carga',
	'Arms elevated': 'Brazos elevados',
	'Hands above shoulder': 'Manos por encima del hombro',
	Activity: 'Actividad',
	Evaluator: 'Evaluador',
	'Failed to fetch sectors': 'Error al obtener sectores',
	'Failed to create a new sector': 'No se pudo crear un nuevo sector',
	'Failed to fetch risk bands': 'Error al buscar bandas de riesgo',
	'Sector created successfully': 'Sector creado con éxito',
	'Line created successfully': 'Línea creada con éxito',
	'Workstation created successfully': 'Puesto de trabajo creado con éxito',
	'TLID created successfully': 'TLID creada con éxito',
	'Evaluator created successfully': 'Evaluador creado con éxito',
	'Cycle created successfully': 'Ciclo creado con éxito',

	'Select a sector': 'Seleccione un sector',
	'Insert a workstation': 'Insertar un trabajo',
	'Insert the date of collection': 'Introduzca la fecha de recogida',
	'Select a risk band': 'Seleccione un rango de riesgo',
	'Graphs of selected body parts': 'Gráfico de partes del cuerpo seleccionadas',

	Summary: 'Resumen',
	'Range of Risk': 'Rango de riesgo',
	'Job information': 'Informacion del trabajo',
	'File data': 'Datos del archivo',
	'Collected Information': 'Información Recopilada',

	File: 'Archivo',
	Duration: 'Duración',
	'Relevant points': 'Puntos relevantes',
	'Most critical move': 'Movimiento más crítico',
	'Include conclusion': 'Incluir conclusión',
	'Include signature': 'Incluya Firma',
	'Insert conclusion': 'Incluir conclusión',
	'Risk track created successfully!': '¡Pista de riesgo creada con éxito!',
	'Create custom risk bands based on your analysis': 'Cree bandas de riesgo personalizadas basadas en su análisis',

	//Dashboard
	'Industrial site status': 'Estado del centro de trabajo',
	'Harmful postures': 'Posturas perjudiciales',
	'Inadequate postures': 'Posturas inapropiadas',
	'Workstation with good postures': 'Mensajes con buenas posturas',
	'Workers in real danger': 'Trabajadores en riesgo real',
	'Total of videos': 'Vídeos totales',
	'Processed minutes': 'Minutos procesados',
	'Critical sector': 'Sector crítico',
	'Registered sectors': 'Sectores registrados',
	'Exported reports': 'Reportes extraídos',
	'Sectors in alert': 'Sectores de alerta',
	'Main statistics': 'Estadísticas principales',
	'No. of videos by risk level': 'Total de videos por nivel de riesgo',
	Month: 'Mes',
	Year: 'Año',
	Day: 'Dia',
	'Assessments completed': 'Evaluaciones completas',
	'Videos by sector': 'Vídeos por sectores',
	'Percentage of videos by risk': 'Porcentaje de videos en riesgo',
	'Ergonomics Management': 'Gestión de la ergonomía',
	'Risk Quotation': 'Cotización de riesgo',
	'Total workstations': 'Estaciones de trabajo totales',
	'Total pending evaluations': 'Total de evaluaciones pendientes',
	'Total evaluations consolidated': 'Total evaluaciones consolidadas',
	Evaluations: 'Evaluaciones',
	'Not analyzed': 'No analizado',
	'There are no registered action plans': 'No hay planes de acción registrados',
	'Not applicable': 'No aplicable',
	'Acceptable Risk': 'Riesgo aceptable',
	'Acceptable risk': 'Riesgo aceptable',
	'Moderate Risk': 'Riesgo moderado',
	'Moderate risk': 'Riesgo moderado',
	'High Risk': 'Alto riesgo',
	'High risk': 'Alto riesgo',
	'Very High Risk': 'Riesgo muy alto',
	'Very high risk': 'Riesgo muy alto',
	'Extreme and Imminent Risk': 'Riesgo extremo e inminente',
	'Serious and imminent risk': 'Riesgo extremo e inminente',
	'Serious and Imminent Risk': 'Riesgo extremo e inminente',
	'Serious risk': 'Riesgo extremo',
	'Low Risk': 'Riesgo leve',
	'Medium Risk': 'Riesgo moderado',
	'Unit overview': 'Descripción general de la unidad',
	'There is nothing to access.': 'No hay nada a lo que acceder.',
	'There is no data': 'no hay datos',
	'of the workstation are': 'de los postos de trabajo son',

	// Dashboard Filter
	Lines: 'Líneas',
	'Select the line': 'Seleccione la línea',
	'Select the Workstation': 'Seleccione la estación de trabajo',
	'Working Population': 'Población trabajadora',
	Men: 'Hombres',
	Women: 'Mujer',
	Others: 'Otros',
	'Stress level': 'Nivel de estrés',
	'Risk Level': 'Nivel de riesgo',

	// Dashboard Tools Results
	Repetitiveness: 'Repetitividad',
	'Cargo Handling': 'Manipulación de la carga',
	'Work Organization': 'Organización del trabajo',
	'Score by workstation': 'Puntuación por estación de trabajo',
	'Total evaluations': 'Evaluaciones totales',
	'Stress Level': 'Nivel de estrés',
	Low: 'Bajo',
	Average: 'Promedio',
	High: 'Alto',

	// Dashboard Movement by score
	'Risk per Workstation': 'Riesgo por estación de trabajo',

	// Dashboard Workstations
	Workstations: 'Estaciones de trabajo',
	'Higher workstation risk score': 'Puntuación de riesgo de estación de trabajo más alta',
	'Workstation score': 'Puntuación de la estación de trabajo',

	// Dashboard Action Plans
	'Planned Actions': 'Acciones planeadas',
	Completed: 'Hecho',
	'To do': 'Hacer',
	Concluded: 'Concluido',
	'Order by deadline': 'Ordenar por prazo',
	'Order by worst score': 'Ordenar por pior pontuação',
	Ascending: 'Ascendente',
	Descending: 'Descendente',
	'Deadline : ': 'Prazo: ',

	// Buttons
	Next: 'Siguiente',
	Previous: 'Regresar',
	delete: 'eliminar',
	Delete: 'Eliminar',

	'Do you really want to delete these tracks?': '¿Realmente desea eliminar estas pistas?',
	'Heads up! the deletion is permanent': '¡Aviso! La eliminación es permanente',
	'Risk ranges deleted successfully': 'Rangos de riesgo eliminados con éxito',

	'Description (optional)': 'Descripción (opcional)',

	// Body parts
	Neck: 'Cuello',
	Trunk: 'Tronco',
	UpperArm: 'Hombro',
	LowerArm: 'Codo',

	'Customize bands of risk': 'Personalice los rangos de riesgo',
	'Create custom risk strips according to your needs.': 'Crea tiras de riesgo personalizadas según tus necesidades',

	Name: 'Nombre',
	'Industrial site name': 'Ingresa un nombre',
	'Enter a name': 'Introduzca un nombre válido',
	'Please enter a valid name': 'Introduzca un número de teléfono válido',
	'Please enter a valid phone number': 'Por favor ingrese un número de teléfono válido',
	'Invalid phone number': 'Numero de telefono invalido',
	'Insert short description': 'Introduzca una breve descripción',
	'Add new band': 'Añadir niebla de banda',
	'Create new band': 'Crear nueva banda',
	'Minimum angle': 'Ángulo mínimo',
	'Maximum angle': 'Ángulo máximo',
	Coloring: 'Colorante',
	Remove: 'Para eliminar',

	//	Breadcrumb
	'Manage users': 'Administrar usuarios',
	Preferences: 'Preferencias',
	'My informations': 'Mis informaciones',
	'My plan': 'Mi plan',

	individual: 'Individual',
	team: 'Equipo',
	business: 'Negocio',
	pilot: 'Piloto',

	yearly: 'anual',
	monthly: 'mensal',
	Yearly: 'Anual',
	Monthly: 'Mensal',

	User: 'Usuario',
	Supervisor: 'Supervisor',
	Master: 'Maestro',
	Admin: 'Administrador',

	'Choose a plan different from your current plan': 'Elija un plan diferente a su plan actual',
	'Plan successfully canceled': 'Plan cancelado con éxito',
	'We received your order, we are processing your payment': 'Hemos recibido tu pedido, estamos procesando tu pago',

	'Password changed successfully': 'Contraseña alterada con éxito',

	'Customer plan not found': 'Plan de cliente no encontrado',
	'Customer data not found': 'Datos del cliente no encontrados',
	'User access not found': 'Permiso de usuario no encontrado',
	'File deleted successfully': 'Archivo eliminado con éxito',

	'Check the parameters entered': 'Verifique los datos ingresados',
	'Number of document characters are invalid': 'El número de caracteres del documento no es válido',
	'Invalid inserted CPF': 'CPF ingresado no válido',
	'Invalid inserted CNPJ': 'CNPJ ingresado no válido',

	'It is necessary to spend a day after contracting the service to change the plan':
		'Es necesario pasar un día después de contratar el servicio para cambiar de plan',

	'Fake communication failure': 'Fallo de comunicación',

	'Remember me': 'Acordarse de mi',
	'Forgot password': '¿Olvidaste tu contraseña?',
	'Log in': 'Acceso',
	Password: 'Clave',
	'Please input your password!': '¡Por favor ingrese su contraseña!',
	'Invalid email or password': 'Correo electrónico o contraseña no válidos',
	'The input is not a valid e-mail!': 'Cuenta inactiva, actívela',
	'Please input your e-mail': 'Por favor ingrese su correo electrónico',
	'Inactive account, please activate': 'Cuenta inactiva, actívala',
	'Enter your email': 'Introduce tu correo electrónico',
	Send: 'Enviar',
	'User not found': 'Usuario no encontrado',
	'Success, check your email box': 'Éxito, revisa tu bandeja de entrada',
	'Password recovery': 'Restablecimiento de contraseña',
	'Token invalid': 'Solicitud no válida',
	'Token expired, generated a new one': 'La sesión expiró, por favor inténtalo de nuevo',
	'Please confirm your password!': 'Por favor, confirme su contraseña',
	'Confirm Password': 'Confirme su contraseña',
	'The two passwords that you entered do not match!': 'Las dos contraseñas no coinciden, compruebe',

	Confirm: 'Confirmar',
	Cancel: 'Cancelar',
	flexion: 'Flexión',
	turned: 'Volcado',
	extension: 'Extensión',
	sideways: 'Lateralmente',
	crouched: 'En cuclillas',
	downed: 'Bajado',
	arm_raised: 'Brazo levantado',
	behind: 'Atrás',
	raised: 'Levantado',
	none: 'Ninguna',

	// Check-in Customer
	'Registered successfully!': '¡Registro completado con éxito!',
	'Just a little longer, check your e-mail inbox':
		'Ahora es el momento de revisar su bandeja de entrada de correo electrónico',
	Access: 'Acceso',
	'Kinebot - Terms of use': 'Kinebot-Términos de uso',
	'terms of use': 'términos de uso',
	"Welcome! Let's start": '¡Bienvenido, empecemos!',
	'Enter your phone number': 'Introduzca su teléfono',
	'Select your contry': 'Selecciona tu pais',
	State: 'Estado',
	'State:': 'Estado:',
	'Select your state': 'Seleccione su estado',
	'Select your city': 'Seleccione su ciudad',
	'Zip code': 'CEP',
	'Enter your zipcode': 'Introduzca su código postal',
	'Enter your address': 'Ingrese su dirección',
	'Enter your street number': 'Ingrese el número de la calle',
	'Coupon (optional)': 'Cupón (opcional)',
	Coupon: 'Cupón',

	// User Activation
	'There are problems on your operation.': 'Hay algunos problemas con su operación',
	Leave: 'Salir',
	Data: 'Datos',
	'Final steps': 'Finalización',
	'Card number': 'Numero de tarjeta',
	'Enter your credit card number': 'Ingrese el número de tarjeta',
	'Invalid credit card': 'Tarjeta no valida',
	'Card holder name': 'Nombre del titular de la tarjeta',
	'Enter the card holder name': 'Nombre del titular de la tarjeta',
	'Due date': 'Fecha de vencimento',
	"Enter the card's due date": 'Ingrese la fecha de vencimiento de la tarjeta',
	'Invalid month': 'Mes inválido',
	'Invalid card date': 'Fecha de tarjeta inválida',
	'Enter the security code': 'Introduzca el código de seguridad',
	'Invalid code': 'Codigo invalido',
	'Payment information': 'Datos de pago',

	// Maintenance
	"We are going through maintenance, we'll be back shortly.": 'Estamos en mantenimiento, pronto estaremos de vuelta',

	// Finalization
	'Personal data': 'Datos personales',
	'Document no.': 'CPF',
	'Payment details': 'Detalles del pago',
	'You will only be charged after the free test period, it can be cancelled at anytime.':
		'El monto del cargo solo se realizará después del período gratuito y se puede cancelar en cualquier momento',
	'Payment method': 'Método de pago',
	'Payment options': 'Tipo de pago',
	'Full payment': 'A la vista',
	Discounts: 'Descuentos',
	'I have read and agree with the': 'He leído y estoy de acuerdo con el',
	Close: 'Cerrar',

	// User Activation - Information
	'Validating coupon': 'Cupón de validación',
	"Couldn't find the coupon": 'No se puede obtener el cupón',
	Individual: 'Individual',
	Team: 'Equipo',
	Business: 'Negocio',
	'Enter your document no.': 'Introduzca el CPF',
	'Enter a valid document': 'Introduzca un CPF válido',
	'Enter a phone number': 'Introduzca un teléfono',
	'Enter the zip code': 'Ingrese el código postal',
	'Enter the city': 'Entra en la ciudad',
	'Enter the state': 'Introduzca el estado',
	'Street number': 'Número de calle',
	'Street number:': 'Número de calle:',

	// Credit Card
	'Under review': 'Tarjeta en revisión',
	'Insufficient funds': 'Fondos insuficientes',
	'Not accepted': 'Transacción inválida',
	'Customer already registered': 'Usuario ya registrado',
	'Failed to perform transaction': 'No se pudo realizar la transacción',

	'email must be unique': 'Correo electrónico ya registrado',

	'Error loading video': 'Error al cargar el video',
	'Failed to fetch your plan information.': 'No se pudo obtener la información de su plan',
	'Failed to fetch total customer videos.': 'No se pudo obtener el total de videos del cliente',
	'Maximum uploads reached.': 'Cargas máximas alcanzadas',
	'Maximum minutes reached.': 'Minutos máximos alcanzados',
	'Corrupted video.': 'Vídeo corrupto',

	// Painel control
	'Maximum users reached': 'Máximo de usuarios registrados',

	"The 'name' field is required.": 'El campo de nombre es obligatorio',
	"The 'email' field is required.": 'El campo de correo electrónico es obligatorio',
	"The 'country' field is required.": 'El campo del país es obligatorio',
	"The 'state' field is required.": 'El campo de estado es obligatorio',
	"The 'city' field is required.": 'El campo de la ciudad es obligatorio',
	"The 'address' field is required.": 'El campo de dirección es obligatorio',
	"The 'street_number' field is required.": 'El campo de número es obligatorio',
	"The 'zipcode' field is required.": 'El campo del código postal es obligatorio',

	// ********************************** //
	'Personal information': 'Informaciones personales',
	Localization: 'Ubicación',

	'Full name': 'Nombre completo',
	'Full name:': 'Nombre completo:',
	'Enter your full name': 'Ingrese su nombre completo',
	'Enter your name': 'Ingrese su nombre',
	'Insert a document': 'Insertar un documento',
	'Insert a valid document': 'Insertar un documento válido',
	Address: 'Dirección',
	'Address:': 'Dirección:',
	'Enter an address': 'Introduce una direccion',
	Number: 'Número',
	'Enter the number': 'Ingrese un numero',
	Zipcode: 'Código postal',
	'Zipcode:': 'Código postal:',
	'Enter zip code': 'Introduzca el código postal',
	Country: 'País',
	'Country:': 'País:',
	'Select your country': 'Selecciona tu pais',
	'Select state': 'Seleccione el estado',
	City: 'Ciudad',
	'City:': 'Ciudad:',
	'Select city': 'Seleccione la ciudad',

	'Update performed': 'Operación realizada',
	'Customer information updated successfully': 'Información actualizada con éxito',
	'Fill in your personal information': 'Complete su información personal',

	// Forgot password
	'Forgot your password?': '¿Olvidaste tu contraseña?',
	'We will send you an email to retrieve your password, rest assured :)':
		'Te enviaremos un email para recuperar tu contraseña, no te preocupes :)',
	'Back to login': 'Atrás para iniciar sesión',
	'Please enter a valid e-mail address': 'Introduzca un correo electrónico válido',
	'Enter an e-mail': 'Introduzca un correo electrónico',

	'Oops... Something went wrong!': 'Ops.. Algo salió mal',
	'Operation performed successfully': 'Operación realizada con éxito',
	'Check your email inbox': 'Revisa tu bandeja de entrada de correo electrónico',
	'Create new password': 'Crear una nueva contraseña',
	'Your new password must be different from previous used passwords':
		'Su nueva contraseña debe ser diferente de las contraseñas que utilizó anteriormente',
	'Enter your new password': 'Introduzca su nueva contraseña',
	'Confirm new password': 'Confirme la nueva contraseña',
	'The two passwords that you entered do not match': 'Las dos contraseñas que ingresaste no coinciden',
	Save: 'Guardar',
	'Click here to continue': 'Clic aquí para continuar',
	'Invalid Token': 'Simbolo no valido',
	'Expired token': 'Contador caducado',

	trunk: 'Tronco',
	neck: 'Cuello',
	left_lower_arm: 'Codo izquierdo',
	right_lower_arm: 'Codo derecho',
	left_upper_arm: 'Hombro izquierdo',
	right_upper_arm: 'Hombro derecho',
	left_knee: 'Rodilla izquierda',
	right_knee: 'Rodilla derecha',
	left_ankle: 'Tobillo izquierdo',
	right_ankle: 'Tobillo derecho',
	hip: 'Cadera',
	left_hand: 'Puño izquierdo',
	right_hand: 'Puño derecho',

	Knee: 'Rodilla',
	Ankle: 'Tobillo',
	Hip: 'Cadera',
	Hand: 'Muñecas',
	Qualification: 'Calificación',
	'Select the body parts to display': 'Seleccione las partes del cuerpo que se mostrarán',

	safe: 'Aceptable',
	info: 'Ligero',
	warning: 'Alto',
	danger: 'Extremo',

	'Light risk': 'Riesgo ligero',
	'Average risk': 'Riesgo medio',

	Level: 'Nivel',
	'Limit of bands reached': 'Límites de rango de banda alcanzados',

	'Industrial site': 'Centro de trabajo',
	Period: 'Período',
	Search: 'Buscar',
	Clear: 'Borrar',

	'Select company': 'Seleccione empresa',

	//User management
	'Create new user': 'Crear nuevo usuario',
	Email: 'Correo electrónico',
	Permissions: 'Permisos',
	'Companies - Industrial sites': 'Empresas - Centro de trabajo',

	'Change password': 'Cambiar contraseña',
	'Current password': 'Contraseña actual',
	'New password': 'Nueva contraseña',
	'Confirm password': 'Confirmar contraseña',
	'Enter your current password': 'Introduce tu contraseña actual',
	'Enter a new password': 'Introduzca una nueva contraseña',
	'Password must be at least 6 characters long': 'La contraseña debe tener al menos 6 caracteres',
	'Repeat your new password': 'Repita su nueva contraseña',
	"The two passwords don't match, check": 'Las dos contraseñas no coinciden, verifique',
	'Sorry time exceeded, try again.': 'Lo sentimos, se excedió el tiempo, inténtelo de nuevo',
	'Invalid current password': 'Contraseña actual inválida',
	'Update information': 'Actualice la información',

	'Phone number': 'Teléfono',
	'Account type': 'Tipo de cuenta',
	'Created in': 'Creado en',
	'Postal code': 'Código postal',
	'Sorry, something went wrong :(': 'Perdón, algo salió mal :(',
	Retry: 'Intentar nuevamente',

	//
	// Layout - Sidebar
	Settings: 'Ajustes',
	'My account': 'Mi cuenta',
	Plan: 'Plan',
	'Subscription type': 'Tipo de suscripción',
	'Subscription type:': 'Tipo de suscripción:',
	Recurrence: 'Reaparición',
	'Recurrence:': 'Reaparición:',
	'Expiration date': 'Fecha de expiración',
	'Plan expiration date:': 'Fecha de vencimiento del plan:',
	'Active users': 'Usuarios activos',
	'Processed videos': 'Vídeos procesados',
	'Processed videos:': 'Vídeos processados:',
	'Processing time': 'Tiempo de procesamiento',
	'Processing time:': 'Tiempo de procesamiento:',
	'Additional minutes': 'Minutos adicionales',
	'Add credits': 'Agregar créditos',
	'Renew subscription': 'Renovar la suscripción',
	'Change subscription': 'Cambiar firma',
	'Cancel subscription': 'Cancelar suscripción',
	of: 'en',
	minutes: 'minutos',

	Test: 'Prueba',
	Minutes: 'Minutos',
	Purchase: 'Compra',
	Payments: 'Pagos',
	Payment: 'Pago',
	'Buy additional credits': 'Comprar créditos adicionales',
	'Enter the amount of additional credits (minutes) below to continue using the platform':
		'Ingrese la cantidad de créditos adicionales (minutos) a continuación para continuar usando la plataforma',
	'Consolidate data': 'Consolidar datos',
	'Export report': 'Reporte de exportacion',
	'There is no post with screwdriver / screwdriver': 'No hay poste con destornillador/destornillador',
	'Data not found': 'Datos no encontrados',
	'Requires actions': 'Requiere acciones',
	'No actions required': 'No requiere acciones',
	'High Risk and Requires Action': 'Alto riesgo y requiere acciones',
	'Moderate risk and no action required': 'Riesgo moderado y no requiere acción',
	'Low Risk and No Action Required': 'Bajo riesgo y no requiere acción',
	'Intensity of work': 'Intensidad del trabajo',
	'Work organization': 'Organización del trabajo',
	'Is spontaneous breaks allowed during the workday?':
		'¿Están permitidos los descansos espontáneos durante la jornada laboral?',
	'Is there a diversification of tasks in the performance of your functions?':
		'¿Existe diversificación de tareas en el desempeño de sus funciones?',
	'Materials are always available at the workstation, avoiding rush, delay or overload?':
		'¿Los materiales están siempre disponibles en el puesto de trabajo, evitando prisas, retrasos o sobrecargas?',
	Complexity: 'Complejidad',
	'Movements do not require high dexterity': 'Los movimientos no requieren altas habilidades',
	'Low level of attention requirement for long periods':
		'Bajo nivel de exigencia de atención durante largos períodos',
	'Workstation is complex and high cognitive demand': 'El rango es complejo y cognitivamente exigente',
	'Workstation is simple and of low cognitive requirement': 'Rank es simple y de baja demanda cognitiva',
	'Displacement ': 'Desplazamiento ',
	'Squat ': 'Ponerse en cuclillas ',
	Cervical: 'Cervical',
	//
	'Left Shoulder/Arm': 'Hombro/brazo izquierdo',
	'Right Shoulder/Arm': 'Hombro/brazo derecho',
	'Left wrist': 'Puño izquierdo',
	'Right wrist': 'Puño derecho',
	'No repeatability': 'Sin repetibilidad',
	'With repetition': 'Con repetibilidad',
	' x per hour': ' x por hora',
	'Without risk': 'Sin riesgo',
	'Action Level': 'Nivel de acción',
	'Complementary resources': 'Factores complementarios',
	'Percussion tools ': 'Herramientas de percusión',
	'Hit against ': 'Golpes en contra',
	'Present Risk': 'Riesgo presente',
	'Low risk': 'Riesgo bajo',
	'Global Ranking': 'Clasificación mundial',
	'Operator report': 'Reportes del operador',
	'Enter operator report below': 'Ingrese el informe del operador a continuación',
	'Easy to understand information': 'Información fácil de entender',

	'≤ 10 steps per minute': '≤ 10 pasos por minuto',
	'15 to 25 steps per minute': 'De 15 a 25 pasos por minuto',
	'Above 25 steps per minute': 'Por encima de 25 pasos por minuto',

	'Inform below the displacement of the operator during the workday':
		'Informar a continuación el desplazamiento del operador durante la jornada laboral',
	'Regulation notes': 'Notas reglamentarias',
	'Spontaneous breaks are allowed during the workday (e.g. drinking water, drinking coffee, going to the bathroom)':
		'Se permiten descansos espontáneos durante la jornada laboral (por ejemplo, beber agua, beber café, ir al baño)',
	'In the performance of their functions, there is diversification of tasks':
		'En el desempeño de sus funciones, existe diversificación de tareas',
	'Materials are always available at the workstation, avoiding rush, delay or overload':
		'Los materiales están siempre disponibles en el puesto de trabajo, evitando prisas, demoras o sobrecargas',
	'Work intensity: give a score from 1 to 7 (1 being a little work and 7 being very intense work)':
		'Intensidad del trabajo: puntúe del 1 al 7 (siendo 1 un poco de trabajo y 7 un trabajo muy intenso)',

	Wrist: 'Muñecas',
	'Hit against': 'Golpes',
	'Enter job information below': 'Ingrese la información del trabajo a continuación',
	'During the operation, the operator taps his hands to adjust parts or components.':
		'Durante la operación, el operador da golpes con las manos para ajustar piezas o componentes',

	'Add a companion video for wrist analysis': 'Agregue un video complementario para el análisis de la muñeca',
	'Do not include in the analysis': 'No incluir en el análisis',
	'Include external video': 'Incluir video externo',
	'Enter video name': 'Introduce el nombre del vídeo',

	'Sledgehammer and/or taps are hits from hard hits (except hit adjustments)':
		'El mazo y/o los mazos son golpes de golpes duros (excepto ajustes de golpe)',
	'Light - Quiet': 'Ligero - Silencioso',
	'Medium - Some effort is perceived (defined)': 'Medio - Se percibe algún esfuerzo (definido)',
	'Heavy - Clear effort: no change in facial expression':
		'Pesado - Esfuerzo claro: sin cambios en la expresión facial',
	'Very heavy - Sharp effort: changes facial expression': 'Muy pesado Esfuerzo claro: cambia la expresión facial',
	'Next. maximum - Use of torso and limbs to generate greater force':
		'Próximo. máximo - Uso del tronco y las extremidades para generar mayor fuerza',

	// ------- //
	'Workstation Information': 'Informacion del trabajo',

	'Enter operator difficulty control below': 'Ingrese el control de dificultad del operador a continuación',
	'Control Difficulty': 'Dificultad de control',
	'Select a cost center': 'Seleccione el centro de costo',

	'Enter data about vibration in employee activity below':
		'Ingrese a continuación los datos sobre la vibración en la actividad del empleado, si no los tiene, no es necesario llenarlos',

	"Enter below the data on the employee's reaction in the activity":
		'Ingrese a continuación los datos sobre la reacción del empleado a la actividad',
	'Insert a new reaction': 'Introduzca una nueva reacción',
	'Insert a new vibration': 'Entra en una nueva vibración',

	"Enter below the data of the employee's effort in the activity":
		'Ingrese a continuación los datos sobre el esfuerzo del empleado en la actividad',

	'Insert a new effort': 'Introduzca un nuevo esfuerzo',
	'Cost center': 'Introduzca el trabajo',
	'Enter a workstation': 'Introduzca el trabajo',

	'Enter the data related to the selected video below':
		'Ingrese los datos relacionados con el video seleccionado a continuación',

	Staff: 'Staff de colaboradores',
	'Enter the Company Activities': 'Entra en el Codigo Fiscal',
	'Insert a production line': 'Ingrese a la línea de producción',
	'Add new range': 'Agregar nueva banda',
	'industrial site': 'centro de trabajo',
	'Select a industrial site': 'Seleccione el centro de trabajo',
	'Select an industrial site': 'Seleccione el centro de trabajo',
	'Production line': 'Línea de producción',
	'Select a production line': 'Seleccione la línea de producción',

	Role: 'Puesto de trabajo',
	Code: 'Código',

	//
	'Tax Code': 'RUT',
	'Enter a Tax Number': 'Ingresa el RUT',
	'Insert a valid Tax Number': 'Introduzca un RUT válido',

	'Select a role': 'Seleccione un tipo',
	'User type': 'Tipo de usuario',
	'User type:': 'Tipo de usuario:',
	Document: 'Documento',
	'Document:': 'Documento:',
	'Current plan': 'Plan actual',
	'Not informed': 'No informado',

	'Risk ranges': 'Bandas de riesgo',
	'Local application': 'Sitio de aplicación',
	'Units to be analyzed': 'Unidades a analizar',
	'Select the units that will be included in the review': 'Seleccione las unidades que se incluirán en la revisión',
	Factory: 'Fábrica',
	'Select the industrial sites to be analyzed': 'Seleccionar las plantas industriales a analizar',
	'Production Volume': 'Volumen de producción',
	Investments: 'Inversiones',
	'Enter production volumes below': 'Ingrese los volúmenes de producción a continuación',
	'Inform below the investments in ergonomics': 'Informar a continuación las inversiones en ergonomía',

	Date: 'Fecha',
	'Date of reference': 'Fecha de referencia',
	'Date of the report': 'Fecha del informe',

	'Ergonomic analysis of work': 'Análisis ergonómico del trabajo',
	Presentation: 'Presentación',
	'Plant Information': 'Información de la planta',
	'Insert a company name': 'Introduzca el nombre de la empresa',
	'Risk degree': 'Grado de riesgo',
	Activity: 'Actividad',
	District: 'Barrio',
	Administrative: 'Administrativo',
	'Work Shift': 'Turno de trabajo',
	Operational: 'Operacional',
	'Direct hourly worker': 'Directo por hora',
	'Indirect hourly worker': 'Indirecto por hora',
	'Monthly worker': 'Pagador mensual',
	'Normal working hours': 'Horas normales de trabajo',

	// AET
	'Include checklists related to this analysis below':
		'Incluya listas de verificación relacionadas con este análisis a continuación',
	'Non-standard scale': 'Escala no estándar',

	// Bodyparts
	'Lower members': 'Miembros inferiores',
	'Left elbow': 'Codo izquierdo',
	'Right elbow': 'Codo derecho',
	'Left shoulder': 'Hombro izquierdo',
	'Right shoulder': 'Hombro derecho',
	'Left knee': 'Rodilla izquierda',
	'Right knee': 'Rodilla derecha',
	'Left ankle': 'Tobillo izquierdo',
	'Right ankle': 'Tobillo derecho',

	/* Nomenclature v2 */
	'Left hand': 'Mano izquierda',
	'Right hand': 'Mano derecha',
	'Video description': 'Descripción del video',
	Below: 'Abajo de',
	Above: 'Encima de',

	Checklist: 'Lista de verificación',
	'Frequency and duration': 'Frecuencia y duración',

	'Date of collection': 'Fecha de colección',

	'Load from 2 kg ≤ 10 kg (intermittent)': 'Carga de 2 kg a 10 kg (intermitente)',
	'Load from 2 kg ≤ 10 kg (static or repetitive)': 'Carga de 2 kg a 10 kg (estática o repetitiva)',
	'Load more than 10 kg of repetitive load or blows': 'Carga superior 10 kg de carga repetitiva o golpes',

	Medium: 'Medio',
	Invalid: 'Inválido',

	Safe: 'Aceptable',
	Info: 'Ligero',
	Attention: 'Atención',
	Danger: 'Extremo',
	'Activity score': 'Puntuación de la actividad',
	'Exposure score per joint': 'Puntuación de exposición por articulación',
	'Angle in time': 'Ángulo en el tiempo',
	'REBA time score': 'Puntuación temporal REBA',
	'Score left': 'Puntuación izquierda',
	'Score right': 'Puntuación derecha',
	'Angle by time': 'Ángulo en el tiempo',
	Score: 'Puntuación',
	'L. Knee': 'Rodilla I.',
	'R. Knee': 'Rodilla D.',
	'L. Elbow': 'Codo I.',
	'R. Elbow': 'Codo D.',
	'L. Shoulder': 'Hombro I.',
	'R. Shoulder': 'Hombro D.',
	'Left Knee': 'Rodilla I.',
	'Right Knee': 'Rodilla D.',
	'Left Elbow': 'Codo I.',
	'Right Elbow': 'Codo D.',
	'Left Shoulder': 'Hombro I.',
	'Right Shoulder': 'Hombro D.',

	'Corrective action not required': 'No se requiere acción correctiva',
	'Corrective action as soon as possible': 'Acción correctiva tan pronto como sea posible',
	'High priority corrective action': 'Acción correctiva de alta prioridad',
	'Immediate corrective action': 'Acción correctiva inmediata',
	'Unable to show results': 'No se pueden mostrar los resultados',

	/* Nomenclature */
	Line: 'Línea',
	Effort: 'Esfuerzo',
	Reaction: 'Reacción',
	Vibration: 'Vibración',
	'Beats against': 'Golpes en contra',
	Percussion: 'Percusión',
	Hands: 'Manos',
	'Shoulders/Arms': 'Hombros/brazos',
	Left: 'Izquierda',
	Right: 'Derecha',
	Exit: 'Salir',
	Filters: 'Filtros',

	/* Login - Page */
	// Placeholder's
	'E-mail': 'Correo electrónico',
	'E-mail:': 'Correo electrónico:',

	// Validation's errors inputs
	'Enter a valid e-mail': 'Introduzca un correo electrónico válido',
	'Enter your password': 'Ingresa tu contraseña',
	Login: 'Acceso',

	// SideMenu
	Dashboard: 'Tablero',
	Upload: 'Subir',

	// Dashboard
	'Comparison over the last 6 months': 'Comparación en los últimos 6 meses',
	/*************/

	'Are you sure?': '¿Está seguro?',
	'You are being redirected': 'Usted está siendo redirigido',
	'Are you sure you want to quit? You have an upload in process.':
		'¿Seguro que quieres salir? Tienes una carga en proceso',

	// Upload filter
	'Select a company': 'Seleccione una empresa',
	'Select a line': 'Seleccione la línea',
	'Select the workstation': 'Seleccione el puesto de trabajo',
	'Select a workstation': 'Seleccione el puesto de trabajo',

	// Chart
	'No data available': 'No hay datos',
	'There is no registered data.': 'No hay datos registrados',

	// Layout
	Logout: 'Salir',

	// Report
	'Add item': 'Añadir artículo',
	"Approximated values, depends mainly on the filming methods. In case there is no data, the algorithm didn't find the points to determine the angle, please review the filming method used.":
		'Valores aproximados, en función de la técnica de filmación adoptada. Si no tiene datos, el algoritmo no ha identificado los puntos para determinar el ángulo, observe las técnicas de filmación',
	'The results obtained from each body part can be affected by the method and position of filming, the identification of the person in the analysis can suffer interference from objects present in the room. The angle data shown are approximate values.':
		'Los resultados obtenidos de cada parte del cuerpo pueden verse afectados por el método y la posición de filmación, la identificación de la persona en el análisis puede sufrir interferencias de los objetos presentes. Los datos de ángulo que se muestran son valores aproximados.',
	Reference: 'Referencia',
	'Investigate and change immediately': 'Investigue y cambie inmediatamente',
	'Analysis of the movement by angle': 'Análisis de movimiento por ángulo',
	'Analysis of the movement by score': 'Análisis de movimiento con puntuación',
	'Analysis of the movement & Body parts': 'Análisis de movimiento y partes del cuerpo',
	'Report types': 'Tipos de Reportes',
	'Generate reports': 'Generar Reportes',
	Finish: 'Finalizar',
	'Description already exists!': '¡La descripción ya existe!',
	'Enter a new sector': 'Entrar en un nuevo sector',
	'Do you wish to delete this sector?': '¿Quieres eliminar este sector?',
	'This sector is used in other reports, do you really wish to delete it?':
		'Este sector se está utilizando en otros Reportes, ¿está seguro de que desea eliminarlo?',
	'Sector created successfully!': '¡Sector creado con éxito!',
	'Line created successfully!': 'Línea creada con éxito!',
	'Workstation created successfully!': 'Puesto de trabajo creado con éxito!',
	"This operation couldn't be completed": 'Esta acción no se pudo realizar',
	Sectors: 'Sectores',
	'Fill in the essential information below.': 'Complete la información esencial a continuación',
	'Select the sector from the above analysis': 'Seleccione el sector del análisis anterior',
	'Select the sector for the analysis': 'Seleccione el sector de análisis',
	Add: 'Agregar',
	'Enter the workstation': 'Introduzca el trabajo',
	'Enter the date the collection was made': 'Ingrese la fecha en que se realizó el cobro',
	'Select the tool for the analysis and the type of report you wish to generate.':
		'Seleccione la herramienta que desea aplicar para el análisis y el tipo de informe que desea generar',
	Tool: 'Herramienta',
	'Pick the tool above': 'Seleccione la herramienta de arriba',
	'Select the type of tool': 'Seleccione el tipo de herramienta',
	Report: 'Reporte',
	'Select the type of report above': 'Seleccione el tipo de reporte anterior',
	'Select the type of report': 'Seleccione el tipo de reporte',

	// BriefBest
	'Shoulder movement': 'Movimientos de hombros',
	'Flexion greater than 20° degrees': 'Flexión superior a 20º grados',
	'Executed with support': 'Ejecución asistida',
	Rotation: 'Rotación',
	'Force greater or equal to 11.3kg': 'Fuerza mayor o igual a 11.3kg',
	'Forearm movement': 'Movimientos del antebrazo',
	'Greater or equal to 40°': 'Mayor o igual a 40º',
	'Full extension': 'Extensión completa',
	'Force greater or equal to 4.5kg': 'Fuerza mayor o igual a 4.5kg',
	'Movement of hands and wrist': 'Movimientos de manos y muñecas',
	'Ulnar deviation': 'Desviación cubital',
	'Radial deviation': 'Desviación radial',
	'[Force]: Pinch or pressure with the fingers greater or equal to 0.9kg, or palm pressure greater or equal to 4.5kg.':
		'[Fuerza] Pellizco o presión con los dedos mayor o igual a 0,9 kg, o presión con la palma mayor o igual a 4,5 kg',
	'[Duration]: Greater or equal to 10 seconds.': '[Duración]: Mayor o igual a 10 segundos',
	'[Frequency]: Greater or equal to 30 minutes.': '[Frecuencia]: Mayor o igual a 30 minutos',
	'Leg movement': 'Movimientos de piernas',
	Squatting: 'En cuclillas',
	'With support': 'Con soporte',
	'Foot pedal greater or equal to 4.5kg': 'Pedal mayor o igual a 4,5 kg',
	'Neck movement': 'Movimientos del cuello',
	'Flexion greater than 30°': 'Flexión superior a 30° grados',
	'Side movement': 'Movimiento lateral',
	Extended: 'Extendido',
	'Rotation greater than 20°': 'Rotación superior a 20° grados',
	'Force greater or equal to 0.9kg': 'Fuerza mayor o igual a 0,9 kg',
	'Arm behind the body': 'Brazo detrás del cuerpo',
	'Shoulders tucked in': 'Hombros encogidos',
	Elbows: 'Codos',
	Ombros: 'Espalda',
	'Back ': 'Atrás', // Coloquei um espaço depois de "Back" para diferenciar de "Voltar"
	"Data couldn't be loaded.": 'No puede cargar',
	'Body parts - Critical:': 'Parte del cuerpo - opiniones:',
	Indicators: 'Indicadores',
	'Glove usage': 'Uso de guantes',
	'Impact exposure': 'Exposición e impacto',
	'Vibration exposure': 'Exposición a vibraciones',
	'Low temperature exposure': 'Exposición a bajas temperaturas',
	'Mechanical compression of muscular tissue': 'Compresión mecánica del tejido muscular',
	'More than 40 hours': 'Más de 40 horas',
	'20 - 40 hours': '20 - 40 horas',
	'4 - 19 hours': '4 - 19 horas',
	'Less than 4 hours': 'Menor que 4 horas',
	Video: 'Video',
	'Coming soon': 'Próximamente',
	'Exposure time': 'Tiempo de exposición',
	'Tool used': 'Herramienta utilizada',
	'Physical stress factors': 'Factores de estrés físico ',
	"Data couldn't be loaded": 'No se pudieron obtener los datos',
	'Very high': 'Muy alto',
	'Final score:': 'Puntuación final:',
	'(Task risk x Exposure time factor)': '(Riesgo de la tarea x factor de tiempo de exposición)',
	'Priority:': 'Prioridad:',
	'Subtitle:': 'Subtítulos:',
	Graphs: 'Gráficos',
	'Not identified': 'No identificado',
	Comments: 'Comentarios',
	'Comments:': 'Comentarios:',
	'Enter the analysis conclusion': 'Ingrese la conclusión del análisis aquí',
	'Complementary factors': 'Factores complementarios',
	'Physical stress': 'Estrés físico:',
	'Inadequate use of gloves': 'Uso inadecuado de guantes',
	'Weekly exposure time:': 'Tiempo de exposición semanal:',
	'Physical factors': 'Factores físicos',
	Filter: 'Filtrar',
	Company: 'Empresa',
	'Select the company': 'Seleccione la empresa',
	'Select the industrial site': 'Seleccione el centro de trabajo',
	Function: 'Ocupación',
	'Enter the function': 'Introduzca la función',
	'Customized reports': 'Reportes personalizados',

	// Settings
	"We weren't able to change your password": 'No se puede cambiar su contraseña',
	'Warning!': '¡Aviso!',
	'Failed to fetch requested information': 'No se pudo obtener la información solicitada',
	'Do you really wish to cancel your plan?': '¿De verdad quieres cancelar tu plan?',
	'After cancelling your plan, when the expiration date comes, you will have no more access to the platform.':
		'Al cancelar tu plan, después de la fecha de vencimiento actual no tendrás acceso a la plataforma',
	"We weren't able to cancel your plan": 'No se puede cancelar el plan',
	"Select a plan that's different from your current one": 'Seleccione un plan diferente a su plan actual',
	"We couldn't process the operation": 'No se puede realizar la operación',
	'Plan cancelled on:': 'Plan cancelado en:',
	'Active users:': 'Usuarios activos:',
	'Plan switch': 'Cambio de planes',
	'You have recently changed your plan': 'Recientemente cambió su suscripción',
	'Plan type:': 'Tipo de suscripción:',
	'New plan start date:': 'Fecha de inicio del nuevo plan:',
	'User limit:': 'Límite de usuarios:',
	'Upload limit:': 'Límite de carga:',
	'Processing time limit:': 'Límite de minutos de procesamiento:',
	'Cancel plan': 'Cancelar plan',
	'Error when trying to verify industrial sites from company.':
		'Error al verificar plantas industriales dentro de la empresa',
	'Error when trying to delete the company': 'Error al eliminar empresa',
	'Enter a permission': 'Introduzca un permiso',
	'Select a permission': 'Seleccione un permiso',
	'Edit user': 'Editar usuario',
	'User changed successfully': 'Usuario cambiado con éxito',
	Permission: 'Permiso',
	'Do you wish to delete this user?': '¿Quieres eliminar este usuario?',
	Active: 'Activo',
	Inactive: 'Inactivo',
	All: 'Todos',
	Disabled: 'Desactivado',

	// Manage companies
	'Manage companies': 'Administrar empresas',
	'Manage industrial sites': 'Administrar plantas industriales',
	'Heads up! This company is not empty': '¡Aviso! Esta empresa no está vacía',
	'To continue, first remove industrial sites belonging to this company.':
		'Para continuar, eliminar las plantas industriales pertenecientes a esta empresa',
	'All companies in this organization will be deleted, along with their respective uploads and reports. Do you wish to proceed?':
		'Se eliminarán todas las empresas, junto con sus videos e Reportes. ¿Estas seguro que deseas continuar?',
	'All industrial sites in this company will be deleted, along with their respective uploads and reports. Do you wish to proceed?':
		'Se eliminarán todas las plantas industriales de esta empresa, junto con sus cargas e Reportes. ¿Estas seguro que deseas continuar?',
	'All uploads and reports from this industrial site will be deleted. This action cannot be undone. Do you wish to continue?':
		'Se eliminarán todas las cargas e Reportes de este centro de trabajo. Esta acción no se puede deshacer. ¿Estas seguro que deseas continuar?',
	'Failed to update information': 'No se pudo actualizar la información',
	'Edit company': 'Editar empresa',
	Loading: 'Cargando',
	'Company name': 'Nombre de la empresa',
	'Industrial sites': 'Centros de trabajo',
	'Total Industrial Sites': 'Total de centros de trabajo',
	'Manage industrial site': 'Administrar centro de trabajo',
	'Update company name': 'Actualizar nombre de la empresa',
	'Delete company': 'Eliminar empresa',
	'Organization created successfully': 'Empresa creado con éxito.',
	'Organization deleted successfully': 'Empresa eliminada con éxito.',
	'Updated information': 'Información actualizada',
	'Error while changing the name of the industrial site': 'Error al editar el nombre del centro de trabajo',

	// ui/Reports
	'1 - Acceptable posture if not repeated or kept for long periods':
		'1 - Postura aceptable si no se repite o mantiene durante largos periodos',
	'2 - Investigate; possibility to request for change; it is convenient to introduce alterations':
		'2 - Investigar posibilidad de solicitar cambios es conveniente introducir cambios',
	'3 - Investigate; make changes quickly': '3 - Investigar hacer cambios rápidamente',
	'4 - Immediate change': '4 - Cambios inmediatos',
	'Acceptable posture if not repeated or kept for long periods':
		'Postura aceptable si no se repite o se mantiene durante períodos prolongados',
	'Investigate; possibility to request for change; it is convenient to introduce alterations':
		'Investigar posibilidad de solicitar cambios es conveniente introducir cambios',
	'Investigate; make changes quickly': 'Investigar hacer cambios rápidamente',
	'Immediate change': 'Cambios inmediatos',
	Ergonomist: 'Ergonomista',
	'Left lower arm': 'Antebrazo izquierdo',
	'Right lower arm': 'Antebrazo derecho',
	'Left upper arm': 'Brazo izquierdo',
	'Right upper arm': 'Brazo derecho',
	Type: 'Escribe',

	// views/Report/Niosh
	'Enter the job characteristics below.': 'Ingrese las características del trabajo.',
	'Gender of the worker': 'Género del trabajador',
	'Select the gender': 'Seleccione el género',
	'Select the age': 'Seleccione la edad',
	Age: 'Años',
	'How many workers are lifting the object?': '¿Cuántos trabajadores están levantando el objeto?',
	'Which hands are used?': '¿Qué manos se utilizan?',
	One: 'Uno',
	Two: 'Dos',
	Three: 'Tres',
	'One hand': 'Una mano',
	'Both hands': 'Ambas manos',
	'Manual Lifting Report': 'Informe - Levantamiento Manual',
	Conclusions: 'Conclusiones',
	'The weight to be lifted': 'El peso a levantar',
	'is greater than the recommended weight limit (RWL)': 'es mayor que el límite de masa recomendado (RML)',
	'is less than the recommended weight limit (RWL)': 'es inferior que el límite de masa recomendado (RML)',
	' The lifting index (LI)': ' El índice de levantamiento (IL)',
	'is more than 3.': 'es más de 3.',
	'is more than 2 and less than 3.': 'esta entre 2 y 3.',
	'is more than 1,5 and less than 2.': 'esta entre 1,5 y 2.',
	'is more than 1 and less than 1,5.': 'esta entre 1 y 1,5.',
	'is less than 1.': 'es menor que 1.',
	'is equal to or more than 3.': 'es igual o mayor que 3.',
	'is equal to or more than 2 and less than 3.': 'es igual o mayor que 2 y menor que 3.',
	'is equal to or more than 1 and less than 2.': 'es igual o mayor que 1 y menor que 2.',
	'is greater than or equal to the recommended weight limit (RWL)':
		'es mayor o igual que el límite de masa recomendado (RML)',
	' There is a very high risk. These values indicate that this lift would be hazardous for a majority of healthy industrial workers.':
		' Hay un riesgo muy alto. Estos valores indican que este levantamiento sería peligroso para la mayoría de los trabajadores industriales sanos.',
	' There is a high risk. These values indicate that this lift would be hazardous for a majority of healthy industrial workers.':
		' Hay un alto riesgo. Estos valores indican que este levantamiento sería peligroso para la mayoría de los trabajadores industriales sanos.',
	' There is a moderate risk. These values indicate that this job is somewhat stressful.':
		' Hay un riesgo moderado. Estos valores indican que este trabajo es ligeramente estresante.',
	' There is a low risk. These values indicate that this job is adequate for the majority of industrial workers, but some may have trouble.':
		' Hay un riesgo bajo. Estos valores indican que este trabajo es adecuado para la mayoría de los trabajadores industriales, pero algunos pueden tener problemas.',
	' There is a low risk. These values indicate that this job is adequate for the majority of industrial workers.':
		' Hay un riesgo bajo. Estos valores indican que este trabajo es adecuado para la mayoría de los trabajadores industriales.',
	' There is a very low risk. These values indicate that this job is adequate for the majority of industrial workers.':
		' Hay un riesgo muy bajo. Estos valores indican que este trabajo es adecuado para la mayoría de los trabajadores industriales.',
	'These values indicate that this lift would be hazardous for a majority of healthy industrial workers.':
		'Estos valores indican que este levantamiento sería peligroso para la mayoría de los trabajadores industriales sanos.',
	'These values indicate that this job is somewhat stressful.':
		'Estos valores indican que este trabajo es ligeramente estresante.',
	'These values indicate that this job is adequate for the majority of industrial workers, but some may have trouble.':
		'Estos valores indican que este trabajo es adecuado para la mayoría de los trabajadores industriales, pero algunos pueden tener problemas.',
	'These values indicate that this job is adequate for the majority of industrial workers.':
		'Estos valores indican que este trabajo es adecuado para la mayoría de los trabajadores industriales.',
	Gender: 'Género',
	Man: 'Hombre',
	Woman: 'Mujer',
	Measures: 'Medidas',
	'20 to 45 years old': '20 a 45 años',
	'< 20 years old': '< 20 años',
	'> 45 years old': '> 45 años',
	'Download PDF': 'Descargar PDF',
	'The most critical variables are listed below with suggestions:':
		'Las variables más críticas se enumeran a continuación con sugerencias:',
	'Bring the load closer to the worker by removing any horizontal barriers or reducing the size of the object. Lifts near the floor should be avoided.':
		'Acerque la carga al trabajador eliminando cualquier barrera horizontal o reduciendo el tamaño del objeto. Deben evitarse levantamientos cerca del suelo.',
	'Raise/lower the origin/destination of the lift. Avoid lifting near the floor or above the shoulders.':
		'Eleve el origen o baje el objetivo de elevación. Evite levantamientos cerca del piso o por encima de los hombros.',
	'Reduce the vertical distance between the origin and the destination of the lift.':
		'Reducir la distancia vertical entre el origen y el destino del levatamiento.',
	'Move the origin and destination closer together to reduce the angle of twist, or move them further apart to force the worker to turn the feet and step, rather than twist the body.':
		'Acerque el origen y el destino para reducir el ángulo de giro, o sepárelos más para obligar al trabajador a girar los pies y dar un paso, en lugar de torcer el cuerpo.',
	'Reduce the lifting frequency rate, reduce the lifting duration, or provide longer recovery periods (i.e., light work period).':
		'Reduzca la tasa de frecuencia de levantamiento, reduzca la duración del levantamiento o proporcione períodos de recuperación más prolongados (período de trabajo liviano).',
	'Improve the hand-to-object coupling by providing optimal containers with handles or handhold cutouts, or improve the handholds for irregular objects.':
		'Mejore el acoplamiento mano-objeto proporcionando recipientes óptimos con asas o recortes para asideros, o mejore los asideros para objetos irregulares.',
	'Consider using both hands when lifting the weight.': 'Considere usar ambas manos al levantar el peso.',
	'One handed': 'Con una sola mano',
	'Distance H': 'Distancia H',
	'Distance Vc': 'Distancia Vc',
	'Distance Dc': 'Distancia Dc',
	'Angle A': 'Ángulo A',
	'Frequency/Duration': 'Frecuencia/Duración',
	Coupling: 'Agarre',
	Frequency: 'Frecuencia',
	Conclusion: 'Conclusión',
	'Coupling factor': 'Calidad de agarre',
	'Frequency factor': 'Factor de frecuencia',
	Poor: 'Malo',
	Fair: 'Regular',
	Good: 'Bueno',
	'1 hour': '1 hora',
	'1 - 2 hours': '1 a 2 horas',
	'2 - 8 hours': '2 a 8 horas',
	'Weight of the object': 'Peso del objeto',
	'Distance the object is moved vertically': 'Distancia a la que se mueve el objeto verticalmente',
	'Vertical distance of the object at the beginning of handling, relative to the ground':
		'Distancia vertical del objeto al inicio de la manipulación, con respecto al suelo',
	'Horizontal distance of the object relative to the body': 'Distancia horizontal del objeto con respecto al cuerpo.',
	'Rotation angle': 'Ángulo de rotación',
	'Recommended Weight Limit (RWL)': 'Límite de masa recomendado (LPR)',
	'Lifting Index (LI)': 'Índice de levantamiento (IL)',
	'lifts / min': 'levant. / min',
	'Report date': 'Fecha del informe',
	'Enter the required values': 'Ingrese los valores requeridos',
	'Comment:': 'Comentario:',
	Details: 'Detalles',
	Risk: 'Riesgo',
	'Very low risk': 'Riesgo muy bajo',
	Measurements: 'Mediciones',
	'Lifted by': 'Levantado por',
	'Lifted by ': 'Levantado por ',
	'1 worker': '1 trabajador',
	'2 workers': '2 trabajadores',
	'3 workers': '3 trabajadores',
	Using: 'Usando',
	'only one hand': 'una sola mano',
	'one hand': 'una mano',
	'both hands': 'ambas manos',
	'Reference weight': 'Peso de referencia',
	Results: 'Resultados',
	'Select the coupling quality': 'Seleccione la calidad de agarre',
	'Select the lifting frequency': 'Seleccione la frecuencia de levantamiento',
	'Select the lifting duration': 'Seleccione la duración de levantamiento',
	'Lifting frequency (lifts per minute)': 'Frecuencia de levantamiento (levant./min)',
	'Enter the task variables below.': 'Introduzca las variables de la tarea a continuación.',
	'Please enter a value': 'Introduzca un valor',
	'Coupling factor: ': 'Factor de agarre: ',
	'Frequency factor: ': 'Factor frecuencia: ',
	Characteristics: 'Características',
	Variables: 'Variables',
	Result: 'Resultado',
	'Report created successfully': 'Informe creado con éxito',
	'Comment updated successfully': 'Comentario actualizado con éxito',
	'Document created successfully': 'Documento creado con éxito',

	// STRAIN INDEX REPORT
	'Report Results - Revised Strain Index': 'Informe de resultados - Strain Index Revisado',
	'Intensity of exertion': 'Intensidad de esfuerzo',
	'Efforts per minute': 'Esfuerzos por minuto',
	'Number of exertions': 'Número de esfuerzos',
	'Observation time': 'Tiempo de observación',
	'Duration per exertion': 'Duración por esfuerzo',
	'Hand/wrist posture': 'Postura de mano/muñeca',
	'Type of wrist posture': 'Tipo de postura de la muñeca',
	'Hand/wrist angle': 'Ángulo de mano/muñeca',
	'Duration of task per day': 'Duración de la tarea por día',
	'Revised Strain Index (RSI)': 'Strain Index Revisado (RSI)',
	'Risk factor': 'Factor de riesgo',
	Input: 'Entrada',
	'Job is probably safe': 'El trabajo es probablemente seguro',
	'Job is probably hazardous': 'El trabajo es probablemente peligroso',
	Degrees: 'Grados',
	'Duration/day': 'Duración/día',
	'Intensity of exertion (Borg Scale - BS)': 'Intensidad de esfuerzo (Borg Scale - BS)',
	Light: 'Ligero',
	'Somewhat Hard': 'Poco Difícil',
	Hard: 'Difícil',
	'Very Hard': 'Muy Difícil',
	'Near Maximal': 'Casi Maxima',
	'Risk factors 1': 'Factores de riesgo 1',
	'Risk factors 2': 'Factores de riesgo 2',
	'Barely noticeable or relaxed effort (BS: 0-2)': 'Esfuerzo casi imperceptible o relajado (BS: 0-2)',
	'Noticeable or definite effort (BS: 3)': 'Esfuerzo perceptible o definido (BS: 3)',
	'Obvious effort; Unchanged facial expression (BS: 4-5)': 'Esfuerzo obvio; Expresión facial sin cambios (BS: 4-5)',
	'Substantial effort; Changes expression (BS: 6-7)': 'Esfuerzo sustancial; Cambio de expresión (BS: 6-7)',
	'Uses shoulder or trunk for force (BS: 8-10)': 'Usa el hombro o el tronco para la fuerza (BS: 8-10)',
	'Number of exertions observed': 'Número de esfuerzos observados',
	'Total observation time': 'Tiempo total de observación',
	'Average single exertion time': 'Tiempo medio de esfuerzo',
	'(total exertions * single exertion time) must be less than or equal to the total observation time':
		'(esfuerzos totales * tiempo de esfuerzo) debe ser inferior o igual al tiempo total de observación',
	seconds: 'segundos',
	hours: 'horas',
	Extension: 'Extensión',
	Flexion: 'Flexión',
	'Revised Strain Index (Moore and Garg)': 'Strain Index Revisado (Moore y Garg)',
	'Report Results': 'Informe de resultados',
	'Revised Strain Index': 'Strain Index Revisado',
	'(Moore and Garg)': '(Moore y Garg)',

	// REBA
	'REBA Report Results': 'Informe de resultados REBA',
	'Puntaje REBA del lugar de trabajo': 'Pontuação REBA do posto de trabalho',
	'Left leg': 'Pierna izquierda',
	'Right leg': 'Pierna derecha',
	'Load less than 5kg (intermittent)': 'Carga inferior a 5 kg (intermitente)',
	'Load from 5kg to 20kg (intermittent)': 'Carga de 5kg a 20kg (intermitente)',
	'Load from 5kg to 20kg (static or repetitive)': 'Carga de 5 kg a 20 kg (estática o repetitiva)',
	'Bigger load 20kg of repetitive load or blows': 'Carga superior a 20 kg de repeticiones o golpes',
	Unacceptable: 'Inaceptable',
	'Repetitions per minute': 'Repeticiones por minuto',
	Force: 'Fuerza',
	Torque: 'Par de apriete',
	Load: 'Carga',
	'Select the load': 'Seleccione la carga',
	'Select the number of repetitions': 'Seleccione el número de repeticiones',
	Acceptable: 'Aceptable',
	Investigate: 'Investigar',
	'Investigate and change soon': 'Investiga y cambia pronto',
	'Investigate and change now': 'Investigue y cambie inmediatamente',
	'REBA Score': 'Score REBA',
	'The 4 most critical body parts': 'Las 4 partes del cuerpo más críticas',
	'Viewing the selected body part': 'Visualización de la parte seleccionada',
	minute: 'minuto',
	'Requested video data is old, please upload to continue':
		'Los datos de video solicitados son antiguos, súbalos para continuar',
	'View score': 'Ver puntuación',
	'Unable to view': 'No se puede ver',
	'Worst grade found in time': 'Peor score encontrado en tiempo',

	// Angle time
	'Create risk range': 'Crear rango de riesgo',
	'Report Results - Angle by Time': 'Informe de resultados - Ángulo en el Tiempo',
	'Please fill all required fields': 'Por favor llene todos los campos requeridos',

	// ACTION PLANS
	'Action Plan Title': 'Título del Plan de Acción',
	'Describe the situation detected...':
		'Describe la situación detectada y las medidas preventivas ya implementadas (si las hay)',
	'Task created successfully': 'Tarea creada con éxito',
	'Action plans': 'Plan de acción',
	'Action plan': 'Plan de acción',
	'Create actions to address the problems encountered': 'Cree acciones para resolver los problemas encontrados',
	'Do you want to delete this action plan?': '¿Desea eliminar este plan de acción?',
	'Action plan created successfully': 'Plan de acción creado con éxito',
	'Create action plan': 'Crear plan de acción',
	'Please enter a valid description': 'Por favor ingrese una descripción válida',
	'Action plan description': 'Descripción del plan de acción',
	'Please enter a valid action plan description': 'Ingrese una descripción válida del plan de acción',
	'Person responsible': 'Responsable',
	Responsible: 'Responsable',
	'Who is responsible for this action plan?': '¿Quién es el responsable de este plan de acción?',
	'Describe the situation found and the preventive measures already implemented (if exist)':
		'Describa la situación encontrada y las medidas preventivas ya implementadas (si existen)',
	'Describe the situation detected and the preventive measures already implemented (if any)':
		'Describa la situación detectada y las medidas preventivas ya implementadas (si las hay)',
	Deadline: 'Fecha de vencimiento',
	Deadline: 'Validez',
	'Finish editing your other task first': 'Primero termine de editar la otra tarea',
	'Add a new task': 'Agregar una nueva tarea',
	History: 'Histórico',
	'Finish by: ': 'Terminar por: ',
	'On time': 'En el plazo',
	Overdue: 'Tarde',
	'Report type': 'Tipo de informe',
	'Select a report type': 'Seleccione o tipo de informe',
	'Finishing in a week': 'Terminando en una semana',
	'Person responsible updated': 'Responsable del plan de acción actualizado',
	'Deadline updated': 'Fecha límite del plan de acción actualizado',
	Tasks: 'Tareas',
	'Task created': 'Tarea creada',
	'Task deleted': 'Tarea eliminada',
	'Task renamed': 'Tarea renombrada',
	'Task type changed': 'Tipo de tarea cambiado',
	'Task and type changed': 'Tarea y tipo cambiados',
	'Task checked': 'Tarea terminada',
	'Task unchecked': 'Tarea deshecha',
	'Action plan created': 'Plan de acción creado',
	'Action plan renamed': 'Plan de acción renombrado',
	'Status changed': 'Estado cambiado',
	'Deadline changed': 'Término cambiado',
	'by ': 'por ',
	'Successfully updated action plan data': 'Datos del plan de acción actualizados con éxito',
	'Responsible user changed': 'Cambio de responsable',
	'Action plan title': 'Título del plan de acción',
	Title: 'Título',
	'Select a file': 'Seleccione un archivo',
	'Please enter a valid title': 'Por favor ingrese un título válido',
	'Please enter a responsible': 'Por favor ingrese un responsable',
	'Please enter a valid date': 'Por favor introduzca una fecha valida',
	'Search company': 'Buscar empresa',
	'Search industrial site': 'Buscar centro de trabajo',
	'Enter a valid email': 'Introduzca un correo electrónico válido',
	'Select a condition': 'Selecione uma condição',
	Eliminate: 'Eliminar',
	Control: 'Controlar',
	Compensate: 'Compensar',
	ELIMINATE: 'ELIMINAR',
	CONTROL: 'CONTROLAR',
	COMPENSATE: 'COMPENSAR',
	'Due Date': 'Fecha de vencimiento',
	'Date of Completion': 'Fecha de finalización',
	Investment: 'Inversión',
	Attachments: 'Adjuntos',
	Progress: 'Progreso',
	Evidence: 'Evidencia',
	Author: 'Autor',
	Origin: 'Origen',
	'Manage Columns': 'Administrar columnas',
	'Priority editing': 'Edición de prioridad',
	'Due Date editing': 'Edición de fecha de vencimiento',
	'Responsible editing': 'Edición de responsable',
	'Are you sure you want to delete the selected action plans?':
		'¿Está seguro de que desea eliminar los planes de acción seleccionados?',

	// KIM - MHO
	'Error, cannot get "': 'Error, no se puede obtener "',
	'" from "': '" de "',
	'Total duration of this sub-activity per working day': 'Duración total de la actividad por día trabajado',
	'Type of force exertion in the finger/hand area within a “standard minute”':
		'Fuerza ejercida sobre el área de la mano/dedo en un "minuto estándar"',
	'Force transfer / gripping conditions': 'Transferencia de fuerza/condiciones de agarre',
	'Hand/arm position and movement': 'Posición y movimiento de manos/brazos',
	'Unfavourable working conditions': 'Condiciones laborales desfavorables',
	'Work organization / temporal distribution': 'Organización del trabajo / distribución del tiempo',
	'Body posture/movement': 'Postura y movimiento del cuerpo',
	'Very low': 'Muy baja',
	Moderate: 'Moderada',
	'Peak forces': 'Fuerzas máximas',
	'Powerful hitting': 'Golpes poderosos',
	'Up to 15% Fmax. Button actuation, shifting, ordering, material guidance, insertion of small parts.':
		'Hasta 15% Fmáx. Accionamiento de botones, desplazamiento, clasificación, orientación de materiales, inserción de piezas pequeñas.',
	'Up to 30% Fmax. Gripping, joining small work pieces by hand or with small tools.':
		'Hasta 30% Fmáx. Agarrar o unir piezas pequeñas a mano o con herramientas pequeñas.',
	'Up to 50% Fmax. Turning, winding, packaging, grasping, holding or joining parts, pressing in, cutting, working with small powered hand tools.':
		'Hasta 50% Fmáx. Torneado, laminado, empaquetado, agarre, sujeción o unión de piezas, prensado, corte, trabajo con pequeñas herramientas manuales motorizadas.',
	'Up to 80% Fmax. Cutting involving major element of force, working with small staple guns, moving or holding parts or tools.':
		'Hasta 80% Fmáx. Cortar que involucre un gran elemento de fuerza, trabajar con pistolas grapadoras pequeñas, mover o sujetar piezas o herramientas.',
	'More than 80% Fmax. Tightening, loosening bolts, separating, pressing in.':
		'Más del 80% Fmáx. Apretar, aflojar tornillos, separar, prensar.',
	'Hitting with the ball of the thumb, palm of the hand or fist.':
		'Golpear con la punta del pulgar, la palma o el puño.',
	'Optimum force transfer/application': 'Transferencia/aplicación de fuerza óptima',
	'Restricted force transfer/application': 'Transferencia/aplicación de fuerza restringida',
	'Force transfer/application considerably hindered':
		'Transferencia/aplicación de fuerza considerablemente deteriorada',
	'Optimum force application': 'Aplicación de fuerza óptima',
	'Restricted force application': 'Aplicación de fuerza restringida',
	'Force application considerably hindered': 'Aplicación de fuerza considerablemente deteriorada',
	'Working objects are easy to grip (e.g. bar-shaped, gripping grooves) / good ergonomic gripping design (grips, buttons, tools).':
		'Los objetos de trabajo son fáciles de agarrar (p. ej., en forma de barra, ranuras de agarre) / buen diseño de agarre ergonómico (asas, botones, herramientas).',
	'Greater holding forces required / no shaped grips.':
		'Se requieren mayores fuerzas de agarre / empuñaduras sin forma ergonómica.',
	'Working objects hardly possible to grip (slippery, soft, sharp edges) / no or only unsuitable grips.':
		'Objetos de trabajo difíciles de agarrar (bordes resbaladizos, blandos, afilados) / empuñaduras inadecuadas solamente o ninguna.',
	Restricted: 'Restringido',
	Unfavourable: 'Desfavorable',
	'Position or movements of joints in the middle (relaxed) range, only rare deviations, no continuous static arm posture, hand-arm rest possible as required.':
		'Posición articular o movimientos en rango medio (relajado), solo desviaciones raras / no es posible una postura estática continua del brazo / apoyo mano-brazo según sea necesario.',
	'Occasional positions or movements of the joints at the limit of the movement ranges, occasional long continuous static arm posture.':
		'Posiciones o movimientos articulares ocasionales en el límite de los rangos de movimiento, ocasionalmente postura estática, larga y continua del brazo.',
	'Frequent positions or movements of the joints at the limit of the movement ranges, frequent long continuous static arm posture.':
		'Posiciones o movimientos articulares a menudo en el límite de los rangos de movimiento, postura del brazo a menudo estática, larga y continua.',
	'Constant positions or movements of the joints at the limit of the movement ranges, constant long continuous static arm posture.':
		'Posiciones o movimientos articulares constantemente en el límite de los rangos de movimiento, postura del brazo constantemente estática, prolongada y continua.',
	'Frequent variation of the physical workload situation due to other activities (including other types of physical workload) / without a tight sequence of higher physical workloads within one type of physical workload during a single working day.':
		'Variación frecuente en la situación de la carga de trabajo física debido a otras actividades (incluidos otros tipos de carga de trabajo física) / sin una secuencia estricta de cargas de trabajo físicas más altas dentro de un tipo de carga de trabajo física durante un solo día de trabajo.',
	'Rare variation of the physical workload situation due to other activities (including other types of physical workload) / occasional tight sequence of higher physical workloads within one type of physical workload during a single working day.':
		'Variación rara de la situación de la carga de trabajo físico debido a otras actividades (incluidos otros tipos de carga de trabajo físico) / secuencia restringida ocasional de cargas de trabajo físico más altas dentro de un tipo de carga de trabajo físico durante un solo día de trabajo.',
	'No/hardly any variation of the physical workload situation due to other activities (including other types of physical workload) / frequent tight sequence of higher physical workloads within one type of physical workload during a single working day with concurrent high load peaks.':
		'Ninguna/casi ninguna variación de la situación de la carga de trabajo físico debido a otras actividades (incluidos otros tipos de carga de trabajo físico)/secuencia estrecha frecuente de cargas de trabajo físicas más altas dentro de un tipo de carga de trabajo físico durante un solo día de trabajo con altos picos de carga simultáneos.',
	'There are no unfavourable working conditions, i.e. reliable recognition of detail / no dazzle / good climatic conditions.':
		'Sin condiciones de trabajo desfavorables, es decir, reconocimiento de detalles confiable / sin deslumbramiento / buenas condiciones climáticas.',
	'Occasionally impaired detail recognition due to dazzle or excessively small details difficult conditions such as draught, cold, moisture and/or disturbed concentration due to noise.':
		'Reconocimiento de detalles ocasionalmente deteriorado debido al deslumbramiento o detalles excesivamente pequeños en condiciones difíciles como corrientes de aire, frío, humedad y/o concentración perturbada debido al ruido.',
	'Frequently impaired detail recognition due to dazzle or excessively small details frequently difficult conditions such as draught, cold, moisture and/or disturbed concentration due to noise.':
		'El reconocimiento de detalles a menudo se ve afectado por el deslumbramiento o por detalles demasiado pequeños, a menudo en condiciones difíciles como corrientes de aire, frío, humedad y/o concentración perturbada debido al ruido.',
	'Alternation between sitting and standing, alternation between standing and walking, dynamic sitting possible':
		'Cambiar entre estar sentado y de pie, cambiar entre estar de pie y caminar, es posible sentarse de forma dinámica',
	'Trunk inclined forward only very slightly': 'Tronco ligeramente inclinado hacia delante',
	'No twisting and/or lateral inclination of the trunk identifiable':
		'Sin torsión del tronco identificable y/o flexión lateral',
	'Head posture: variable, head not inclined backward and/or severely inclined forward or constantly moving':
		'Postura de la cabeza: Variable, cabeza no inclinada hacia atrás y/o muy inclinada hacia adelante o en constante movimiento',
	'No gripping above shoulder height / no gripping at a distance from the body':
		'Sin agarre por encima de la altura del hombro/Sin agarre a la distancia del cuerpo',
	'Predominantly sitting or standing with occasional walking':
		'Predominantemente sentado o de pie con caminata ocasional',
	'Trunk with slight inclination of the body towards the work area':
		'Tronco con ligera inclinación del cuerpo hacia la zona de trabajo',
	'Occasional twisting and/or lateral inclination of the trunk identifiable':
		'Torsión ocasional y/o flexión del tronco identificable lateralmente',
	'Occasional deviations from good “neutral” head posture/movement':
		'Desviaciones ocasionales de una buena postura/movimiento neutral de la cabeza',
	'Occasional gripping above shoulder height / occasional gripping at a distance from the body':
		'Convulsiones ocasionales por encima de la altura del hombro / convulsiones ocasionales a distancia del cuerpo',
	'Exclusively standing or sitting without walking': 'Exclusivamente de pie o sentado sin caminar',
	'Trunk clearly inclined forward and/or frequent twisting and/or lateral inclination of the trunk identifiable':
		'Tronco claramente inclinado hacia adelante y/o torsión frecuente y/o inclinación lateral del tronco identificable',
	'Frequent deviations from good “neutral” head posture/movement':
		'Desviaciones frecuentes de una buena postura/movimiento neutral de la cabeza',
	'Head posture hunched forward for detail recognition / restricted freedom of movement':
		'Postura de la cabeza inclinada hacia adelante para reconocimiento de detalles/libertad de movimiento restringida',
	'Frequent gripping above shoulder height / frequent gripping at a distance from the body':
		'Agarre frecuente por encima de la altura del hombro/agarre frecuente lejos del cuerpo',
	'Trunk severely inclined forward / frequent or long-lasting bending':
		'Tronco muy inclinado hacia adelante/flexión frecuente o prolongada',
	'Work being carried out in a kneeling, squatting, lying position':
		'Trabajo realizado en posición de rodillas, agachado y acostado',
	'Constant twisting and/or lateral inclination of the trunk identifiable':
		'Torsión constante y/o inclinación lateral del tronco identificable',
	'Body posture strictly fixed / visual check of action through magnifying glasses or microscopes':
		'Postura corporal estrictamente fija/verificación visual de la acción a través de lupas o microscopios',
	'Constant deviations from good “neutral” head posture/movement':
		'Desviaciones constantes de una buena postura/movimiento neutral de la cabeza',
	'Constant gripping above shoulder height / constant gripping at a distance from the body':
		'Agarre constante por encima de la altura del hombro/Agarre constante a distancia del cuerpo',
	'Manual Handling': 'Manejo Manual',
	'Manual Handling Operations': 'Operaciones de Manejo Manual',
	'KIM - Manual Handling Operations': 'KIM - Operaciones de Manejo Manual',
	'Total duration per working day': 'Duración total por día trabajado',
	'Type of force exertion in the finger/hand': 'Fuerza ejercida en el área de la mano/dedo',

	'Possible health consequences': 'Posibles consecuencias para la salud',
	Measures: 'Medidas',
	'No measures need to be taken.': 'No es necesario tomar medidas.',
	'Physical overload is unlikely.': 'La sobrecarga física no es probable.',
	'No health risk is to be expected.': 'No se esperan riesgos para la salud.',
	'None.': 'Ninguno.',
	'Physical overload is possible for less resilient persons.':
		'La sobrecarga física es posible para las personas menos resilientes.',
	'Fatigue, low-grade adaptation problems which can be compensated for during leisure time.':
		'Fatiga, problemas de ajuste de bajo grado que se pueden compensar durante el tiempo libre.',
	'For less resilient persons, workplace redesign and other prevention measures may be helpful.':
		'Para las personas menos resilientes, los cambios en el lugar de trabajo y otras medidas preventivas pueden ayudar.',
	'Physical overload is possible for normally resilient persons.':
		'La sobrecarga física es posible para las personas normalmente resilientes.',
	'Disorders (pain), possibly including dysfunctions, reversible in most cases, without morphological manifestation.':
		'Trastornos (dolor), posiblemente incluyendo disfunciones, reversibles en la mayoría de los casos, sin manifestación morfológica.',
	'Workplace redesign and other prevention measures should be considered.':
		'Se deben considerar cambios en el lugar de trabajo y otras medidas preventivas.',
	'Physical overload is likely.': 'La sobrecarga física es probable.',
	'More pronounced disorders and/or dysfunctions, structural damage with pathological significance.':
		'Trastornos y/o disfunciones más pronunciados, daño estructural con significado patológico.',
	'Workplace redesign measures are necessary. Other prevention measures should be considered.':
		'Los cambios en el lugar de trabajo son necesarios, se deben considerar otras medidas preventivas.',
	'Slightly increased': 'Ligeramente aumentada',
	'Substantially increased': 'Incrementado sustancialmente',
	'Type of force exertion in the finger/hand area': 'Tipo de esfuerzo realizado en el área de la mano/dedo',
	'Intensity of force exertion in the finger/hand area within a “standard minute”':
		'Fuerza ejercida sobre el área de la mano/Intensidad de la fuerza ejercida sobre el área de la mano/dedos en un "minuto estándar"',
	Holding: 'Sosteniendo',
	Moving: 'Moviendo',
	'average (seconds holding / minute)': 'promedio (segundos sosteniendo / min.)',
	'average (movements / minute)': 'promedio (movimientos / min.)',
	'Left arm': 'Brazo izquierdo',
	'Right arm': 'Brazo derecho',

	'Time and force': 'Tiempo y fuerza',
	Conditions: 'Condiciones',
	Posture: 'Postura',

	'Select the body parts you are interested in': 'Selecciona las partes del cuerpo que te interesan',
	'Select all': 'Seleccionar todo',

	'Shoulder L': 'Hombro E',
	'Shoulder R': 'Hombro D',
	'Elbow L': 'Codo E',
	'Elbow R': 'Codo D',
	'Leg L': 'Pierna E',
	'Leg R': 'Pierna D',

	Cycle: 'Ciclo',
	'Select the cycle': 'Seleccione el ciclo',
	'Select one of the vehicles or a wheel type:': 'Seleccione uno de los vehículos o un tipo de rueda',
	Conveyors: 'Transportadores',
	Cranes: 'Grúas',
	'Driveway conditions:': 'Condiciones de la calzada:',
	'Select the mass to be transported (in kg):': 'Seleccione la masa a transportar (en kg):',
	'Inclination or stairs:': 'Pendiente o escaleras:',
	'Conditions:': 'Condiciones:',

	'Increased movement speed (approx. 1.0 up to 1.3 m/s)': 'Mayor velocidad de movimiento (aprox. 1,0 hasta 1,3 m/s)s',

	'Cannot change a consolidated analysis': 'No se puede cambiar un análisis consolidado',
	'Comments successfully saved': 'Comentarios guardados correctamente',

	'Action plan deleted successfully': 'Plan de acción eliminado con éxito',
	'Task deleted successfully': 'Tarea eliminada con éxito',
	'Task updated successfully': 'Tarea actualizada con éxito',

	'Ops... something happened!': 'Ups... ¡algo pasó!',
	'It was not possible to save your information': 'No se puede guardar su información',
	'No task available': 'No hay tareas disponibles',
	day: 'día',
	days: 'días',

	// Super PEA File History
	'Selected Files': 'Archivos seleccionados',
	'Worst score': 'Peor puntuación',
	'Open File List': 'Abrir lista de archivos',
	'EWA deleted successfully': 'AEP eliminado con éxito.',

	//Others words
	Likelihood: 'Probabilidad',
	Exposure: 'Exposición',
	'Possible Injuries/Harms': 'Posibles lesiones/daños',
	Job: 'Trabajo',
	'Assignment note': 'Nota de tarea',
	'Hours worked in the day': 'Horas trabajadas en el día',
	'Weight Limit recommended (WLR)': 'Límite de peso recomendado (LPR)',
	'Lifting index (LI)': 'índice de elevación (IL)',
	Comment: 'Comentario',
	Particularities: 'Particularidades',
	Production: 'Producción',
	'Working regime': 'Régimen de trabajo',
	EWA: 'AET',
	Action: 'Acción',
	'New document': 'Nuevo documento',
	'File history': 'Historial del archivo',
	'Items per page': 'Artículos por página',
	'New Report': 'Novo Informe',
	Analysis: 'Análisis',

	//Action plans cards
	'Fill in the details above': 'Complete los detalles arriba',

	'Risk Acceptable': 'Riesgo Aceptable',

	'Risk Moderate': 'Riesgo Moderado',
	'Improvement action': 'Acción de mejora',

	'Risk High': 'Riesgo Alto',
	'Immediate action for improvement and reassess': 'Acción inmediata de mejora y reevaluación',

	'Risk Very High': 'Riesgo Muy Alto',
	'Perform Ergonomic Work Analysis': 'Realizar análisis de trabajo ergonómico',

	'Risk Serious and Imminent': 'Riesgo Grave e Inminente',
	'Stop the activity and carry out an Ergonomic Work Analysis':
		'Detener la actividad y realizar un Análisis Ergonómico del Trabajo',

	//Possible injuries
	'Possible injuries': 'Posibles lesiones',
	'Fatigue complaints': 'Quejas de fatiga',
	Absenteeism: 'Absentismo',
	'Musculoskeletal complaints': 'Quejas musculoesqueléticas',
	'Complaints of mental overload': 'Quejas de sobrecarga mental',
	'Complaints of irritability': 'Quejas de irritabilidad',
	'Nonconforming products': 'Productos no conformes',
	'Low back pain complaints': 'Quejas de lumbalgia',
	'Elbow pain': 'Dolor de codo',
	'Shoulder pain': 'Dolor de hombro',
	Headache: 'Dolor de cabeza',
	'Unexcused absences': 'Ausencias injustificadas',
	'Neck pain': 'Dolor de cuello',
	'Wrist pain': 'Dolor en la muñeca',

	//Consequence
	Consequence: 'Consecuencia',
	'Severe with fatalities and serious injuries': 'Severo con muertos y heridos graves',
	'Temporary disability': 'Incapacidad temporal',
	'Injuries with leave': 'Lesiones con baja',
	'Severe with possibility of death or disability': 'Grave con posibilidad de muerte o invalidez',
	'Superficial injuries': 'Lesiones / daños superficiales',
	'Catastrophic with numerous deaths': 'Catastrófico con numerosas muertes',

	//Probability
	Probability: 'Probabilidad',
	'Most likely and expected outcome': 'Resultado más probable y esperado',
	'Extremely remote possibility': 'Posibilidad extremadamente remota',
	'Practically impossible, never happened': 'Prácticamente imposible, nunca sucedió',
	'Unlikely, but it has happened': 'Improbable, pero ha pasado',
	'Possible outcome': 'Resultado posible',
	'Rare but possible': 'Raro pero posible',

	//Exhibition
	'Remotely (never occurred)': 'Remotamente (nunca ocurrió)',
	'Rarely (occurs in short bursts without definition)': 'Raramente (ocurre en ráfagas cortas sin definición)',
	'Irregular (once a month to once a year)': 'Irregular (una vez al mes a una vez al año)',
	'Occasionally (once a week to once a month)': 'Ocasionalmente (una vez a la semana a una vez al mes)',
	'Frequent (at least once a day)': 'Frecuente (al menos una vez al día)',
	'Continues (several times a day)': 'Continúa (varias veces al día)',
	'Remotely (>90% green)': 'Remotamente (>90% verde)',
	'Rarely (80 to 89% green)': 'Raramente (80 a 89% verde)',
	'Irregular (50 to 79% green)': 'Irregular (50 a 79% verde)',
	'Occasionally (30 to 49% green)': 'Ocasionalmente (30 a 49% verde)',
	'Frequent (10 to 29% green)': 'Frecuente (10 a 29% verde)',
	'Continues (<9% green)': 'Continúa (<9% verde)',

	//Steps erros
	'Select the injuries': 'Seleccione las lesiones',
	'Select the consequence': 'Seleccione la consecuencia',
	'Select the probability': 'Seleccione la probabilidad',
	'Select the exhibition': 'Seleccione la exposición',
	"Some required steps wasn't filled": 'No se completaron algunos pasos obligatorios',

	//Step 1
	Informations: 'Informaciones',
	'Select the sector': 'Seleccione el sector',
	Analyst: 'Analista',
	'Insert the analyst': 'Inserte el analista',
	Responsibility: 'Responsabilidad',
	'Insert the responsibility': 'Insertar la responsabilidad',
	'Insert the cell': 'Introduce la célula',
	'Insert the activity': 'Insertar la actividad',
	'Insert the workstation': 'Insertar la estación de trabajo',
	'Enter the collection date': 'Introduce la fecha de recogida',

	//Step 2
	'Work conditions': 'Condiciones de trabajo',
	'Working conditions': 'Condiciones laborales',
	'Work schedule minute': 'Minuta del horario de trabajo',
	'Work schedule hours': 'Horas del horario de trabajo',
	'Select the constraints perceived in the evaluated work condition':
		'Seleccione las restricciones percibidas en la condición de trabajo evaluada',
	'Work schedule': 'Horario de trabajo',
	'Summary description of the place': 'Descripción resumida del lugar',
	'Simplified description of the expected task': 'Descripción simplificada de la tarea esperada',
	'Simplified description of the task performed': 'Descripción simplificada de la tarea realizada',

	//Step 3
	'Working population': 'Población activa',
	"Worker's verbalization": 'Verbalización de los trabajadores',
	'Self-evaluation': 'Autoevaluación',
	'What is the level of stress perceived by the worker when performing the task?':
		'¿Cuál es el nivel de estrés que percibe el trabajador al realizar la tarea?',
	'Nothing stressful': 'Nada estresante',
	'Little stressful': 'Un poco estresante',
	'Not too stressful': 'No muy estresante',
	'Working population must be greater than 0': 'La población de los trabajadores debe ser mayor que 0',
	workers: 'trabajadores',
	Stressful: 'Estresante',
	'Very stressful': 'Muy estresante',
	'Extremely stressful': 'Extremadamente estresante',

	//Step 4
	'Workday and concentration at work': 'Jornada y concentración en el trabajo',
	'Working hours of more than 8 hours a day': 'Jornada de trabajo de más de 8 horas diarias',
	'Existence of long and frequent overtime hours of work':
		'Existencia de largas y frecuentes horas extraordinarias de trabajo',
	'Stays long time continuous operation': 'Permanece mucho tiempo en funcionamiento continuo',
	'Insufficient rest interval': 'Intervalo de descanso insuficiente',
	'Insufficient rest break': 'Pausa de descanso insuficiente',
	'Insufficient rest days': 'Días de descanso insuficientes',
	'Unbalanced concentrations of work in a day, week, month or year':
		'Concentraciones desequilibradas de trabajo en un día, semana, mes o año',
	'Unbalanced concentrations of work among workers': 'Concentraciones desequilibradas de trabajo entre trabajadores',
	'Insufficient rest between shifts (less than 11 hours)': 'Descanso insuficiente entre turnos (menos de 11 horas)',
	'Remains long time continuous operation': 'Permanece mucho tiempo en funcionamiento continuo',

	//Step 5
	'Kind of work': 'Clase de trabajo',
	'Lift and/or carry heavy objects': 'Levantar y/o transportar objetos pesados',
	'Apply the tool': 'Aplicar la herramienta',
	'Load surveys': 'Cargar encuestas',
	'Lifts and/or carries objects farther than 60 cm': 'Levanta y/o transporta objetos a más de 60 cm',
	'Performs tasks that require great strength': 'Realiza tareas que requieren una gran fuerza',
	'Performs tasks that require pronounced pushing and pulling forces':
		'Realiza tareas que requieren fuerzas pronunciadas de empuje y tracción',
	'Performs repetitive work': 'Realiza trabajo repetitivo',
	'Performs work that requires frequent finger, hand, or arm movements':
		'Realiza trabajos que requieren movimientos frecuentes de dedos, manos o brazos',
	'Do intensive work with a keyboard or other input devices':
		'Haz un trabajo intensivo con un teclado u otros dispositivos de entrada',
	'Perform precision work': 'Realizar trabajo de precisión',
	'Performs activities with high visual requirements': 'Realiza actividades con altos requerimientos visuales',

	//Step 6
	'Postures and movements': 'Posturas y movimientos',
	'Stays in uncomfortable postures and movements': 'Permanece en posturas y movimientos incómodos',
	'Performs continuous and/or highly frequent change in joint positions':
		'Realiza cambios continuos y/o muy frecuentes en posiciones conjuntas',
	'Stays in constrained posture for long duration': 'Permanece en una postura restringida durante mucho tiempo',
	'Walk for long duration and/or long distance (on a horizontal surface as well as an inclined surface)':
		'Caminata de larga duración y/o larga distancia (tanto en una superficie horizontal como en una superficie inclinada)',
	'Performs frequent stair climbing': 'Realiza frecuentes subidas de escaleras',
	'Remains in a sedentary/standing position for a long time':
		'Permanece en una posición sedentaria/de pie durante mucho tiempo',
	'Postures requirements (Kinebot)': 'Requisitos de posturas (Kinebot)',

	//Step 7
	'Influence of workspace and task factors': 'Influencia del espacio de trabajo y los factores de la tarea',
	'Workspace is inadequate and forces an uncomfortable posture or limited movement':
		'El espacio de trabajo es inadecuado y obliga a una postura incómoda o movimiento ilimitado',
	'Workstation layout requires excessive movement or uncomfortable postures':
		'La disposición de los puestos de trabajo requiere movimientos excesivos o posturas incómodas',
	'The heights, distances and dimensions of controls or work surfaces are inadequate':
		'Las alturas, distancias y dimensiones de los mandos o superficies de trabajo son inadecuadas',
	'Anthropometry Table x Furniture (cm)': 'Mesa de Antropometría x Mobiliario (cm)',
	'Add information': 'Añadir información',
	'Found (cm)': 'Encontrado (cm)',
	'Foreseen (cm)': 'Previsto (cm)',
	'Enter a location': 'Ingrese una ubicación',
	'Enter what was found': 'Ingrese lo encontrado',
	'Insert predicted': 'Insertar predicho',
	'Performs handling of work objects above the shoulder or below the knee':
		'Realiza la manipulación de objetos de trabajo por encima del hombro o por debajo de la rodilla',
	'The workspace forces the worker to maintain the same working posture':
		'El espacio de trabajo obliga al trabajador a mantener la misma postura de trabajo',
	'Handles work objects that are difficult to handle and slippery':
		'Maneja objetos de trabajo que son difíciles de manejar y resbaladizos',
	'Activity requires high-voltage contact or local pressure acting on the body':
		'La actividad requiere contacto de alto voltaje o presión local que actúa sobre el cuerpo',

	//Step 8
	'Influence of psychosocial factors': 'Influencia de los factores psicosociales',
	'Activity with mental overload or underload': 'Actividad con sobrecarga o subcarga mental',
	'Work pace with time pressure and high demands': 'Ritmo de trabajo con presión de tiempo y altas exigencias',
	'Presence of work-related stress': 'Presencia de estrés relacionado con el trabajo',
	'Reports of low job satisfaction': 'Informes de baja satisfacción laboral',
	'Activity with lack of autonomy (low influence, low control)':
		'Actividad con falta de autonomía (baja influencia, bajo control)',
	'Low social support': 'Poco apoyo social',

	//Step 9
	'Influence of environmental factors': 'Influencia de los factores ambientales',
	'Place with slippery and/or uneven floor': 'Lugar con suelo resbaladizo y/o irregular',
	'There is exposure to whole body vibration (see ISO 2631)':
		'Hay exposición a vibraciones de todo el cuerpo (ver ISO 2631)',
	'Makes use of hand-arm vibration tools during work; (see ISO 5349)':
		'Hace uso de herramientas de vibración mano-brazo durante el trabajo (ver ISO 5349)',
	'Makes use of hand-arm vibration tools during work (see ISO 5349)':
		'Hace uso de herramientas de vibración mano-brazo durante el trabajo (ver ISO 5349)',
	'Performs work using vehicles that transmit vibration throughout the body':
		'Realiza trabajos utilizando vehículos que transmiten vibraciones por todo el cuerpo',
	'Hot or cold working environment': 'Ambiente de trabajo caliente o frío',
	'Location with background noise': 'Ubicación con ruido de fondo',

	//Step 10
	'Organizational influences': 'Influencias organizacionales',
	'Production standards are not clear or understood by workers':
		'Los estándares de producción no son claros o no son entendidos por los trabajadores',
	'The operative mode descriptions are insufficient or wrong':
		'Las descripciones de los modos operativos son insuficientes o incorrectas',
	'The time to carry out the activities is inadequate': 'El tiempo para realizar las actividades es inadecuado',
	'The pace of work is accelerated': 'Se acelera el ritmo de trabajo',
	'The content of the tasks is different from the technical means available':
		'El contenido de las tareas es diferente de los medios técnicos disponibles',
	'Task with high cognitive demand': 'Tarea con alta demanda cognitiva',

	// Results

	'Anthropometry Table': 'Mesa de antropometría',
	'Consolidate analysis': 'Consolidar análisis',
	Deconsolidate: 'Desconsolidar',
	'Deconsolidate report': 'Desconsolidar informe',
	'By deconsolidating, the report will be updated to revision JDS-D86 04/2025. Do you want to proceed?':
		'Al desconsolidar, el informe se actualizará a la revisión JDS-D86 04/2025. ¿Desea continuar?',
	'Successfully consolidated analysis': 'Análisis consolidado con éxito',
	'Successfully deconsolidated analysis': 'Análisis no consolidado con éxito',
	'Failed to generate the report': 'Error al generar el informe',
	'Failed to generate PDF': 'Error al generar el PDF',

	Hazardous: 'Peligroso',
	'Movement by score (Kinebot/REBA)': 'Movimiento por puntuación (Kinebot/REBA)',
	'Cargo Handling (NIOSH)': 'Manejo de carga (NIOSH)',
	'Manual Handling (KIM)': 'Manipulación manual (KIM)',
	'Push and Pull (KIM)': 'Empujar y tirar (KIM)',
	'No more action plans available': 'No hay más planes de acción disponibles',
	'No more workstations available': 'No hay más estaciones de trabajo disponibles',

	//Super Preliminary Ergonomic Analysis

	//Error
	'length must be less than or equal to 50 characters long': 'la longitud debe ser menor o igual a 50 caracteres',

	'Preliminary Ergonomic Analysis': 'Análisis Ergonómico Preliminar',

	'New Document': 'Nuevo documento',
	'File History': 'Historial de archivos',

	'Basic Information': 'Información básica',
	'Select PEA': 'Seleccionar AEP',
	"To generate this document, it's necessary that the EWA's must be consolidated, so the list below only shows the consolidated EWA's.":
		'Para generar este documento, es necesario que las AEP estén consolidadas, por eso la lista a continuación muestra solo las AEP consolidadas.',

	// Basic Informartion Step
	'Report Information': 'Información del informe',
	'Report name': 'Nombre del informe',
	'Enter report name': 'Ingrese el nombre del informe',
	'Select a Company': 'Seleccione una empresa',
	'Select the reference date': 'Seleccione la fecha de referencia',
	'Select the report date': 'Seleccione la fecha del informe',

	// Select PEA Step
	'File Name': 'Nombre del archivo',
	'File name': 'Nombre del archivo',
	'Created At': 'Creado en',
	'Uploaded date': 'Fecha de carga',
	'Date of creation': 'Fecha de creación',
	'Date of update': 'Fecha de actualización',
	'Analyst Name': 'Nombre del analista',
	Submit: 'Entregar',

	//Signatures Step
	Signatures: 'Firmas',
	'Enter with a role': 'Entrar con un puesto de trabajo',
	'Enter with a name of responsible': 'Ingresar con nombre de responsable',
	'Add a new signature': 'Añadir una nueva firma',
	'Responsible name': 'Nombre responsable',

	// Conclusion Step
	'Check selected Files': 'Comprobar archivos seleccionados',
	'Files List': 'Lista de archivos',
	'Selected EWA': 'EWA seleccionado',
	'EWA created successfully': 'EWA creado con éxito',
	'Failed to upload PEA report.': 'Error al cargar el informe AEP.',

	// Super PEA File History
	'Preliminary Ergonomic Analyzes': 'Análisis Ergonómicos Preliminares',

	Location: 'Ubicación',
	Found: 'Encontró',
	Foreseen: 'Visto el futuro',
	Condition: 'Condición',

	'NOT OK': 'NO OK',
	"Score's sum": 'Resumen',

	// Do not change due to AEP key - Influences the translation of action plans created by AEP
	'Trunk posture from Kinebot': 'Postura del tronco de Kinebot',
	'Trunk posture from kinebot': 'Postura del tronco de kinebot',
	'Neck posture from Kinebot': 'Postura del cuello de Kinebot',
	'Neck posture from kinebot': 'Postura del cuello de kinebot',
	'Left elbow posture from Kinebot': 'Postura del codo izquierdo de Kinebot',
	'Left elbow posture from kinebot': 'Postura del codo izquierdo de kinebot',
	'Right elbow posture from Kinebot': 'Postura del codo derecho de Kinebot',
	'Right elbow posture from kinebot': 'Postura del codo derecho de kinebot',
	'Left shoulder posture from Kinebot': 'Postura del hombro izquierdo de Kinebot',
	'Left shoulder posture from kinebot': 'Postura del hombro izquierdo de kinebot',
	'Right shoulder posture from Kinebot': 'Postura del hombro derecho de Kinebot',
	'Right shoulder posture from kinebot': 'Postura del hombro derecho de kinebot',

	'Failed to upload the file': 'Error al cargar el archivo',

	// Two-factor authentication
	// API Errors
	'Two-factor authentication not found': 'Autenticación de dos factores no encontrada',
	'Already created two-factor authentication': 'Autenticación de dos factores ya creada',
	'Invalid token': 'Simbolo no valido',
	'Token already validated': 'Token ya validado',
	'Token not yet validated': 'Token aún no validado',
	'Token expired': 'Ficha caducada',
	'Too early to resend email': 'Demasiado pronto para reenviar el correo electrónico',
	'Something went wrong checking token': 'Algo salió mal al verificar el token',
	'Authentication type same as default': 'Tipo de autenticación igual que el predeterminado',
	'Authentication type through app already enabled': 'Tipo de autenticación a través de la aplicación ya habilitada',
	'Two-factor authentication not enabled': 'Autenticación de dos factores no habilitada',
	'Too many tries!': '¡Demasiados intentos!',
	'Too many calls! Wait a moment to try again.': '¡Demasiadas llamadas! Espere un momento para volver a intentarlo.',
	'You are not authorized to access this resource': 'No está autorizado para acceder a este recurso',

	// Hooks success message
	'Two-factor authentication generated successfully': 'Autenticación de dos factores generada con éxito',
	'Two-factor authentication validated successfully': 'Autenticación de dos factores validada con éxito',
	'Two-factor authentication method changed successfully':
		'El método de autenticación de dos factores cambió con éxito',
	'Token sent successfully': 'Token enviado con éxito',
	'Token resent successfully': 'Token reenviado con éxito',
	'Authenticator app enabled successfully': 'Aplicación de autenticación habilitada con éxito',
	'Two-factor authentication deleted successfully': 'La autenticación de dos factores se eliminó con éxito',
	'Two-factor authentication reset successfully': 'Restablecimiento de autenticación de dos factores con éxito',
	'Forced two-factor authentication enabled successfully':
		'Autenticación de dos factores forzada habilitada con éxito',
	'Forced two-factor authentication disabled successfully':
		'Autenticación de dos factores forzada deshabilitada con éxito',

	// My Account
	'Force two-factor authentication to all users': 'Forzar autenticación de dos factores a todos los usuarios',
	'When activated, all users will be forced to activate two-factor authentication on login.':
		'Cuando se activa, todos los usuarios se verán obligados a activar la autenticación de dos factores al iniciar sesión.',
	'Two-factor authentication': 'Autenticación de dos factores',
	'When activated, you will have to type a validation code every time you login.':
		'Cuando esté activado, deberá escribir un código de validación cada vez que inicie sesión.',
	'You can choose to receive your code by email or connect your authentication app with a QRCode.':
		'Puede optar por recibir su código por correo electrónico o conectar su aplicación de autenticación con un QRCode.',

	// Actions
	'Reset 2FA': 'Restablecer 2FA',
	'Deactivate 2FA': 'Desactivar 2FA',
	'You are about to reset your authentication method.': 'Está a punto de restablecer su método de autenticación.',
	'Select a new desired authentication type and insert one of your recovery token to perform this operation.':
		'Seleccione un nuevo tipo de autenticación deseado e inserte uno de sus tokens de recuperación para realizar esta operación.',
	'Authentication method': 'Método de autentificación',
	'Recovery token': 'Token de recuperación',
	'Authenticator app': 'Aplicación de autenticación',
	'You are about to deactivate your 2FA.': 'Está a punto de desactivar su 2FA.',
	'Confirming this action will delete your two-factor authentication. Are you sure?':
		'Si confirma esta acción, se eliminará su autenticación de dos factores. ¿Está seguro?',
	'Heads up! Closing now will delete the token you generated. Want to continue?':
		'¡Aviso! Si cierra ahora, se eliminará el token que generó. ¿Quieres continuar?',
	'Generate Two-factor authentication': 'Generar autenticación de dos factores',
	'Select a method to generate your two-factor authentication':
		'Seleccione un método para generar su autenticación de dos factores',
	'With this method, you will scan a QRCode so you can use your favorite authenticator app (such as Google Authenticator or Microsoft Authenticator). Then, all you have to do is type the code shown in your app when you login. This code changes every few seconds.':
		'Con este método, escaneará un QRCode para poder usar su aplicación de autenticación favorita (como Google Authenticator o Microsoft Authenticator). Luego, todo lo que tiene que hacer es escribir el código que se muestra en su aplicación cuando inicia sesión. Este código cambia cada pocos segundos.',
	'You are about to generate your 2FA with your authenticator app.':
		'Está a punto de generar su 2FA con su aplicación de autenticación.',
	'Be sure to have your mobile phone with you ready to scan your code.':
		'Asegúrese de tener su teléfono móvil con usted listo para escanear su código.',
	'Validation code': 'Código de validación',
	'Enter the 6 digit code.': 'Ingrese el código de 6 dígitos.',
	'Recovery tokens': 'Fichas de recuperación',

	"Here are your recovery codes, which will be requested should you need to recover your account. Keep in mind that they will not be accessible again after this moment, so it's crucial that you save them securely.":
		'Aquí están tus códigos de recuperación, que se solicitarán en caso de que necesites recuperar tu cuenta. Ten en cuenta que no estarán accesibles de nuevo después de este momento, por lo que es crucial que los guardes de manera segura.',

	"Can't close yet. Read the instructions": 'No se puede cerrar todavía. Lee las instrucciones.',
	"Your company has asked for all users to keep two-factor authentication enabled for security reasons. You'll be asked to activate it again on your next login. Want to deactivate it anyway?":
		'Su empresa ha pedido a todos los usuarios que mantengan habilitada la autenticación de dos factores por razones de seguridad. Se le pedirá que la active nuevamente en su próximo inicio de sesión. ¿Desea desactivarla de todos modos?',

	//Login
	'For protection reasons, we need that you validate your 2FA':
		'Por razones de protección, necesitamos que valides tu 2FA',
	'Your company is requesting that all users must have two-factor authentication enabled. Continue to activate yours and login.':
		'Su empresa solicita que todos los usuarios tengan habilitada la autenticación de dos factores. Continúe activando el suyo e inicie sesión.',

	Change: 'Cambiar',
	Security: 'Seguridad',
	'Account security settings': 'Configuración de seguridad de la cuenta',
	'Account information summary': 'Resumen de información de la cuenta',
	'Password must be at least 8 characters long': 'La contraseña debe tener al menos 8 caracteres',
	'The password must have a maximum of 20 characters': 'La contraseña debe tener como máximo 20 caracteres',
	'The password field is required': 'Se requiere el campo de contraseña',
	'Password field cannot be empty': 'El campo de contraseña no puede estar vacío',
	'The password must contain capital letters': 'La contraseña debe contener letras mayúsculas',
	'The password must contain lowercase letters': 'La contraseña debe contener letras minúsculas',
	'Password must contain numbers': 'La contraseña debe contener números',
	'The password must contain at least one special character':
		'La contraseña debe contener al menos un carácter especial',

	// Risks Manager
	Set: 'Definir',
	'Severity not set': 'Severidad no definida',
	'Manage risks': 'Gestionar riesgos',
	'Manage risk categories': 'Gestionar categorías de riesgo',
	'Risk category': 'Categoría de riesgo',
	'Risk damage': 'Daño',
	'Risk category not found': 'Categoría de riesgo no encontrada',
	'Risk description not found': 'Descripción de riesgo no encontrada',
	'Risk damage not found': 'Daño no encontrado',
	'Select a risk damage': 'Seleccionar un daño',
	'Current severity': 'Severidad actual',
	'Severity set successfully': 'Severidad definida con éxito',
	'Create new risk category': 'Crear nueva categoría de riesgo',
	'Update category name': 'Actualizar nombre de categoría',
	'Delete category': 'Eliminar categoría',
	'Category deleted successfully': 'Categoría eliminada con éxito',
	'Category updated successfully': 'Categoría actualizada con éxito',
	'Damage created successfully': 'Daño creado con éxito',
	'Category created successfully': 'Categoría creada con éxito',
	'Risk description created successfully': 'Descripción creada con éxito',
	'Data created successfully': 'Datos creados con éxito',
	'Data updated successfully': 'Datos actualizados con éxito',
	'Data deleted successfully': 'Datos eliminados con éxito',
	'Create new company': 'Crear nueva empresa',
	'Company updated successfully': 'Empresa actualizada con éxito',
	'Company deleted successfully': 'Empresa eliminada con éxito',
	'All risk descriptions related to it will be deleted. Do you wish to proceed?':
		'Todas las descripciones de riesgo relacionadas con esto serán eliminadas. ¿Desea continuar?',
	'Manage risk description': 'Gestionar descripciones de riesgo',
	'Select a risk description': 'Seleccionar una descripción de riesgo',
	'Want to delete this description?': '¿Desea eliminar esta descripción?',
	'Want to delete this damage?': '¿Desea eliminar este daño?',

	// B.E.R.A. Report
	Files: 'Archivos',
	'Custom report': 'Reporte personalizado',
	'Custom reports': 'Reportes personalizados',
	'Custom reports files': 'Archivos del reportes personalizados',
	'Basic Ergonomics Risk Assessment (B.E.R.A.)': 'Evaluación Básica de Riesgos Ergonómicos (B.E.R.A.)',
	'General informations': 'Informaciones Generales',
	'General view': 'Vista general',
	'Insert below the informations for the cycle': 'Inserte a continuación las informaciones para el ciclo',
	Organization: 'Organización',
	'Operator evaluated': 'Operador evaluado',
	'Enter a report name': 'Ingrese un nombre de informe',
	'Enter a evaluator': 'Ingrese un evaluador',
	'Work center': 'Centro de trabajo',
	Evaluator: 'Evaluador',
	'Select below the video files referring to the tasks that make up the cycle':
		'Seleccione los archivos de video que se refieren a las tareas que componen el ciclo',
	Task: 'Tarea',
	'Insert below the informations related to the selected video':
		'Inserte a continuación las informaciones relacionadas con el video seleccionado',
	'Task list ID (TLID)': 'ID de lista de tareas (TLID)',
	'Task time': 'Tiempo de tarea',
	'Has known injury?': '¿Ha tenido lesiones conocidas?',
	'There is no presence of "Too High" movements': 'No hay presencia de movimientos "Muy Alto"',
	'Too High': 'Muy Alto',
	'Job element': 'Elemento de trabajo',
	'Insert job element': 'Insertar elemento de trabajo',
	'Total task duration': 'Duración total de la tarea',
	'Select the task': 'Seleccione la tarea',
	'Insert a task duration': 'Inserte la duración de una tarea',
	'Elbow to Shoulder - 1075 to 1425 mm (42.2 to 56 in)': 'Codo a Hombro - 1075 a 1425 mm (42.2 a 56 pulgadas)',
	'Shoulder to top of head  > 60 deg shoulder flex - 1425 to 1730 mm (56 to 68 in)':
		'Hombro a parte superior de la cabeza > 60 grados de flexión del hombro - 1425 a 1730 mm (56 a 68 pulgadas)',
	'Overhead work - >  1730 mm (> 68 in)': 'Trabalho acima da cabeça - > 1730 mm (> 68 pol.)',
	'1 per task': '1 por tarea',
	'1 per minute': '1 por minuto',
	'2 per minute': '2 por minuto',
	'>2 per minute': '>2 por minuto',
	'<10% of Task': '<10% de la tarea',
	'<25% of Task': '<25% de la tarea',
	'<33% of Task': '<33% de la tarea',
	'<50% of Task': '<50% de la tarea',
	'>50% of Task': '>50% de la tarea',
	'Too Low': 'Muy Bajo',
	'There is no presence of "Too Low" movements': 'No hay presencia de movimientos "Muy Bajo"',
	'Elbow to standing grip - 1075 to 800 mm (42.2 to 31.3 in)':
		'Codo al agarre de pie - 1075 a 800 mm (42.2 a 31.3 pulgadas)',
	'Grip to knee - 800 to 550 mm (31.3 to 21.8 in)': 'Agarre a la rodilla - 800 a 550 mm (31.3 a 21.8 pulgadas)',
	'Below knee - < 550 mm (<21.8 in)': 'Debajo de la rodilla - < 550 mm (<21.8 pulgadas)',
	'Well Below Knee <255 mm (<10 in)': 'Muy por debajo de la rodilla <255 mm (<10 pulgadas)',
	'Too Far': 'Muy Lejos',
	'There is no presence of "Too Far" movements': 'No hay presencia de movimientos "Muy Lejos"',
	'<300 mm (<12 inches) in front of body': '<300 mm (<12 pulgadas) frente al cuerpo',
	'300<460 mm (12<18 inches) in front of body': '300<460 mm (12<18 pulgadas) frente al cuerpo',
	'460<610 mm (18<24 inches) in front of body': '460<610 mm (18<24 pulgadas) frente al cuerpo',
	'610<915 mm (24<36 inches) in front of body': '610<915 mm (24<36 pulgadas) frente al cuerpo',
	'>915 mm (>36 inches) in front of body': '>915 mm (>36 pulgadas) frente al cuerpo',
	'Select the stress level': 'Seleccione el nivel de estrés',
	'Select the frequency': 'Seleccione la frecuencia',
	'Select the total task duration': 'Seleccione la duración total de la tarea',
	'Too Many': 'Muchas veces',
	'There is no presence of "Too Many" movements': 'No hay presencia de movimientos "Muchas veces"',
	'Striking parts': 'Ajuste de piezas',
	'Hand activities': 'Actividades manuales',
	'Small hammer (<.2 kg, <.3 lb)': 'Martillo pequeño (<.2 kg, <.3 lb)',
	'Mallet Use (< 1 kg, < 2.2 lb)': 'Uso de maza (< 1 kg, < 2.2 lb)',
	'Using hand as a hammer': 'Usar mano como martillo',
	'Hammer Use (< 1 kg, < 2.2 lb)': 'Uso de martillo (< 1 kg, < 2.2 lb)',
	'Sledge Hammer Use (> 2 kg, >4.5 lb)': 'Uso de martillo grande (> 2 kg, >4.5 lb)',
	'Light tap 1/cycle': 'Golpe ligero 1/ciclo',
	'<10 per hour': '<10 por hora',
	'>10 per hour': '>10 por hora',
	'>20 per hour': '>20 por hora',
	'>30 per hour': '>30 por hora',
	'Populate using tool': 'Realizar usando herramienta',
	'Job Strain Index <3': 'Índice de Tensión Laboral <3',
	'Job Strain Index 3-5': 'Índice de Tensión Laboral 3-5',
	'Job Strain Index 5-7': 'Índice de Tensión Laboral 5-7',
	'Job Strain Index 7-12': 'Índice de Tensión Laboral 7-12',
	'Job Strain Index >12': 'Índice de Tensión Laboral >12',
	'Select at least one option.': 'Seleccione al menos una opción.',
	'Too Much': 'Muy pesado',
	'There is no presence of "Too Much" movements': 'No hay presencia de movimientos "Muy pesado"',
	Lifting: 'Levantamiento',
	'Push/Pull One Hand': 'Empujar/Tirar con una mano',
	'Push/Pull Two Hand': 'Empujar/Tirar con ambas manos',
	'Push/Pull Cart': 'Empujar/Tirar de un carrito',
	'Tool Weight <2.3 kg (<5 lb)': 'Peso de la herramienta <2.3 kg (<5 lb)',
	'Tool Weight >4.5 kg (>10 lb)': 'Peso de la herramienta >4.5 kg (>10 lb)',
	'Tool Weight >7 kg (>15 lb)': 'Peso de la herramienta >7 kg (>15 lb)',
	'Tool Weight >9 kg (>20 lb)': 'Peso de la herramienta >9 kg (>20 lb)',
	'Tool Weight >11.3 kg (>25 lb)': 'Peso de la herramienta >11.3 kg (>25 lb)',
	'Two hand force <6 kg (<13 lb)': 'Fuerza con ambas manos <6 kg (<13 lb)',
	'Two hand force >6 kg (>13 lb)': 'Fuerza con ambas manos >6 kg (>13 lb)',
	'Two hand force >10 kg (>22 lb)': 'Fuerza con ambas manos >10 kg (>22 lb)',
	'Two hand force >15 kg (>33 lb)': 'Fuerza con ambas manos >15 kg (>33 lb)',
	'Two hand force >18 kg (>40 lb)': 'Fuerza con ambas manos >18 kg (>40 lb)',
	'Cart Push/Pull Initial <23 kg (< 50lb)': 'Empujar/Tirar del carrito inicial <23 kg (< 50 lb)',
	'Cart Push/Pull Initial >23 kg (> 50lb)': 'Empujar/Tirar del carrito inicial >23 kg (> 50 lb)',
	'Cart Push/Pull Initial >29.5 kg (> 65lb)': 'Empujar/Tirar del carrito inicial >29.5 kg (> 65 lb)',
	'Cart Push/Pull Initial >34 kg (>75 lb)': 'Empujar/Tirar del carrito inicial >34 kg (>75 lb)',
	'No noticeable vibration': 'No hay vibración perceptible',
	'Slight hand vibration': 'Ligera vibración en la mano',
	'Noticeable vibration of hand': 'Vibración perceptible en la mano',
	'Vibration in arm': 'Vibración en el brazo',
	'Too Long': 'Muy Largo',
	'There is no presence of "Too Long" movements': 'No hay presencia de movimientos "Muy Largos"',
	'Inadequate Clearance': 'Espacio insuficiente',
	'Contact Stress': 'Estrés de contacto',
	'Limited Hand Clearance': 'Espacio limitado para la mano',
	'Limited Whole Body Clearance': 'Espacio limitado para todo el cuerpo',
	'Limited Finger Clearance': 'Espacio limitado para los dedos',
	'Limited Arm Clearance': 'Espacio limitado para el brazo',
	'Limited Hand Clearance with Part': 'Espacio limitado para la mano con pieza',
	'Contact Stress <20 sec': 'Estrés de contacto <20 seg',
	'Contact Stress >20 sec': 'Estrés de contacto >20 seg',
	Severity: 'Severidad',
	Vulnerability: 'Probabilidad',
	'Risk Priority Number (RPN)': 'Número de Prioridad de Riesgo (NPR)',
	'Collection Date': 'Fecha de recolección',
	'Known injuries': 'Lesiones conocidas',
	'Has no injury history': 'No tiene historial de lesiones',
	'Has known injury': 'Tiene lesiones conocidas',
	'Last update': 'Última actualización',
	'Show reports': 'Mostrar informes',
	'Hide reports': 'Esconder',
	'Create B.E.R.A. report': 'Crear informe de B.E.R.A.',
	'Total evaluated time': 'Tiempo total evaluado',
	'Weighted RSI': 'RSI Ponderado',
	'Weighted RPN': 'RPN Ponderado',
	'Tasks analyzed': 'Tareas analizadas',
	'Cycle summary': 'Resumen del ciclo',
	'Risk Factors': 'Factores de riesgo',
	'Highest RPN': 'NPR más alto',
	'Five highest RPNs': 'Cinco RPN más altos',
	'Highest Risk Factors': 'Mayores factores de riesgo',
	'B.E.R.A. Result': 'Resultado B.E.R.A.',
	'ENS Result': 'Resultado ENS',
	'RPN Score': 'RPN',
	Position: 'Posición',
	'Task RPN': 'RPN de la tarea',
	'Greater than': 'Mayor que',
	'Greater than or equal': 'Mayor o igual',
	'Less than': 'Menos que',
	'Less than or equal': 'Menor o igual',
	Between: 'Entre',
	Maximum: 'Máximo',
	Minimum: 'Mínimo',
	'Search by file name...': 'Buscar por nombre de archivo...',
	'Select at least one file': 'Seleccione al menos un archivo',
	Seconds: 'Segundos',
	'Finish B.E.R.A.': 'Finalizar B.E.R.A.',
	'Consolidate report': 'Consolidar el informe',
	'Report updated successfully': 'Informe actualizado correctamente',
	'B.E.R.A. deleted successfully': 'B.E.R.A. eliminado con éxito',
	'B.E.R.A. report deleted successfully': 'Relatório B.E.R.A. eliminado con éxito',
	Uncertain: 'Incierto',
	'Some risk': 'Algo de riesgo',
	Extreme: 'Extremo',

	// S.E.R.A. Report
	'Safety Ergonomic Risk Assessment (S.E.R.A.)': 'Evaluación de Riesgos Ergonómicos de Seguridad (S.E.R.A.)',
	'Ergonomic - Biomechanical': 'Ergonómico - Biomecánico',
	'Ergonomic - Furniture and equipment': 'Ergonómico - Mobiliario y equipamiento',
	'Ergonomic - Organizational': 'Ergonómico - Organizacional',
	'Ergonomic - Environmental': 'Ergonómico - Ambiental',
	'Ergonomic - Psychosocial and cognitive': 'Ergonómico - Psicosocial y cognitivo',
	'Working in awkward or uncomfortable postures for long periods':
		'Trabajar en posturas incómodas o poco ergonómicas durante largos períodos',
	'Sitting posture for long periods': 'Postura sentada durante largos períodos',
	'Standing posture for long periods': 'Postura de pie durante largos períodos',
	'Frequent commuting on foot during the workday': 'Desplazamiento frecuente a pie durante la jornada laboral',
	'Work with intense physical exertion': 'Trabajo con esfuerzo físico intenso',
	'Lifting and manual transport of loads or volumes': 'Levantamiento y transporte manual de cargas o volúmenes',
	'Frequent pulling/pushing of loads or packages': 'Tirar/empujar cargas o paquetes con frecuencia',
	'Frequent execution of repetitive movements': 'Ejecución frecuente de movimientos repetitivos',
	'Handling tools and/or heavy objects for long periods':
		'Manipulación de herramientas y/o objetos pesados durante largos períodos',
	'Adoption of unnecessary and inappropriate postures and movements.':
		'Adopción de posturas y movimientos innecesarios e inapropiados.',
	'Mental/physical exhaustion and psychiatric disorders': 'Agotamiento mental/físico y trastornos psiquiátricos',
	'Discomfort in upper/lower limbs and spine':
		'Incomodidad en extremidades superiores/inferiores y columna vertebral',
	'Accidents, low performance': 'Accidentes, bajo rendimiento',
	'Accidents, physical or mental exhaustion': 'Accidentes, agotamiento físico o mental',
	'Physical discomforts': 'Molestias físicas',
	'Musculoskeletal disorders in the upper limbs': 'Trastornos musculoesqueléticos en las extremidades superiores',
	'Exposure to localized vibrations (hand-arm) below action level':
		'Exposición a vibraciones localizadas (mano-brazo) por debajo del nivel de acción',
	'Exposure to localized vibrations (hand-arm) at action level':
		'Exposición a vibraciones localizadas (mano-brazo) en el nivel de acción',
	'Exposure to whole-body vibration below action level':
		'Exposición a vibración de cuerpo entero por debajo del nivel de acción',
	'Exposure to localized vibrations (hand-arm) above the tolerance limit':
		'Exposición a vibraciones localizadas (mano-brazo) 	por encima del límite de tolerancia',
	'Exposure to whole-body vibration above the tolerance limit':
		'Exposición a vibración de cuerpo entero por encima del límite de tolerancia',
	'Exposure to whole-body vibration at action level': 'Exposición a vibración de cuerpo entero en el nivel de acción',
	'Stumbles, falls': 'Tropezones, caídas',
	'Reflections, glare': 'Reflejos, deslumbramiento',
	'Visualization impairment': 'Impedimento de la visualización',
	'Low back pain': 'Dolor lumbar',
	'Irritation of structures (tendons, ligaments and nerves) causing musculoskeletal disorders':
		'Irritación de estructuras (tendones, ligamentos y nervios) que causa trastornos musculoesqueléticos',
	'Excessive caloric expenditure, development of musculoskeletal disorders':
		'Gasto calórico excesivo, desarrollo de trastornos musculoesqueléticos',
	'Fatigue, risk of falls': 'Fatiga, riesgo de caídas',
	'Fatigue in the legs and development of vascular disorders':
		'Fatiga en las piernas y desarrollo de trastornos vasculares',
	'Fatigue in lower limbs': 'Fatiga en las extremidades inferiores',
	'Mental exhaustion and psychiatric disorders': 'Agotamiento mental y trastornos psiquiátricos',
	'Requiring frequent use of force, pressure, gripping, flexion, extension, or twisting of body segments':
		'Requiere el uso frecuente de fuerza, presión, agarre, flexión, extensión o torsión de segmentos corporales',
	'Compression of body parts by hard or cornered surfaces':
		'Compresión de partes del cuerpo por superficies duras o con esquinas',
	'Requiring frequent spinal flexions': 'Requiere flexiones frecuentes de la columna vertebral',
	'Frequent use of pedals': 'Uso frecuente de pedales',
	'Frequent use of levers': 'Uso frecuente de palancas',
	'Demand for frequent lifting of upper limbs': 'Requiere levantar frecuentemente los miembros superiores',
	'Handling or moving loads and volumes without a handle or with a “poor handle”':
		'Manipulación o movimiento de cargas y volúmenes sin asa o con una "asa deficiente"',
	'Whole body vibration exposure': 'Exposición a vibraciones de cuerpo completo',
	'Exposure to localized vibrations (hand-arm)': 'Exposición a vibraciones localizadas (mano-brazo)',
	'Frequent use of stairs': 'Uso frecuente de escaleras',
	'Makeshift workstation': 'Puesto de trabajo improvisado',
	'Unplanned/Unadapted workstation for sitting position':
		'Puesto de trabajo no planificado/no adaptado para posición sentada',
	'Inappropriate seat': 'Asiento inadecuado',
	'Improper or missing seat backrest': 'Respaldo del asiento inadecuado o ausente',
	'Furniture or equipment without space to move body segments':
		'Muebles o equipos sin espacio para mover los segmentos corporales',
	'Work performed without predefined rest breaks': 'Trabajo realizado sin pausas predefinidas para descanso',
	'Need to maintain intense work rhythms': 'Necesidad de mantener ritmos de trabajo intensos',
	'Work with need for shift variation': 'Trabajo con necesidad de variación de turnos',
	Monotony: 'Monotonía',
	'Night work': 'Trabajo nocturno',
	'Insufficient training to perform the task': 'Formación insuficiente para realizar la tarea',
	'Work with strict use of production targets': 'Trabajo con uso estricto de objetivos de producción',
	'Work paid by production': 'Trabajo remunerado por producción',
	'Work cadence imposed by a piece of equipment': 'Cadencia de trabajo impuesta por una pieza de equipo',
	'Imbalance between work time and rest time': 'Desbalance entre tiempo de trabajo y tiempo de descanso',
	'Working conditions with sound pressure levels outside comfort parameters':
		'Condiciones de trabajo con niveles de presión sonora fuera de los parámetros de comodidad',
	'Working conditions with effective temperature index outside the comfort parameters':
		'Condiciones de trabajo con índice de temperatura efectiva fuera de los parámetros de comodidad',
	'Working conditions with air speed outside comfort parameters':
		'Condiciones de trabajo con velocidad del aire fuera de los parámetros de comodidad',
	'Working conditions with air humidity outside comfort parameters':
		'Condiciones de trabajo con humedad del aire fuera de los parámetros de comodidad',
	'Working conditions with inadequate daytime lighting': 'Condiciones de trabajo con iluminación diurna inadecuada',
	'Working conditions with inadequate night lighting': 'Condiciones de trabajo con iluminación nocturna inadecuada',
	'Presence of reflections on screens, panels, glass, monitors or any surface':
		'Presencia de reflejos en pantallas, paneles, vidrio, monitores o cualquier superficie',
	'Slippery and/or uneven floor': 'Suelo resbaladizo y/o irregular',
	'Excessive stressful situations': 'Situaciones de estrés excesivo',
	'Situations of mental work overload': 'Situaciones de sobrecarga de trabajo mental',
	'Requiring a high level of concentration, attention and memory':
		'Requiere un alto nivel de concentración, atención y memoria',
	'Working in conditions of difficult communication': 'Trabajar en condiciones de comunicación difícil',
	'Excessive hierarchical conflicts at work': 'Conflictos jerárquicos excesivos en el trabajo',
	'Excessive emotional/affective demands at work': 'Demandas emocionales/afectivas excesivas en el trabajo',
	'Harassment of any nature at work': 'Acoso de cualquier naturaleza en el trabajo',
	'Work with divergent demands (divergent orders, mutually incompatible goals, demand for quality X quantity, among others)':
		'Trabajar con demandas divergentes (órdenes divergentes, metas mutuamente incompatibles, demanda de calidad X cantidad, entre otros)',
	'Job dissatisfaction': 'Insatisfacción laboral',
	'Lack of autonomy at work': 'Falta de autonomía en el trabajo',
	'Accidents and physical discomforts': 'Accidentes y molestias físicas',
	'Low performance': 'Bajo rendimiento',
	'Physical or mental exhaustion': 'Agotamiento físico o mental',
	'Adoption of inappropriate postures and movements': 'Adopción de posturas y movimientos inapropiados',
	'Alteration in the circadian cycle, sleep disorders': 'Alteración en el ciclo circadiano, trastornos del sueño',
	'Low visibility': 'Baja visibilidad',
	'Compression of structures (tissues, tendons, ligaments and nerves) causing musculoskeletal disorders':
		'Compresión de estructuras (tejidos, tendones, ligamentos y nervios) que causan trastornos musculoesqueléticos',
	Discomfort: 'Incomodidad',
	'Discomfort in lower limbs (legs and feet)': 'Incomodidad en las extremidades inferiores (piernas y pies)',
	'Discomfort in upper limbs (arms and hands)': 'Incomodidad en las extremidades superiores (brazos y manos)',
	'Discomfort in upper limbs and spine': 'Incomodidad en las extremidades superiores y la columna vertebral',
	'Discomfort in the spine': 'Incomodidad en la columna vertebral',
	'Discomfort in the lower limbs and spine': 'Incomodidad en las extremidades inferiores y la columna vertebral',
	'Development of musculoskeletal disorders': 'Desarrollo de trastornos musculoesqueléticos',
	'Difficulty concentrating, irritability': 'Dificultad para concentrarse, irritabilidad',
	'Balance disorders, headache': 'Trastornos del equilibrio, dolor de cabeza',
	'Musculoskeletal disorders in the upper limbs (Repetitive Strain Injury)':
		'Trastornos musculoesqueléticos en las extremidades superiores (Lesión por Esfuerzo Repetitivo)',
	'Musculoskeletal disorders in the spine': 'Trastornos musculoesqueléticos en la columna vertebral',
	'Musculoskeletal disorders': 'Trastornos musculoesqueléticos',
	'Muscle fatigue and development of musculoskeletal disorders':
		'Fatiga muscular y desarrollo de trastornos musculoesqueléticos',
	'Mental exhaustion': 'Agotamiento mental',
	'Requirement to perform multiple tasks, with high cognitive demand':
		'Requerimiento de realizar múltiples tareas, con alta demanda cognitiva',
	'Trabajo con demandas divergentes (órdenes divergentes, metas mutuamente incompatibles, demanda de calidad X cantidad, entre otras)':
		'Trabajo con demandas divergentes (órdenes divergentes, metas mutuamente incompatibles, demanda de calidad X cantidad, entre otras)',
	'Trabajo realizado sin pausas predefinidas para descanso':
		'Trabajo realizado sin pausas predefinidas para descanso',
	"Equipment or furniture not adapted to the worker's anthropometry":
		'Equipos o mobiliario no adaptados a la antropometría del trabajador',
	'Work with the need to reach objects, documents, controls or any point beyond the ideal reach zones for the anthropometric characteristics of the worker':
		'Trabajo con la necesidad de alcanzar objetos, documentos, controles o cualquier punto más allá de las zonas de alcance ideales para las características antropométricas del trabajador',
	'Equipment and/or machines without regulation means or without conditions of use':
		'Equipos y/o máquinas sin medios de regulación o sin condiciones de uso',
	'Furniture without regulation means of adjustment': 'Muebles sin medios de regulación de ajuste',
	'Intensive work with a keyboard or other input devices':
		'Trabajo intensivo con un teclado u otros dispositivos de entrada',
	'Requiring frequent lifting of upper limbs':
		'Requiere levantamiento frecuente de miembros superiores por encima del hombro',
	'1% to 10% of the cycle': '1% al 10% del ciclo',
	'11% to 20% of the cycle': '11% al 20% del ciclo',
	'21% to 30% of the cycle': '21% al 30% del ciclo',
	'31% to 50% of the cycle': '31% al 50% del ciclo',
	'51% to 75% of the cycle': '51% al 75% del ciclo',
	'76% to 100% of the cycle': '76% al 100% del ciclo',
	'[1] 1% to 10% of the cycle': '[1] 1% al 10% del ciclo',
	'[2] 11% to 20% of the cycle': '[2] 11% al 20% del ciclo',
	'[3] 21% to 30% of the cycle': '[3] 21% al 30% del ciclo',
	'[4] 31% to 50% of the cycle': '[4] 31% al 50% del ciclo',
	'[5] 51% to 75% of the cycle': '[5] 51% al 75% del ciclo',
	'[6] 76% to 100% of the cycle': '[6] 76% al 100% del ciclo',
	'Muscle fatigue/Discomfort': 'Fatiga muscular/Desconforto',
	'First aid': 'Primeros auxilios',
	'Recordable injury': 'Historial de lesiones',
	'Recordable with surgery or restrictions': 'Historial con cirugía o restricciones',
	'Lost time - Missed work due to injury and/or hospitalization':
		'Tiempo perdido - Ausencia laboral debido a lesión y/o hospitalización',
	'Fadiga muscular/desconforto': 'Fatiga muscular/incomodidad',
	'Primeiro socorro': 'Primeros auxilios',
	'Histórico de lesão': 'Historial de lesiones',
	'Histórico com cirurgia ou restrições': 'Historial con cirugía o restricciones',
	Fatality: 'Fatalidad',
	'[1] Muscle fatigue/Discomfort': '[1] Fatiga muscular/Desconfort',
	'[2] First aid': '[2] Primeros auxilios',
	'[3] Recordable injury': '[3] Historial de lesiones',
	'[4] Recordable with surgery or restrictions': '[4] Historial con cirugía o restricciones',
	'[5] Lost time - Missed work due to injury and/or hospitalization':
		'[5] Tiempo perdido - Ausencia laboral debido a lesión y/o hospitalización',
	'[6] Fatality': '[6] Fatalidad',
	'Unlikely (never happened and there is no possibility)': 'Poco probable (nunca ha sucedido y no hay posibilidad)',
	'Remote (there is a possibility of this occurring once during the useful life of the equipment)':
		'Remoto (existe la posibilidad de que esto ocurra una vez durante la vida útil del equipo)',
	'Occasional (there is a possibility of this occurring more than once during the useful life of the equipment)':
		'Ocasional (existe la posibilidad de que esto ocurra más de una vez durante la vida útil del equipo)',
	'Likely (there is already a record and there is the possibility of occurring 1 to 12 times a year)':
		'Probable (ya hay un registro y existe la posibilidad de que ocurra de 1 a 12 veces al año)',
	'Frequent (there is already a registration and there is the possibility of occurring more than once a month)':
		'Frecuente (ya hay un registro y existe la posibilidad de que ocurra más de una vez al mes)',
	'Certainly (there is already a record and there is the possibility of occurring daily)':
		'Seguro (ya hay un registro y existe la posibilidad de que ocurra a diario)',
	'[1] Unlikely (never happened and there is no possibility)':
		'[1] Poco probable (nunca ha sucedido y no hay posibilidad)',
	'[2] Remote (there is a possibility of this occurring once during the useful life of the equipment)':
		'[2] Remoto (existe la posibilidad de que esto ocurra una vez durante la vida útil del equipo)',
	'[3] Occasional (there is a possibility of this occurring more than once during the useful life of the equipment)':
		'[3] Ocasional (existe la posibilidad de que esto ocurra más de una vez durante la vida útil del equipo)',
	'[4] Likely (there is already a record and there is the possibility of occurring 1 to 12 times a year)':
		'[4] Probable (ya hay un registro y existe la posibilidad de que ocurra de 1 a 12 veces al año)',
	'[5] Frequent (there is already a registration and there is the possibility of occurring more than once a month)':
		'[5] Frecuente (ya hay un registro y existe la posibilidad de que ocurra más de una vez al mes)',
	'[6] Certainly (there is already a record and there is the possibility of occurring daily)':
		'[6] Seguro (ya hay un registro y existe la posibilidad de que ocurra a diario)',
	'[1] Unlikely': '[1] Poco probable',
	'[2] Remote': '[2] Remoto',
	'[3] Occasional': '[3] Ocasional',
	'[4] Likely': '[4] Probable',
	'[5] Frequent': '[5] Frecuente',
	'[6] Certainly': '[6] Seguro',
	'Reports status': 'Estado de informes',
	Uncompleted: 'No completado',
	'Show only uncompleted reports': 'Mostrar solo informes no completados',
	'Show only completed reports': 'Mostrar solo informes completados',
	'Show only reviewed reports': 'Mostrar solo informes revisados',
	'Created date': 'Fecha de creación',
	'Reviewed date': 'Fecha de revisión',
	'Task review': 'Revisión de tareas',
	'Select tasks below to review': 'Seleccione las tareas siguientes para revisarlas',
	'Review each task below': 'Revisar cada tarea a continuación',
	'Add report': 'Agregar informe',
	Specifications: 'Especificaciones',
	Specification: 'Especificación',
	'Existing prevention measures': 'Medidas de prevención existentes',
	Category: 'Categoría',
	'Select the category': 'Seleccionar la categoría',
	'Risk description': 'Descripción del riesgo',
	'Total risk descriptions': 'Descripciones de riesgos totales',
	'Select the description': 'Seleccionar la descripción',
	Damage: 'Daño',
	'Select the damage': 'Seleccionar el daño',
	'Select the evaluator': 'Seleccionar el evaluador',
	'Select the exposure': 'Seleccionar la exposición',
	'Select the vulnerability': 'Seleccionar la vulnerabilidad',
	'Select the severity': 'Seleccionar la severidad',
	'Select a severity': 'Seleccionar la severidad',
	'How many times is the operator exposed to risk in the work cycle?':
		'¿Cuántas veces está expuesto el operador al riesgo en el ciclo de trabajo?',
	'What is the probability of an incident happening?': '¿Cuál es la probabilidad de que ocurra un incidente?',
	'How severe could the injury be?': '¿Qué tan grave podría ser la lesión?',
	Edit: 'Editar',
	'Create review': 'Crear revisión',
	'Cycle results': 'Resultados del ciclo',
	Version: 'Versión',
	Review: 'Revisión',
	'Result S.E.R.A.': 'Resultado S.E.R.A.',
	'Original version date': 'Fecha de la versión original',
	'Last review': 'Última revisión',
	'Analyzed reports': 'Informes analizados',
	'Reviewed reports': 'Informes revisados',
	'Original version sum of RPN': 'Suma de RPN de la versión original',
	'Sum of RPN': 'Suma de RPN',
	'Average RPN': 'RPN promedio',
	'Analyzed tasks': 'Tareas analizadas',
	'Reviewed at': 'Revisado en',
	'Review date': 'Fecha de revisión',
	'RPN and Priority': 'RPN y Prioridad',
	Priority: 'Prioridad',
	'Create S.E.R.A. report': 'Crear informe S.E.R.A.',
	'Go back to files selection': 'Volver a la selección de archivos',
	'Action plans list': 'Lista de planes de acción',
	'S.E.R.A. action plans': 'Planes de acción S.E.R.A.',
	'Add action plan': 'Agregar plan de acción',
	'General history': 'Historial general',
	'Tasks summary': 'Resumen de tareas',
	'Reviews history': 'Historial de revisiones',
	'Changed field': 'Campo cambiado',
	'Original value': 'Valor original',
	'Reviewed value': 'Valor revisado',
	Reviewer: 'Crítico',
	Reviewed: 'Revisado',
	Hide: 'Ocultar',
	Show: 'Mostrar',
	'Unlikely (never happened and there is no possibility) [1]':
		'Poco probable (nunca ha sucedido y no hay posibilidad) [1]',
	'Remote (there is a possibility of this occurring once during the useful life of the equipment) [2]':
		'Remoto (existe la posibilidad de que esto ocurra una vez durante la vida útil del equipo) [2]',
	'Occasional (there is a possibility of this occurring more than once during the useful life of the equipment) [3]':
		'Ocasional (existe la posibilidad de que esto ocurra más de una vez durante la vida útil del equipo) [3]',
	'Likely (there is already a record and there is the possibility of occurring 1 to 12 times a year) [4]':
		'Probable (ya hay un registro y existe la posibilidad de que ocurra de 1 a 12 veces al año) [4]',
	'Frequent (there is already a registration and there is the possibility of occurring more than once a month) [5]':
		'Frecuente (ya hay un registro y existe la posibilidad de que ocurra más de una vez al mes) [5]',
	'Certainly (there is already a record and there is the possibility of occurring daily) [6]':
		'Seguro (ya hay un registro y existe la posibilidad de que ocurra a diario) [6]',
	Choose: 'Elegir',
	'Next file': 'Siguiente archivo',
	'No fields were changed': 'No se cambiaron campos',
	'S.E.R.A. deleted successfully': 'S.E.R.A. eliminado con éxito',

	// Liberty Mutual
	'Go back to report list': 'Volver a la lista de informes',
	'Material Handling': 'Manipulación de Material',
	'Material handling': 'Manipulación de material',
	'Invalid request data': 'Datos de solicitud no válidos',
	'Liberty Mutual report created successfully!': '¡Informe Liberty Mutual creado exitosamente!',
	'Liberty Mutual report updated successfully!': '¡Informe Liberty Mutual actualizado exitosamente!',
	'Liberty Mutual task not found': 'Tarea de Liberty Mutual no encontrada',
	'Return to task list': 'Volver a la lista de tareas',
	'End hand height lower than start hand height. Should it be Lower task?':
		"Altura final de la mano inferior a la altura inicial de la mano. ¿Debería ser tarea 'Abaixar'?",
	'End hand height higher than start hand height. Should it be Lift task?':
		"Altura final de la mano superior a la altura inicial de la mano. ¿Debe ser tarea 'Levantar'?",
	'System of units not found': 'Sistema de unidades no encontrado',
	'Cannot be lower than start height': 'No puede ser inferior a la altura inicial',
	'Cannot be higher than start height': 'No puede ser superior a la altura inicial',
	Movements: 'Movimientos',
	'Individually evaluate the movements present in the task':
		'Evaluar individualmente los movimientos presentes en la tarea.',
	'Liberty mutual report created successfully!': '¡Informe Liberty Mutual creado exitosamente!',
	'Liberty mutual report updated successfully!': '¡Informe Liberty Mutual actualizado exitosamente!',
	'Liberty mutual task not found': 'Tarea de Liberty Mutual no encontrada',
	Lift: 'Levantar',
	Lifts: 'Levantamientos',
	lift: 'levantamiento',
	lifts: 'levantamientos',
	Lower: 'Bajar',
	Lowers: 'Bajamientos',
	lowers: 'bajamientos',
	lower: 'bajamiento',
	Push: 'Empujar',
	Pushes: 'Empujones',
	pushes: 'empujones',
	push: 'empujón',
	Pull: 'Tirar',
	Pulls: 'Tiradas',
	pulls: 'tiradas',
	pull: 'tirada',
	Carry: 'Cargar',
	Carries: 'Cargamentos',
	carries: 'cargamentos',
	carry: 'cargamento',
	'System of unit': 'Sistema de unidad',
	'Select the system of unit': 'Seleccione um sistema de unidad',
	'Select a system of unit': 'Seleccione um sistema de unidad',
	'Select the movement of the task being evaluated': 'Seleccione el movimiento de la tarea que se está evaluando',
	'Insert the fields data for the selected task': 'Inserte los datos de los campos para la tarea seleccionada',
	'Start hand height': 'Altura inicial de la mano',
	'End hand height': 'Altura final de la mano',
	'Start hand distance': 'Distancia inicial de la mano',
	'End hand distance': 'Distancia final de la mano',
	'Initial force': 'Fuerza inicial',
	'Sustained force': 'Fuerza sostenida',
	'Horizontal distance': 'Distancia horizontal',
	'Vertical hand height': 'Altura vertical de la mano',
	'Hand coupling': 'Acoplamiento de la mano',
	'Object weight': 'Peso del objeto',
	Weight: 'Peso',
	'Select an hand coupling': 'Seleccione un acoplamiento de mano',
	'Insert a start height': 'Inserte una altura inicial',
	'Insert an end height': 'Inserte una altura final',
	'Insert a start distance': 'Inserte una distancia inicial',
	'Insert an end distance': 'Inserte una distancia final',
	'Insert an object weight': 'Inserte un peso de objeto',
	'Insert a frequency value': 'Inserte un valor de frecuencia',
	'Select a frequency interval': 'Seleccione un intervalo de frecuencia',
	'Insert an initial force': 'Inserte una fuerza inicial',
	'Insert a sustained force': 'Inserte una fuerza sostenida',
	Initial: 'Inicial',
	Sustain: 'Sostenida',
	'Insert an horizontal distance': 'Inserte una distancia horizontal',
	'Insert a vertical hand height': 'Inserte una altura vertical de la mano',
	'Select a task': 'Seleccione una tarea',
	'per hour': 'por hora',
	hour: 'hora',
	'per minute': 'por minuto',
	per: 'por',
	'Video duration': 'Duración del video',
	'Assessment date': 'Fecha de evaluación',
	'Activity is safe for': 'Actividad es segura para',
	'Initial state': 'Estado inicial',
	'End state': 'Estado final',
	Displacement: 'Desplazamiento',
	Metric: 'Métrico',
	Imperial: 'Imperial',
	'Data entered for Start hand height and End hand height indicates that the task type is Lift, not Lower':
		'Los datos ingresados para la altura inicial de la mano y la altura final de la mano indican que el tipo de tarea es Levantar, no Bajar',
	'Data entered for Start hand height and End hand height indicates that the task type is Lower, not Lift':
		'Los datos ingresados para la altura inicial de la mano y la altura final de la mano indican que el tipo de tarea es Bajar, no Levantar',

	// API error messages
	'Internal Server Error': 'Error interno del servidor',
	'You are unauthorized to access the requested resource': 'No está autorizado a acceder al recurso solicitado',
	'Check the header parameters entered': 'Compruebe los parámetros de cabecera introducidos',
	'Range risk not found': 'Rango de riesgo no encontrado',
	'Failed to fetch risk tracks': 'No se han podido recuperar las pistas de riesgo',
	'Task not found': 'Tarea no encontrada',
	'Task already exists': 'La tarea ya existe',
	'Cycle not found': 'Ciclo no encontrado',
	'Cycle already exists': 'El ciclo ya existe',
	'Stress level not found': 'Nivel de estrés no encontrado',
	'Frequency not found': 'Frecuencia no encontrada',
	'Total task duration not found': 'Duración total de la tarea no encontrada',
	'Evaluator not found': 'Evaluador no encontrado',
	'Exposure not found': 'Exposición no encontrada',
	'Vulnerability not found': 'Vulnerabilidad no encontrada',
	'Severity not found': 'Severidad no encontrada',
	'Severity already set to this risk damage': 'Severidad ya establecida para este daño',
	'Custom report step key not found': 'No se ha encontrado la clave del paso del informe personalizado',
	'Custom report step not found': 'Paso de informe personalizado no encontrado',
	'Custom report not found': 'Informe personalizado no encontrado',
	'Bera step key result not found': 'Bera paso clave resultado no encontrado',
	'Bera step key result already exists': 'Bera paso clave resultado ya existe',
	'Bera weighted average not found': 'No se ha encontrado la media ponderada de Bera',
	'Bera weighted average already exists': 'La media ponderada de Bera ya existe',
	'Bera report not found': 'Informe Bera no encontrado',
	'Bera report already exists': 'El informe de Bera ya existe',
	'Bera job summary not found': 'Bera job summary no encontrado',
	'Bera job summary result not found': 'No se ha encontrado el resultado del resumen de empleo de Bera',
	'Bera job summary already exists': 'Ya existe el resumen de empleo de Bera',
	'Sera report not found': 'Informe Sera no encontrado',
	'Sera report already exists': 'El informe Sera ya existe',
	'Sera summary not found': 'No se ha encontrado el resumen de Sera',
	'Sera summary already exists': 'El resumen de Sera ya existe',
	'Sera summary review not found': 'No se ha encontrado el resumen de revisión de Sera',
	'Sera summary review already exists': 'Sera summary review ya existe',
	'Sector not found': 'Sector no encontrado',
	'Report data not found': 'No se han encontrado los datos del informe',
	'File not found': 'Archivo no encontrado',
	'Failed to read file': 'Error al leer el archivo',
	'Failed to save file': 'Error al guardar archivo',
	'Master user not found': 'Usuario maestro no encontrado',
	'Potential customer not found': 'Cliente potencial no encontrado',
	'Voucher not found': 'Vale no encontrado',
	'Invalid voucher': 'Vale no válido',
	'Invalid recurrence': 'Recurrencia no válida',
	'Plan not found': 'Plan no encontrado',
	'Plan already canceled': 'Plan ya cancelado',
	'Invalid subscription type': 'Tipo de suscripción no válido',
	'It is not possible to downgrade the annual plan': 'No es posible bajar de categoría el plan anual',
	'Failed to decode payload': 'Error al descodificar la carga útil',
	'Plan expiration date not found': 'Fecha de caducidad del plan no encontrada',
	'Document already registered': 'Documento ya registrado',
	'Failed to create user plan': 'Error al crear plan de usuario',
	'Maximum registered users': 'Número máximo de usuarios registrados',
	'Failed to create user': 'Error al crear usuario',
	'User already registered': 'Usuario ya registrado',
	'Organization not found': 'Empresa no encontrada',
	'Company not found': 'Planta industriale no encontrada',
	'Failed to create company': 'Error al crear empresa',
	'Failed to create a user permission': 'Error al crear un permiso de usuario',
	'Failed to send email': 'Error al enviar correo electrónico',
	'Failed to create storage bucket': 'Error al crear un bucket de almacenamiento',
	'Failed to upload file to storage': 'Error al cargar archivo en el almacenamiento',
	'Failed to download data': 'Error al descargar datos',
	'Failed to download file': 'No se pudo descargar el archivo',
	'Failed to delete file': 'Fallo al eliminar archivo',
	'Fail get information storage': 'Fallo al obtener información de almacenamiento',
	'Failed to store data': 'Fallo al almacenar datos',
	'File sent for download': 'Archivo enviado para descargar',
	'Reply queue communication failure': 'Fallo en la comunicación de la cola de respuesta',
	'Selected report not found': 'Informe seleccionado no encontradoencontrado',
	'Unauthorized requisition': 'Solicitud no autorizada',
	'Authorization header is missing': 'Falta la cabecera de autorización',
	'Failed to query the database': 'Error al consultar la base de datos',
	'Calculation per second not found': 'Cálculo por segundo no encontrado',
	'Business information not found': 'Información comercial no encontrada',
	'Worker self evaluation not found': 'No se ha encontrado la autoevaluación del trabajador',
	'Action plan not found': 'No se ha encontrado el plan de acción',
	'Failed to create an history': 'Error al crear un historial',
	'Already created action plan': 'Plan de acción ya creado',
	'Action plan task not found': 'No se ha encontrado la tarea del plan de acción',
	'Action plan history not found': 'No se ha encontrado el historial del plan de acción',
	'Preliminary analysis not found': 'Análisis preliminar no encontrado',
	'Default step not found': 'No se ha encontrado el paso por defecto',
	'Analysis step not found': 'No se ha encontrado el paso de análisis',
	'Probabilty analysis not found': 'Análisis de probabilidad no encontrado',
	'Consequence analysis not found': 'Análisis de consecuencias no encontrado',
	'Exhibition analysis not found': 'Análisis de exposición no encontrado',
	'Organization still has registered companies': 'La organización aún tiene empresas registradas',
	'Failed to create an organization': 'Error al crear una organización',
	'Workstation not found': 'Puesto de trabajo no encontrada',
	'Custom report result not found': 'Resultado de informe personalizado no encontrado',
	'Already created custom report result': 'Resultado de informe personalizado ya creado',
	'Custom report step key result not found': 'Resultado de clave de paso de informe personalizado no encontrado',
	'Already created custom report step key result': 'Resultado de clave de paso de informe personalizado ya creado',
	'Failed to create custom report step key result':
		'Error al crear el resultado de la clave de paso de informe personalizado',
	'Failed to update custom report step key result':
		'Error al actualizar el resultado de la clave de paso de informe personalizado',
	'Custom report step key additional item result not found':
		'Resultado de elemento adicional de clave de paso de informe personalizado no encontrado',
	'Failed to create custom report step key additional item result':
		'Error al crear el resultado de elemento adicional de clave de paso de informe personalizado',
	'Failed to update custom report step key additional item result':
		'Error al actualizar el resultado de elemento adicional de clave de paso de informe personalizado',
	'Work condition result not found': 'Resultado de condición de trabajo no encontrado',
	'Already created work condition result': 'Resultado de condición de trabajo ya creado',
	'Characteristic result not found': 'Resultado de característica no encontrado',
	'Already created characteristic result': 'Resultado de característica ya creado',
	'Custom report sub step key not found': 'Subclave de paso de informe personalizado no encontrada',
	'Corrupted video': 'Vídeo dañado',
	'Failed to read sent file': 'Error al leer el archivo enviado',
	'Failed to create download url': 'Error al crear URL de descarga',
	'File already queued': 'Archivo ya en cola',
	'File already processed': 'Archivo ya procesado',
	'Already registered user': 'Usuario ya registrado',
	'Failed to create customer plan': 'Error al crear el plan del cliente',
	'Failed to create customer transaction': 'Error al crear la transacción del cliente',
	'Customer transaction not found': 'Transacción del cliente no encontrada',
	'Customer transaction already completed': 'Transacción del cliente ya completada',
	'Product not found': 'Producto no encontrado',
	'Failed to create customer credits': 'Error al crear los créditos del cliente',
	'Processed minutes limit reached': 'Límite de minutos procesados alcanzado',
	'Invalid event': 'Evento no válido',
	'Not authorized': 'No autorizado',
	'Customer not found': 'Cliente no encontrado',
	'Unregistered customer': 'Cliente no registrado',
	'Already registered customer': 'Cliente ya registrado',
	'Failed to create customer': 'Error al crear el cliente',
	'Failed to update customer': 'Error al actualizar el cliente',
	'Report not found': 'Informe no encontrado',
	'Already created report': 'Informe ya creado',
	'Failed to create report': 'Error al crear el informe',
	'Failed to create report pdf': 'Error al crear el PDF del informe',
	'Failed to update report': 'Error al actualizar el informe',
	'Custom report additional item option not found':
		'Opción de elemento adicional de informe personalizado no encontrada',
	'Error calculating custom report additional item result':
		'Error al calcular el resultado de elemento adicional de informe personalizado',
	'Line not found': 'Línea no encontrada',
	'Failed to create file signature': 'Error al crear la firma del archivo',

	// Force Two-Factor
	'For security reasons, we need you to enable your two-factor validation':
		'Por razones de seguridad, necesitamos que habilites tu validación de dos factores',
	'Your company is requesting that all users have two-factor authentication enabled. Proceed to activate yours and login.':
		'Su empresa solicita que todos los usuarios tengan habilitada la autenticación de dos factores. Procede a activar el tuyo e inicie sesión.',
	Return: 'Volver',

	// Integrations
	'Continue with Microsoft SSO': 'Continuar con Microsoft SSO',
	Integrations: 'Integraciones',
	'Built-in user groups': 'Grupos de usuarios integrados',
	'Connect your Microsoft Azure AD users': 'Conecte a sus usuarios de Microsoft Azure AD',
	'Invitation sent': 'Invitación enviada',
	'Microsoft Azure Active Directory - Users': 'Microsoft Azure Active Directory - Usuarios',
	'Failed to load user groups': 'No se pudieron cargar los grupos de usuarios',
	'User removed successfully!': '¡El usuario se eliminó correctamente!',
	'Failed to remove user': 'No se pudo eliminar la usuario',
	'Do you want to remove the user': '¿Quieres eliminar a la usuaria?',
	'Failed to update user': 'Error al actualizar el usuario',
	'Failed to load information': 'No se pudo cargar la información',
	'Investigate and implement change': 'Investigar y aplicar cambios',
	'Implement changes': 'Implementar cambios',

	'To Do': 'Pendientes',
	'TO DO': 'PENDIENTES',
	Doing: 'En curso',
	DOING: 'EN CURSO',
	Done: 'Terminadas',
	DONE: 'TERMINADAS',
	Carriage: 'Carro',
	Barrow: 'Carretilla de mano',
	Conveyor: 'Cinta transportadora',
	Crane: 'Grúa',

	//EWA-JDS-D86
	'Ergonomic workplace analysis': 'Análisis ergonómico preliminar',
	'Select the right model for your analysis': 'Seleccione el modelo adecuado para su análisis',
	'Brazilian standard': 'Norma brasileña',
	'Brazilian standard and John Deere guidelines': 'Norma brasileña y directrices de John Deere',
	'International standard': 'Norma Internacional',
	'International standard and John Deere guidelines': 'Norma Internacional y directrices de John Deere',
	'ISO 20646': 'ISO 20646',
	'ISO 20646 + JDS-D86': 'ISO 20646 + JDS-D86',
	Unit: 'Unidad',
	'Evaluator name': 'Revisor',
	Interviewer: 'Entrevistador',
	'Interviewee name': 'Entrevistado',
	'Select the restrictions perceived in the evaluated working condition':
		'Seleccione las restricciones percibidas en las condiciones de trabajo evaluadas',
	'Summary description of the site': 'Descripción resumida del puesto',
	'Simplified description of the planned task': 'Descripción simplificada de la tarea prevista',
	'Particularities / Production / Working regime': 'Particularidades / Producción / Régimen laboral',
	'Select the Work schedule hours': 'Seleccione su horario de trabajo',
	'Select the Sector': 'Seleccione el sector',
	'Select the Unit': 'Seleccione la unidad',
	'Select the Line': 'Seleccione la línea',
	'Select the Collection date': 'Seleccione la fecha de recogida',
	'Select the Evaluator name': 'Seleccione el nombre del evaluador',
	'Workday and concentration': 'Jornada y concentración',
	'Risk Index:': 'Índice de Riesgo:',
	'Check the tool for conducting risk assessments': 'Compruebe la herramienta para realizar evaluaciones de riesgos',
	'Wrench length': 'Longitud de la llave (mm)',
	'Sum of RPNs': 'Suma de RPNs',
	'Higher RPNs': 'RPNs más altos',
	'Found at:': 'Encontrado en:',
	'Interviewer name': 'Nombre del entrevistador',
	'The movement is considered safe for': 'El movimiento se considera seguro para',
	'of man': 'de hombres',
	'of woman': 'de mujeres',
	Movement: 'Movimiento',
	'Movement by score (Kinebot/JDS)': 'Movimiento por puntaje (Kinebot/JDS)',
	'Tool type': 'Tipo de herramienta',
	'Movement type': 'Tipo de movimiento',
	Dimension: 'Dimensión',
	'Range zone': 'Zona de alcance',
	'Command range': 'Alcance de los comandos',
	'Target condition': 'Condición objetivo',
	'Conditionally acceptable': 'Condicionalmente aceptable',
	'Actions must be implemented': 'Las acciones deben implementarse',
	'Impact frequency': 'Frecuencia de impacto',
	'Evaluation necessary': 'Evaluación necesaria',
	'Evaluation not necessary': 'Evaluación no necesaria',
	'Select the items you want to present in your document':
		'Seleccione los elementos que desea presentar en su documento',
	'Criteria not evaluated': 'Criterios no evaluados',
	'Generate document': 'Generar documento',
	'Analysis not consolidated!': '¡Análisis no consolidado!',
	'If you continue, the filled-in data will be saved but not taken into account in your dashboard':
		'Si continúa, los datos completados se guardarán pero no se tendrán en cuenta en su panel de control',
	Proceed: 'Continuar',
	'Material Handling (Liberty Mutual)': 'Manipulación de material (Liberty Mutual)',
	Tools: 'Herramientas',
	Workday: 'Jornada laboral',
	'Influence of workspace': 'Influencia del espacio de trabajo',
	'Influence of environment': 'Influencia del entorno',
	"The risk assessment recommendation is based on the indicators in the JDS-92 guidelines. The color pattern follows the same pattern present in the document's tables.":
		'La recomendación de evaluación del riesgo se basa en los indicadores de las directrices JDS-92. El patrón de colores sigue el mismo patrón que las tablas del documento.',
	"The risk assessment recommendation is based on the indicators in the JDS-86 guidelines. The color pattern follows the same pattern present in the document's tables.":
		'La recomendación de evaluación del riesgo se basa en los indicadores de las directrices JDS-86. El patrón de colores sigue el mismo patrón que las tablas del documento.',
	'Not evaluated': 'No evaluado',
	'Use of one-handed manual wrench': 'Uso de llave manual con una sola mano',
	'Use of one-handed manual wrench with backup wrench': 'Uso de una llave manual de una mano con llave de apoyo',
	'Use of two-handed manual wrench': 'Uso de una llave manual de dos manos',
	'Using power tools': 'Uso de herramientas eléctricas',
	'Performs work that requires frequent finger, hand or arm movements':
		'Realiza trabajos que requieren frecuentes movimientos de los dedos, la mano o el brazo',
	'Using an impact device': 'Utiliza un dispositivo de impacto',
	'Viewing area': 'Área de visión',
	'Postural demands (JDS-D86)': 'Exigencias posturales (JDS-D86)',
	'Workstation involves seated work (fixed height)': 'Puesto de trabajo en el que se trabaja sentado (altura fija)',
	'Workstation involves seated work (adjustable station)':
		'Puesto de trabajo que implique trabajar sentado (altura regulable)',
	'Distances from controls or work surface are inadequate':
		'Las distancias a los mandos o a la superficie de trabajo son inadecuadas',
	'Workspace dimensions are too narrow': 'Las dimensiones del espacio de trabajo son demasiado estrechas',
	'The dimensions and clearances of the controls or work surface with the hands are inadequate':
		'Las dimensiones y distancias de los mandos o de la superficie de trabajo con las manos son inadecuadas',
	'Grip and hand strength': 'Fuerza de agarre y mano',
	'Standing arm strength forces': 'Fuerza de brazos de pie',
	'Hand-arm vibration exposure for 8 hours': 'Exposición durante 8 horas a vibraciones mano-brazo',
	'Hand-arm vibration exposure for': 'Exposición a vibraciones mano-brazo',
	'Contact with very hot or very cold surfaces': 'Contacto con superficies muy calientes o muy frías',
	'Exposure to hot or cold surfaces': 'Exposición a superficies calientes o frías',
	'Hammer Use (<.25 kg, <.5 lb)': 'Uso de martillo (<,25 kg, <,5 lb)',
	'Use of hammer/mallet (<1 kg, <2.2 lb)': 'Uso de martillo/mazo (<1 kg, <2,2 lb)',
	'Use of hammer/mallet (>1 kg, >2.2 lb)': 'Uso de martillo/mazo (>1 kg, >2,2 lb)',
	'Using hand for striking part': 'Uso de la mano para golpear la pieza',
	'Visual tasks >=10º above the horizontal line of the eye':
		'Tareas visuales ≥10º por encima de la línea horizontal del ojo',
	'Visual tasks 0º to 10º above the horizontal line of the eye':
		'Tareas visuales de 0º a 10º por encima de la línea horizontal del ojo',
	'Visual tasks 0º to 45º below the horizontal line of the eye':
		'Tareas visuales de 0º a 45º por debajo de la línea horizontal del ojo".',
	'Visual tasks 45º to 60º below the horizontal line of the eye':
		'Tareas visuales 45º a 60º por debajo de la línea horizontal del ojo',
	'Visual tasks >=60º below the horizontal line of the eye':
		'Tareas visuales ≥60º por debajo de la línea horizontal del ojo".',
	'Workstation height': 'Altura del puesto de trabajo',
	'Precision task height': 'Altura de las tareas de precisión',
	'Writing and light assembly task height': 'Altura de las tareas de escritura y montaje ligero',
	'Vertical height to the bottom of the work surface':
		'Altura vertical hasta la parte inferior de la superficie de trabajo',
	'Horizontal knee (depth) clearance': 'Distancia horizontal (profundidad) de las rodillas',
	'Horizontal knee width clearance': 'Distancia horizontal a la anchura de las rodillas',
	Horizontally: 'Horizontalmente',
	'Vertically for standing workstations': 'Verticalmente para puestos de trabajo de pie',
	'Vertically for seated workstations': 'Verticalmente para puestos de trabajo sentados',
	'Whole Body': 'Todo el cuerpo',
	'Head (least favorable position)': 'Cabeza (posición menos favorable)',
	Leg: 'Pierna',
	Foot: 'Pie',
	Arm: 'Brazo',
	'Hand, Wrist, Fist': 'Mano, muñeca, puño',
	Finger: 'Dedo',
	'One finger': 'Un dedo',
	'Two finger': 'Dos dedos',
	'Empty hand, flat': 'Mano vacía, plana',
	'Empty hand, thumb tucked': 'Mano vacía, pulgar metido',
	'Clenched hand, fist': 'Mano cerrada, puño',
	'Hand plus 25 mm (1 in) object': 'Mano más 25 mm (1 pulg.) de objeto".',
	'Hand plus X mm (in) object to wrist': 'Mano más X mm de objeto hasta la muñeca',
	'Arm to elbow': 'Brazo hasta el codo',
	'Arm to Shoulder': 'Brazo hasta el hombro',
	'Both Arms to Shoulder': 'Ambos brazos hasta el hombro',
	'Power grip force': 'Fuerza de agarre',
	'Power grip press': 'Fuerza de agarre',
	'Pinch grip': 'Agarre de pellizco',
	'Lateral pinch (key grip)': 'Agarre lateral (agarre de llave)',
	'Tip pinch grip': 'Agarre de punta',
	'Hook grip': 'Agarre de gancho',
	'Push with index finger': 'Empuje con el dedo índice',
	'Push with thumb': 'Empuje con el pulgar',
	'Wrist flexion or extension torque': 'Torsión de flexión o extensión de la muñeca',
	'Ulnar/Radial deviation': 'Desviación cubital/radial',
	Screwdriving: 'Atornillado',
	'Push-Pull 1 hand (knee to shoulder)': 'Empuje-Tire 1 mano (de rodilla a hombro)',
	'Push-Pull 1 hand (below knee or above shoulder)':
		'Empuje-Tire 1 mano (por debajo de la rodilla o por encima del hombro)',
	'Up-Down 1 hand (knee to shoulder)': 'Arriba-Abajo 1 mano (rodilla-hombro)',
	'Up-Down 1 hand (below knee or above shoulder)':
		'Arriba-Abajo 1 mano (por debajo de la rodilla o por encima del hombro)',
	'Push-Pull 2 hands (knee to shoulder)': 'Empuje-Tire 2 manos (rodilla-hombro)',
	'Push-Pull 2 hands (below knee or above shoulder)':
		'Empuje-Tire 2 manos (por debajo de la rodilla o por encima del hombro)',
	'Up-Down 2 hands (knee to shoulder)': 'Arriba-Abajo 2 manos (rodilla a hombro)',
	'Up-Down 2 hands (below knee or above shoulder)':
		'Up-Down 2 manos (por debajo de la rodilla o por encima del hombro)',
	'Lateral force 2 hands (between knee and shoulder)': 'Fuerza lateral 2 manos (entre rodilla y hombro)',
	'Lateral force 2 hands (above shoulder or below knee) ':
		'Fuerza lateral 2 manos (por encima del hombro o por debajo de la rodilla)',
	'Lateral force 1 hand (between knee and shoulder)': 'Fuerza lateral 1 mano (entre rodilla y hombro)',
	'Lateral force 1 hand (above shoulder or below knee)':
		'Fuerza lateral 1 mano (por encima del hombro o por debajo de la rodilla)',
	'Foot and leg force': 'Fuerza de pies y piernas',
	'Ladders and clamps': 'Escaleras y abrazaderas',
	'Ladder usage': 'Uso de escaleras',
	'Clamps usage': 'Uso de abrazaderas',
	'Ladder is validated against national standards (e.g., ISO, ANSI, ABNT)?':
		'¿La escalera está validada según normas nacionales (p. ej., ISO, ANSI, ABNT)?',
	'Is there non-occasional load handling (>9kg)?': '¿Hay manipulación de carga (>9kg) de forma no ocasional?',
	'Used for regular production activities (excluding short-duration tasks)?':
		'¿Se utiliza la escalera para actividades regulares de producción (excepto tareas de corta duración)?',
	'< 35N (< 8 lb)': '< 35N (< 8 lb)',
	'> 35N (> 8 lb)': '> 35N (> 8 lb)',
	'> 50N (> 11 lb)': '> 50N (> 11 lb)',
	'> 130N (> 30 lb)': '> 130N (> 30 lb)',
	'Foot-operated switch – standing, heel on floor':
		'Interruptor accionado con el pie – de pie, con el talón apoyado en el suelo',
	'Ankle pedal control, seated (accelerator)': 'Control de pedales con el tobillo, sentado (acelerador)',
	'Clutch and brake pedals – normal operation': 'Pedales de embrague y freno – operación normal',
	'Vertical movement': 'Movimiento vertical',
	'Lateral and longitudinal movement': 'Movimiento lateral y longitudinal',
	'Hand-arm Vibration A(eq) for 8-hr exposure': 'Vibración mano-brazo A(eq) para una exposición de 8 horas".',
	'Without gloves': 'Sin guantes',
	'Assembly gloves': 'Guantes de montaje',
	'Welding gloves': 'Guantes de soldadura',
	'Viewing area in relation to the horizontal line at eye level':
		'Área de visión en relación con la línea horizontal a la altura de los ojos',
	Height: 'Altura',
	Width: 'Anchura',
	Diameter: 'Diámetro',
	'Object dimension': 'Dimensión del objeto',
	'Reach zone': 'Zona de alcance',
	'Body part': 'Parte del cuerpo',
	'Minimum gap': 'Hueco mínimo',
	Criterion: 'Criterio',
	"Some required step wasn't filled": 'No se cumplimentó algún paso requerido',
	Unlikely: 'Poco probable',
	Remote: 'Remoto',
	Occasional: 'Ocasional',
	Likely: 'Probable',
	Frequent: 'Frecuente',
	Certainly: 'Seguro',
	'Muscle fatigue/discomfort or near-miss accident': 'Fatiga muscular/Desconfort ou o casi accidente',
	'No absence': 'Ninguna ausencia',
	'No absence with surgery or restriction': 'Ninguna ausencia con cirugía o restricción',
	'Absence - loss of work capacity and/or hospitalization':
		'Ausencia - pérdida de capacidad laboral y/o hospitalización',
	'>20 strikes per hour': '>20 golpes por hora',
	'<20 strikes per hour': '<20 golpes por hora',
	'>40 strikes per hour': '>40 golpes por hora',
	'1 strike per minute': '1 golpe por minuto',
	'<10 strikes per hour': '<10 golpes por hora',
	'2 strikes per minute': '2 golpes por minuto',
	'< 2 light taps for alignment': '< 2 golpes ligeros para alineación',
	'The action of pulling/pushing loads or volumes with great effort':
		'La acción de tirar/empujar cargas o volúmenes con gran esfuerzo',
	'Vision-guided tasks outside the primary viewing area (0° to 45°)':
		'Tareas guiadas por la visión fuera del área de visión primaria (0° a 45°)',
	'Standing for long periods': 'Estar de pie durante largos periodos',
	'Sitting for long periods (fixed height)': 'Sentado durante largos periodos (altura fija)',
	'Sitting for long periods (adjustable station)': 'Sentado durante largos periodos (puesto regulable)',
	'Exposure to whole-body vibration': 'Exposición a vibraciones de todo el cuerpo',
	'Musculoskeletal strain on wrists and elbows': 'Tensión musculoesquelética en muñecas y codos',
	'Development of musculoskeletal disorders and/or eye fatigue':
		'Desarrollo de trastornos musculoesqueléticos y/o fatiga ocular',

	// JDS D86
	'Ergonomic evaluation': 'Evaluación ergonómica',
	'Frequent motions': 'Movimientos frecuentes',
	'Excessive reaches': 'Alcances excesivos',
	'Lifting of heavy components and tools': 'Elevación de componentes pesados y herramientas',
	'Handling of bulky parts': 'Manipulación de partes voluminosas',
	'Heavy exertions to install parts': 'Esfuerzos pesados para instalar partes',
	'High forces to pull or push carts, baskets and containers':
		'Altas fuerzas para arrastrar o empujar carros, cestos y contenedores',
	'Contact stress': 'Estrés de contacto',
	'Sharp edges are present': 'Hay bordes afilados',
	'The noise level is very high': 'El nivel de ruido es muy alto',
	'Poor access or inadequate clearances': 'Acceso deficiente o huecos insuficientes',
	'Awkward or static postures': 'Posturas incómodas o estáticas',
	'Staying in a static posture for a long time': 'Mantenerse en una postura estática durante mucho tiempo',
	'Video selection': 'Selección de video',
	'Search for a file': 'Buscar un fichero',
	Revaluations: 'Revaluaciones',
	'Last revaluation': 'Última revaluación',
	'New revaluation': 'Nueva revaluación',
	Revaluation: 'Revaluación',
	'General History': 'Historial general',
	Crouching: 'Agachado',
	Kneeling: 'Arrodillado',
	Standing: 'Bipedestación',
	'Time per episode': 'Tiempo por episodio',
	'Frequency per hour': 'Frecuencia por hora',
	'Total time (in one day)': 'Tiempo total (en un día)',
	'Are you sure you want to delete the last revaluation': '¿Está seguro de que desea eliminar la última revaluación?',
	'Are you sure you want to delete the review': '¿Está seguro de que desea eliminar la revisión?',
	'Delete report': 'Eliminar informe',
	'Delete the last revaluation': 'Eliminar la última revaluación',
	'JDS D86 last revaluation deleted successfully': 'JDS D86 última revaluación eliminada correctamente',
	'Delete review': 'Eliminar revisión',
	'You can delete the entire report or just the last revaluation':
		'Puede eliminar todo el informe o solo la última revaluación',
	'JDS D86 deleted successfully': 'JDS D86 eliminado correctamente',
	'Select the video file below for the task you want to analyze':
		'Seleccione el archivo de video correspondiente a la tarea que desea analizar',
	Evaluation: 'Evaluación',
	'Generating a document': 'Generando un documento',
	'The created document is being generated and will be downloaded':
		'El documento creado se está generando y será descargado',
	'Noise level': 'Nivel de ruido',
	'Select the Report name': 'Seleccione el nombre del informe',

	//D92
	'Lifting tasks': 'Levantamiento',
	'Push, pull and carry': 'Empujar, arrastrar y cargar ',
	'Handles work objects above the shoulder or below the knee':
		'Realiza manejo de objetos de trabajo por encima del hombro o por debajo de la rodilla.',
	'Shoulder moment calculator': 'Calculadora de momento para el hombro',
	'Manual lifting (NIOSH)': 'Levantamiento de cargas (NIOSH)',
	'Manual handling (KIM MHO)': 'Manejo manual (KIM MHO)',
	'Lever Arm': 'Brazo de palanca',
	'Type of Task': 'Tipo de tarea',
	'Material handling (Liberty Mutual)': 'Manipulación de material (Liberty Mutual)',
	'Use of manually operated carts': 'Uso de carrinhos movimentados manualmente',
	'Is the manual force to lift the car out of inertia less than 22kg?':
		'¿La fuerza manual para sacar el carro de la inercia es menor de 22 kg?',
	'Is the sustained hand force less than 11.5kg?': '¿La fuerza manual sostenida es menor de 11,5 kg?',
	'Is the diameter to fit the fingers larger than 30mm and smaller than 50mm?':
		'¿El diámetro para encajar los dedos es mayor de 30 mm y menor de 50 mm?',
	'Is the vertical handle between 900mm and 1225mm?': '¿El asa vertical está entre 900 mm y 1225 mm?',
	'Is the width from one handle to the other larger than 400mm and smaller than 600mm?':
		'¿El ancho de un agarre al otro es mayor de 400 mm y menor de 600 mm?',
	'Is the caster in good condition?': '¿La rueda giratoria está en buenas condiciones?',
	'Is the road in good condition?': '¿El recorrido realizado está en buenas condiciones?',
	'Is the layout in good condition for moving the car, with enough space for maneuvering?':
		'¿El diseño está en buenas condiciones para la movilización del carro con suficiente espacio para maniobras?',
	'Is the floor in good condition?': '¿El piso está en buenas condiciones?',
	'Handling load': 'Manipulación de carga',
	'Horizontal push or pull': 'Empujar o arrastrar horizontal',
	'Push or pull downward': 'Empujar o arrastrar hacia abajo',
	'Distance from the acromion to the center of the load (greatest distance)':
		'Distancia desde el acromion hasta el centro de carga (mayor distancia)',
	'Repetitions in a working day': 'Repeticiones en un día de trabajo',
	'Apply when moving a part with a mass greater than 4.5 kg with one hand':
		'Aplicar cuando hay movimiento de una pieza con una masa mayor a 4,5 kg con una mano.',
	'Apply when moving a piece with a mass greater than 9kg with two hands in up to two steps':
		'Aplicar cuando hay movimiento de una pieza con una masa mayor a 9 kg con dos manos en hasta dos pasos.',
	'Apply when there is movement in a critical scenario (e.g. bottom of a container)':
		'Aplicar cuando hay movimiento en un escenario crítico (por ejemplo, fondo de un contenedor).',
	'per work day': 'por dia',
	'Probability of Shoulder Outcome': 'Probabilidad de consecuencia para el hombro',
	'The task should serve 75% of the female population': 'A tarefa deve ser adequada para 75% da população feminina.',

	//  Back compressive force estimation
	'Back compressive force estimation': 'Estimación de compresión lumbar',
	'Person weight': 'Peso de la persona',
	"Person's weight": 'Peso de la persona',
	'Insert the person weight': 'Inserte el peso de la persona',
	"Person's height": 'Altura de la persona',
	'Person height': 'Altura de la persona',
	'Insert the person height': 'Inserte la altura de la persona',
	'Trunk angle to Horizontal': 'Ángulo del tronco respecto a horizontal',
	'Trunk angle to horizontal': 'Ángulo del tronco respecto a horizontal',
	'Insert a trunk angle': 'Inserte el Ángulo del tronco',
	'Load in hands': 'Carga que se está manipulando ',
	'Insert the load in hands': 'Inserte la carga que se está manipulando',
	'Horizontal distance from hands to low back': 'Distancia horizontal de las manos a la región lumbar',
	'Insert a horizontal distance': 'Insert la d istancia horizontal de las manos a la región lumbar',
	'Total compressive force': 'Fuerza de compresión total',
	'Back compressive force estimation report updated successfully':
		'Informe de estimación de la fuerza de compresión trasera actualizado con éxito',
	'Creation date': 'Fecha de creación',
	"Enter the operator's activity-related data below": 'Inserta abajo los datos relacionados al vídeo seleccionado',
	Dimensions: 'Dimensiones',
	'Condition found': 'Condición encontrada',
	'Select the video files for the operations that make up the workstation below':
		'Seleccione a continuación el archivo de vídeo referente a las tareas que desea analizar.',
	'Are you sure you want to delete the evaluation': '¿Está seguro de que desea eliminar a evaluación',
	'Document generated!': 'Documento generado!',
	'Activity created successfully': 'Actividad creada con éxito',
	'Select EWA': 'Selección de AEP',
	'Unable to load data': 'No se pueden cargar los datos',
	'Influence of organizational factors': 'Influencia de factores organizacionales',

	// New Dashboard
	'No data available.': 'No hay datos.',
	'This page was not found.': 'No se ha encontrado esta página.',
	'Try Again': 'Intentar de Nuevo',
	'Start date must be before end date': 'Fecha inicial debe ser antes de la final',
	'End date must be after start date': 'Fecha final debe ser después de la inicial',
	'Number of reports': 'Número de reportes',
	'Unable to load custom reports': 'No se pueden cargar los informes personalizados',
	'Actions created and resolved': 'Acciones creadas y resueltas',
	'Actions created': 'Acciones creadas',
	'Delayed actions': 'Acciones diferidas',
	Late: 'Retrasada',
	'Not started': 'No iniciado',
	Total: 'Total',
	'Number of actions': 'Número de acciones',
	Variation: 'Variación',
	'Risk evolution': 'Evolución del riesgo',
	'Main risk category': 'Categoría de riesgo principal',
	"Sum of RPN of factors '6 too'": "Suma de RPN de factores '6 demasiado'",
	'Too Many Times': 'Demasiadas Veces',
	'Too Heavy': 'Demasiado Pesado',
	'Risk comparison between': 'Comparativa de riesgo entre',
	files: 'archivos',
	workstations: 'estaciones de trabajo',
	lines: 'líneas',
	sectors: 'sectores',
	'industrial sites': 'centros de trabajo',
	'Comparison of': 'Comparación de',
	'with variation': 'con variación',
	'Percentile by gender': 'Percentil por género',
	'Male percentile': 'Percentil masculino',
	'Female percentile': 'Percentil femenino',
	'Reports generated': 'Reportes generados',
	'General overview': 'Visión general',
	'Ergonomic Risk Management': 'Gestión de riesgos ergonómicos',
	'Ergonomics Assessments Tools Status': 'Estado de las Herramientas de Evaluación Ergonómica',
	'John Deere Enterprise Ergonomics Assessments Tools Status':
		'Estado de las Herramientas de Evaluación Ergonómica de John Deere Enterprise',
	'Checklist reports generated': 'Reportes de listas de control generados',
	'Action plan status': 'Estados de los planes de acción',
	'Start date': 'Fecha inicial',
	'End date': 'Fecha final',
	'Predetermined time frame': 'Espacio de tiempo predeterminado',
	Week: 'Semana',
	Months: 'Meses',
	'Highest incidence': 'Categoria de maior',
	category: 'incidência',
	'Granularity of information': 'Granularidad de la información',
	'Change date for all': 'Cambiar la fecha para todos',
	'Single period': 'Periodo único',
	'Compound period (comparative)': 'Periodo compuesto (comparativo)',
	'Period 1': 'Periodo 1',
	'Period 2': 'Periodo 2',
	Biomechanical: 'Biomecánica',
	quarter: 'trimestre',
	semester: 'semestre',
	Jan: 'Ene',
	Apr: 'Abr',
	May: 'Mayo',
	Aug: 'Ago',
	Dec: 'Dic',
	to: 'até',
	'Slightly high': 'Ligeramente alto',
	'Substantially high': 'Sustancialmente alto',
	Torso: 'Tronco',
	'Exposure score of all body parts': 'Puntuación de exposición de todas las partes del cuerpo',
	'Exposure by body side': 'Exposición por lado del cuerpo',
	'Left side': 'Lado izquierdo',
	'Right side': 'Lado derecho',
	'Investigate and implement changes': 'Investigar y aplicar cambios',
	Today: 'Hoy',
	'This week': 'Esta semana',
	'This month': 'Este mes',
	'This quarter': 'Este trimestre',
	'This semester': 'Este semestre',
	'This year': 'Este año',
	'Last 7 days': 'Últimos 7 días',
	'Last 30 days': 'Últimos 30 días',
	'Last 3 months': 'Últimos 3 meses',
	'Last 6 months': 'Últimos 6 meses',
	'Last 12 months': 'Últimos 12 meses',
	'From the beginning': 'Desde el principio',
	'Fiscal year (FY)': 'Año fiscal (FY)',
	'Not GNS': 'No GNS',
	'Want to know more about Kinebot?': '¿Quieres saber más sobre Kinebot?',
	'Evidence removed': 'Evidencia removida',
	'Attachment removed': 'Anexo removido',
	'Evidence updated successfully': 'Evidencia actualizada con éxito',
	'Attachment updated successfully': 'Anexo actualizado con éxito',
	'Action plan attachment not found': 'Anexo del plano de acción no encontrado',
	'Action plan evidence not found': 'Evidencia del plano de acción no encontrada',
	'Task removed successfully': 'Tarea removida con éxito',
	'Action plan updated': 'Plano de acción actualizado',
	'Selected action plans deleted successfully': 'Planos de acciones seleccionados eliminados con éxito',
	'Failed to deleted selected action plans': 'Error al eliminar los planos de acciones seleccionados',
	'Drag or select the files you want to attach to your action plan':
		'Arrastre o seleccione los archivos que desea adjuntar a su plan de acción',
	'Are you sure you want to remove the attachment': '¿Está seguro de que desea eliminar el anexo',
	'Add description': 'Añadir descripción',
	'File description': 'Descripción del archivo',
	'Upload author': 'Autor de carga',
	'Attach files': 'Adjuntar archivos',
	'Attach evidences': 'Adjuntar evidencias',
	'New action plan': 'Nuevo plan de acción',
	Sort: 'Ordenación',
	Board: 'Tablero',
	Table: 'Tabla',
	Notifications: 'Notificaciones',
	Responsable: 'Responsable',
	'Select the responsible': 'Seleccione el responsable',
	'Create an action plan': 'Crear un plan de acción',
	'Action plan name': 'Nombre del plan de acción',
	'Alphabetical A-Z': 'Alfabético A-Z',
	'Alphabetical Z-A': 'Alfabético Z-A',
	'Most recent': 'Más reciente',
	'Least recent': 'Menos reciente',
	'Nearest due date': 'Vencimiento próximo',
	'Furthest due date': 'Vencimiento lejano',
	'Highest priority': 'Mayor prioridad',
	'Lowest priority': 'Menor prioridad',
	'Highest investment': 'Mayor inversión',
	'Lowest investiment': 'Menor inversión',
	'Attach new file': 'Anexar nuevo archivo',
	'Action plan deleted': 'Plano de acción eliminado',
	'Description changed': 'Descripción modificada',
	'Title changed': 'Título modificado',
	'Responsible changed': 'Responsable modificado',
	'Due date changed': 'Fecha de vencimiento modificada',
	'Priority changed': 'Prioridad modificada',
	'Investment changed': 'Inversión modificada',
	'Attachment added': 'Anexo añadido',
	'Evidence added': 'Evidencia añadida',
	'Task changed': 'Tarea modificada',
	'Task removed': 'Tarea eliminada',
	'Task added': 'Tarea añadida',
	'Task completed': 'Tarea concluida',
	'Task uncompleted': 'Tarea no concluida',
	'Linked tool': 'Herramienta vinculada',
	'Unlinked tool': 'Herramienta desvinculada',
	'Comment added': 'Comentario añadido',
	'Comment removed': 'Comentario eliminado',
	'Comment changed': 'Comentario modificado',
	'Error fetching responsible options': 'Error al buscar opciones de responsable',
	'Are you sure you want to delete the selected items?':
		'¿Está seguro de que desea eliminar los elementos seleccionados?',
	'Please select a priority': 'Seleccione una prioridad',
	'Please select a date': 'Seleccione una fecha',
	'Please select a responsible': 'Seleccione un responsable',
	Evidences: 'Evidencias',
	'New Task': 'Nueva tarea',
	'Are you sure you want to delete the selected task?': '¿Está seguro de que desea eliminar la tarea seleccionada?',
	'Notification Control': 'Control de notificaciones',
	'Follow up action plans created by me': 'Planes de acción de seguimiento creados por mí',
	'Receive an e-mail when the status of the action plan changes':
		'Recibir un correo electrónico cuando cambie el estado del plan de acción',
	'Receive e-mail when tasks are completed': 'Recibir un correo electrónico cuando se completen las tareas',
	'Follow up on action plans assigned to me': 'Seguimiento de los planes de acción que se me asignen',
	'Receive an e-mail when a new action plan is assigned to me':
		'Recibir un correo electrónico cuando se me asigne un nuevo plan de acción',
	'Receive an e-mail when the due date is near':
		'Recibir un correo electrónico cuando se acerque la fecha de vencimiento',
	Unknown: 'Desconocido',
	'Select the due date': 'seleccionar fecha de vencimiento',
	By: 'Por',
	'Investment value': 'Valor de inversión',
	'Open action plan': 'Plan de acción abierto',
	'Action plans updated successfully': 'Planes de acción actualizados con éxito',
	'Attachments - Images': 'Archivos adjuntos - Imágenes',
	'Attachments - Other files': 'Archivos adjuntos - Otros archivos',
	'Completed tasks': 'Tareas completadas',
	'Tasks not completed': 'Tareas no realizadas',
	'Edit history': 'Editar historial',
	'Categorization of the urgency of action plan resolution':
		'Categorización de la urgencia de la resolución del plan de acción',
	'Expected cost of the action plan': 'Coste previsto del plan de acción',
	Exporting: 'Exportando',
	'There are tasks that have not been saved.': 'Hay tareas que no se han guardado.',
	'Tools updated successfully': 'Herramientas actualizadas correctamente',
	'Enter the action plan name': 'Ingrese el nombre del plan de acción',
	'Description of the file': 'Descripción del archivo',
	'Failed to upload file': 'No se pudo cargar el archivo',
	'File uploaded successfully': 'Archivo cargado exitosamente',
	'Failed to load attachments': 'No se pudieron cargar los archivos adjuntos',
	'PEA (NR17)': 'AEP (ISO 20646)',
	'PEA (NR17 + JDS-D86)': 'AEP (ISO 20646 + JDS-D86)',
	'PEA (NR17 + JDS D86)': 'AEP (ISO 20646 + JDS D86)',
	'AEP (NR17 + JDS-D86)': 'AEP (ISO 20646 + JDS-D86)',
	'AEP (NR17 + JDS D86)': 'AEP (ISO 20646 + JDS D86)',
	'NR17 + JDS-D86': 'ISO 20646 + JDS-D86',
	'NR-17 + JDS-D86': 'ISO 20646 + JDS-D86',
	NR17: 'ISO 20646',
	'NR-17': 'ISO 20646',
	PEA: 'AEP',
	'You are activating sandbox mode.': 'Estás activando el modo sandbox.',
	'From now on, no actions will be recorded in the official environment.':
		'A partir de ahora, no se registrarán acciones en el entorno oficial.',
	'Use the area for simulations.': 'Utiliza esta área para simulaciones.',
	'You are activating sandbox mode. From now on, no actions will be recorded in the official environment - use the area for simulations.':
		'Estás activando el modo sandbox. A partir de ahora, no se registrarán acciones en el entorno oficial - utiliza esta área para simulaciones.',
	'You are exiting sandbox mode.': 'Estás saliendo del modo sandbox.',
	'All actions that have not been applied will be lost.': 'Todas las acciones que no se han aplicado se perderán.',
	'You are exiting sandbox mode. All actions that have not been applied will be lost.':
		'Estás saliendo del modo sandbox. Todas las acciones que no se han aplicado se perderán.',
	'Exit without applying': 'Salir sin aplicar',
	'To production': 'A Producción',
	'To sandbox': 'A Sandbox',
	'Video upload': 'Carga de video',
	'New report': 'Nuevo informe',
	'For the application of the report in the official environment, the following items will also be applied':
		'Para la aplicación del informe en el entorno oficial, también se aplicarán los siguientes elementos:',
	'Apply report in the official environment': 'Aplicar informe en el entorno oficial',
	'Apply all': 'Aplicar todo',
	Update: 'Actualizar',
	'Error on send report': 'Error al enviar informe',
	'Report sent successfully': 'Informe enviado correctamente',
	'Error on exists report': 'Error al verificar la existencia del informe',
	'Error on logout': 'Error al cerrar sesión',
	'Error fetching total created custom reports': 'Error al obtener el total de reportes personalizados creados',
	'Review action plans': 'Verificar planos de acción',
	'Do you want to extract the action plans from the report(s)?':
		'¿Desea extraer los planes de acción del(s) informe(s)?',
	'Showing the available tools in': 'Exibiendo las herramientas disponibles en',
	report: 'informe',
	'Deselect all': 'Deseleccionar todos',
	'Select one or more tools for extraction. If desired, you can proceed without including tools in the extraction.':
		'Seleccione una o más herramientas para la extracción. Si lo desea, puede continuar sin incluir herramientas en la extracción.',
	'General Information': 'Información general',
	'Number of attachments': 'Número de archivos adjuntos',
	'Number of evidences': 'Número de evidencias',
	'Completion date': 'Fecha de finalización',
	Source: 'Fuente',
	'Source and information of action plans': 'Fuente e información de los planes de acción',
	'The extraction will include action plans from the following sources:':
		'La extracción incluirá planes de acción de las siguientes fuentes:',
	'Select the information you want to include in the extraction:':
		'Seleccione la información que desea incluir en la extracción:',
	'Set as template ': 'Guardar como plantilla',
	'The extraction contains the following information:': 'La extracción contiene la siguiente información:',
	'Content of action plans:': 'Contenido de los planes de acción:',
	Extraction: 'Extracción',
	'has been added to the queue and will be available for download on the home page soon':
		'ha sido añadida a la cola y estará disponible para descarga en la página de inicio pronto',
	'Go to home page': 'Ir a la página de inicio',
	'Could not create extraction': 'No se pudo crear la extracción',
	'please try again': 'por favor inténtalo de nuevo',
	'Data Extraction CSV file created successfully! Download in progress.':
		'¡Archivo CSV de extracción de datos creado con éxito! Descarga en curso.',
	'Unable to download the data extraction file. Please try again.':
		'No se pudo descargar el archivo de extracción de datos. Por favor, inténtalo de nuevo.',
	Pending: 'Pendiente',
	'In progress': 'En progreso',
	Failed: 'Fallido',
	'Content:': 'Contenido:',
	'Action plans content:': 'Contenido del plan de acción:',
	'No report selected': 'No se ha seleccionado ningún informe',
	'No action plan is linked to this extraction': 'No hay plan de acción vinculado a esta extracción',
	'Select the action plans sources and information to include in the extraction.':
		'Seleccione las fuentes y las informaciones de los planes de acción que desea incluir en la extracción.',
	'Select one or more origins for extracting action plans. If desired, you can proceed without including action plans in the extraction.':
		'Seleccione una o más fuentes para extraer los planes de acción. Si lo desea, puede continuar sin incluir planes de acción en la extracción.',
	'Select a report category for extraction. You can proceed without including a report in the extraction if you wish.':
		'Seleccione una categoría de informe para la extracción. Si lo desea, puede continuar sin incluir un informe en la extracción.',
	'Initial reference date': 'Fecha de referencia inicial',
	'Final reference date': 'Fecha de referencia final',
	'Select the reports you want to include in the extraction':
		'Seleccione los informes que desea incluir en la extracción',
	'Search for a report': 'Buscar un informe',
	Selected: 'Seleccionado(s)',
	'Extraction template name': 'Nombre del modelo de extracción',
	'By model': 'Por modelo',
	'Choose model': 'Elija un modelo',
	'Select the desired model and edit the necessary information to create a new extraction':
		'Seleccione el modelo deseado y edite la información necesaria para crear una nueva extracción',
	'Use template': 'Usar plantilla',
	'Industrial site is required': 'El sitio industrial es requerido',
	'action plan': 'plan de acción',
	'Do you want to delete the selected extractions?': '¿Desea eliminar las extracciones seleccionadas?',
	'Extraction deleted successfully': 'Extracción eliminada correctamente',
	'Extractions deleted successfully': 'Extracciónes eliminada correctamente',
	'Failed to delete extraction': 'No se pudo eliminar la extracción',
	'Do you want to delete the extraction model': '¿Desea eliminar el modelo de extracción',
	'Status updated successfully': 'Estado actualizado con éxito',
	'Error updating status': 'Error al actualizar el estado',
	'Notifications disabled successfully!': 'Notificaciones deshabilitadas con éxito!',
	'Notifications enabled successfully!': 'Notificaciones habilitadas con éxito!',
	'Error updating notification preferences': 'Error al actualizar las preferencias de notificaciones',
	'The tools listing shows the number of reviews available in each category.':
		'La lista de informes muestra el número de reseñas disponibles en cada categoría.',
	'Origin not specified': 'Origen no especificado',
	'Due date ': 'Fecha de vencimiento',
	'Data extraction model created successfully': 'Modelo de extracción de datos creado con éxito',
	'Error creating data extraction model': 'Error al crear el modelo de extracción de datos',
	Displaying: 'Mostrando',
	'Data extraction created successfully': 'Extracción de datos creada con éxito',
	'Download unavailable - extraction not completed': 'Descarga no disponible - extracción no completada',

	// Resolution 886
	'Resolution 886': 'Resolución 886',
	'Job position': 'Cargo',
	'Written work procedure': 'Procedimiento escrito de trabajo',
	'Early manifestation': 'Manifestación temprana',
	'Symptom location': 'Ubicación de síntoma',
	'Evaluation name': 'Nombre de la evaluación',
	Training: 'Capacitación',
	'Worker name': 'Nombre del trabajador',
	'Number of workers': 'Número de trabajadores',
	Workers: 'Trabajadores',
	'Create new version': 'Crear nueva versión',
	'View versions': 'Ver versiones',
	Download: 'Descargar',
	'New evaluation': 'Nueva evaluación',
	'Select line': 'Seleccionar línea',
	'Select workstation': 'Seleccionar estación de trabajo',
	'Select sector': 'Seleccionar sector',
	'Select work center': 'Seleccionar centro de trabajo',
	"Worker's name": 'Nombre del trabajador',
	Versions: 'Versiones',
	'Do you want to delete the Initial Version of the evaluation':
		'¿Quieres eliminar la versión inicial de la evaluación',
	'Do you want to delete the evaluation': '¿Quieres eliminar la evaluación',
	'and all its versions': 'y todas sus versiones',
	'Once a new review is created, the current version will no longer be editable. Do you wish to continue?':
		'Al crear una nueva revisión, ya no será posible editar la versión actual. ¿Desea continuar?',
	'Enter the data related to the evaluation.': 'Ingresa los datos relacionados con la evaluación.',
	'Worker(s) name': 'Apelido y Nombre',
	'Workers number': 'Número de trabajadores',
	'Responsible of the Occupational Medicine Service': 'Responsable del Servicio de Medicina del Trabajo',
	'Responsible for the Hygiene Service and Security': 'Responsable del Servicio de Higiene y Seguridad',
	Employer: 'Empleador',
	'Identify tasks and carry out their evaluation.': 'Identifica las tareas y realiza su evaluación.',
	'Select a worker': 'Seleccionar un trabajador',
	'Please enter a worker': 'Ingrese un trabajador',
	'Add worker': 'Añadir trabajador',
	'Enter a workers number': 'Ingrese el número de trabajadores',
	'Enter the workers name': 'Ingrese el nombre del(s) trabajador(es)',
	'select a work center': 'Seleccionar un centro de trabajo',
	'Enter a symptom location': 'Ingrese una ubicación de sintoma',
	'Enter a evaluation name': 'Ingrese un nombre de evaluación',
	'Tolerable risk': 'Riesgo tolerable',
	'Unacceptable risk': 'Riesgo no tolerable',
	'Each task corresponds to a specific administrative or engineering measure. Modify the person responsible and the due date, and keep the “Administrative” or “Engineering” prefix when modifying the task name. To create new tasks, always identify them with the corresponding measure prefix in the title.':
		'Cada tarea corresponde a una medida específica de administración o ingeniería. Modifique el responsable y la fecha de vencimiento, y mantenga el prefijo “Administrativo” o “Ingeniería” cuando modifique el nombre de la tarea. Para crear nuevas tareas, siempre identifíquelas con el prefijo correspondiente en el título.',
	Engineering: 'Ingeniería',
	'Video Selection': 'Selección de vídeo',
	'Select the videos corresponding to the tasks that will be evaluated':
		'Seleccione los vídeos correspondientes a las tareas que se evaluarán',
	'Action Plan': 'Plan de acción',
	'Evaluation Resolution 886': 'Evaluación Resolución 886',
	'Please select at least one file': 'Por favor seleccione al menos un archivo',
	Showing: 'Mostrando',
	'Risk evaluation': 'Evaluación de riesgo',
	'Select the risk level:': 'Seleccione el nivel de riesgo:',
	'The risk factor can be evaluated using the NIOSH tool:':
		'El factor de riesgo puede ser evaluado utilizando la herramienta NIOSH:',
	ErgonomicTool886: 'El factor de riesgo puede ser evaluado utilizando la herramienta {{tool_name}}:',
	'Load lifting': 'Levantamiento de carga',
	'Observations:': 'Observaciones:',
	Observations: 'Observaciones',
	'Watch video': 'Ver vídeo',
	'Hand-arm vibration': 'Vibración mano - brazo',
	Transport: 'Transporte',
	'Repetitive movements': 'Movimientos repetitivos',
	'Thermal comfort': 'Comfort térmico',
	'Whole body vibration': 'Vibración cuerpo entero',
	'Push / pull': 'Empuje / arraste',
	'Forced posture': 'Postura forzada',
	'Evaluation of risk factors': 'Evaluación de factores de riesgo',
	'Select the risk factor to carry out the evaluation. Factors not evaluated will be considered a tolerable risk.':
		'Selecciona el factor de riesgo para realizar la evaluación. Los factores no evaluados se considerarán un riesgo tolerable.',
	'Evaluation not started': 'Evaluación no iniciada',
	Evaluate: 'Evaluar',
	'Initial evaluation of risk factors': 'Evaluación inicial de factores de riesgo',
	'Fill out the following information.': 'Rellene la información siguiente.',
	'Safety and hygiene responsible': 'Responsable de seguridad y higiene',
	'Occupational doctor': 'Médico del trabajo',
	'Safety and hygiene responsible created successfully': 'Responsable de seguridad y higiene creado con éxito',
	'Error on create safety and hygiene responsible': 'Error al crear responsable de seguridad y higiene',
	'Safety and hygiene responsible updated successfully': 'Responsable de seguridad y higiene actualizado con éxito',
	'Error on update safety and hygiene responsible': 'Error al actualizar responsable de seguridad y higiene',
	'Safety and hygiene responsible destroyed successfully': 'Responsable de seguridad y higiene eliminado con éxito',
	'Error on destroy safety and hygiene responsible': 'Error al eliminar responsable de seguridad y higiene',
	'Occupational doctor created successfully': 'Médico del trabajo creado con éxito',
	'Error on create occupational doctor': 'Error al crear médico del trabajo',
	'Occupational doctor updated successfully': 'Médico del trabajo actualizado con éxito',
	'Error on update occupational doctor': 'Error al actualizar médico del trabajo',
	'Occupational doctor destroyed successfully': 'Médico del trabajo eliminado con éxito',
	'Error on destroy occupational doctor': 'Error al eliminar médico del trabajo',
	'Select a responsible': 'Seleccionar una persona responsable',
	'Please select a written work procedure': 'Existencia de un procedimiento escrito de trabajo',
	'Please select a training': 'Existencia de un entrenamiento',
	'Please select a early manifestation': 'Existencia de una manifestación precoz',
	'Please enter a workers number': 'Por favor insira el número de trabajadores',
	'Please select a worker': 'Por favor seleccione el(los) trabajador(es)',
	'Please select a workstation': 'Por favor seleccione la estación de trabajo',
	'Please enter an evaluation name': 'Por favor insira el nombre de la evaluación',
	'Please select a responsible of the occupational medicine service':
		'Por favor seleccione un responsable del servicio de medicina del trabajo',
	'Please select a responsible for the hygiene service and security':
		'Por favor seleccione un responsable del servicio de higiene y seguridad',
	'Please select an employer': 'Por favor seleccione un empleador',
	'Please enter a job position': 'Por favor insira el cargo',
	'Please select an evaluator': 'Por favor seleccione un evaluador',
	'Please enter a symptom location': 'Por favor insira una localización de sintoma',
	'Please select a line': 'Por favor seleccione una línea',
	'Please select a sector': 'Por favor seleccione un sector',
	'Please select a company': 'Por favor seleccione una empresa',
	'Please select a industrial site': 'Por favor seleccione un centro de trabajo',
	'Lift and lower': 'Levantamiento y descenso',
	'Identify if the task of the job position involves': 'Identifique si en puesto de trabajo',
	'Determine the risk level': 'Determinar el nivel de riesgo',
	obligatorily: 'obligatoriamente',
	moderate: 'moderado',
	'not tolerable': 'no tolerable',
	'Indicate the time of exposure to the risk factor (in percentage)':
		'Indique el tiempo de exposición al factor de riesgo (en porcentaje)',
	'This value will be added to the total exposure time to the Risk Factor.':
		'Este valor se agregará al tiempo total de exposición al Factor de Riesgo.',
	'Lifting and/or lowering loads weighing more than 2 kg and up to 25 kg?':
		'¿Levantar y/o bajar manualmente cargas de peso superior a 2 kg. y hasta 25 kg?',
	'Does the worker perform lifting/lowering operations daily and cyclically with a frequency of ≥ 1 per hour or ≤ 360 per hour? (If done sporadically, indicate "No")':
		'¿Realizar diariamente y en forma cíclica operaciones de levantamiento / descenso con una frecuencia ≥ 1 por hora o ≤ 360 por hora?  (Si se realiza de forma esporádica, consignar "No")',
	'Lifting and/or lowering loads weighing more than 25 kg?':
		'¿Levantamiento y/o bajada de cargas con peso superior a 25 kg?',
	'Does the worker lift, hold, and deposit the load exceeding 30 cm above shoulder height with their hands?':
		'¿El trabajador levanta, sostiene y deposita la carga sobrepasando con sus manos 30 cm sobre la altura del hombro?',
	'Does the worker lift, hold, and deposit the load more than 80 cm horizontally from the midpoint between the ankles?':
		'¿El trabajador levanta, sostiene y deposita la carga sobrepasando con sus manos una distancia horizontal mayor de 80 cm desde el punto medio entre los tobillos?',
	'Between lifting and depositing the load, does the worker twist or bend their waist more than 30º to either side (or both) from the sagittal plane?':
		'¿Entre la toma y el depósito de la carga, el trabajador gira o inclina la cintura más de 30º a uno u otro lado (o a ambos) considerados desde el plano sagital?',
	'Do the loads have irregular shapes, are difficult to grasp, deform, or have movement inside?':
		'¿Las cargas poseen formas irregulares, son difíciles de asir, se deforman o hay movimiento en su interior?',
	'Does the worker lift, hold, and deposit the load with one arm?':
		'¿El trabajador levanta, sostiene y deposita la carga con un brazo?',
	// Manual load push and pull
	'Manual load push and pull': 'Empuje y arrastre manual de carga',
	'Are cyclical tasks performed daily, with a frequency of ≥ 1 movement per day? (If sporadic, indicate “No”)':
		'¿Se realizan diariamente tareas cíclicas, con una frecuencia de ≥ 1 movimiento por jornada? (Si son esporádicas, consignar "No")',
	'Does the worker move by pushing and/or pulling an object over a distance greater than 60 meters?':
		'¿El trabajador se desplaza empujando y/o arrastrando manualmente un objeto recorriendo una distancia mayor a los 60 metros?',
	'Are objects (bags, boxes, furniture, machines, etc.) pushed or pulled cyclically with a force measured with a dynamometer exceeding 34 kg?':
		'¿Se empujan o arrastran cíclicamente objetos (bolsones, cajas, muebles, máquinas, etc.) cuyo esfuerzo medido con dinamómetro supera los 34 kg?',
	'Is an initial effort required to push the rolling object measured with a dynamometer >= 12 kg for men or 10 kg for women?':
		'¿Para empujar el objeto rodante se requiere un esfuerzo inicial medido con dinamómetro ≥ 12 kg para hombres o 10 kg para mujeres?',
	'Is an initial effort required to pull the rolling object measured with a dynamometer >= 10 kg for men or women?':
		'¿Para arrastrar el objeto rodante se requiere un esfuerzo inicial medido con dinamómetro ≥ 10 kg para hombres o mujeres?',
	'Is the rolling object pushed and/or pulled with difficulty (the sliding surface is uneven, there are ramps to go up or down, there are breaks or obstacles in the path, wheels in poor condition, poorly designed handle, etc.)?':
		'¿El objeto rodante es empujado y/o arrastrado con dificultad (la superficie de deslizamiento es despareja, hay rampas que subir o bajar, hay roturas u obstáculos en el recorrido, ruedas en mal estado, mal diseño del asa, etc)?',
	'Can the rolling object not be pushed and/or pulled with both hands, and if allowed, is the hand support at an uncomfortable height (above the chest or below the waist)?':
		'¿El objeto rodante no puede ser empujado y/o arrastrado con ambas manos, y en caso que lo permita, el apoyo de las manos se encuentra a una altura incómoda (por encima del pecho o por debajo de la cintura)?',
	'In the act of pushing and/or pulling, is the initial effort required significantly maintained once the object is in motion (is there wheel jamming, jerking, or lack of uniform sliding)?':
		'¿En el movimiento de empujar y/o arrastrar, el esfuerzo inicial requerido se mantiene significativamente una vez puesto en movimiento el objeto (se produce atascamiento de las ruedas, tirones o falta de deslizamiento uniforme)?',
	'Does the worker push or pull the rolling object using only one hand?':
		'¿El trabajador empuja o arrastra el objeto rodante asiéndolo con una sola mano?',
	'Error updating report': 'Error al actualizar reporte',
	'Manual load transport': 'Transporte manual de cargas',
	'Manually transporting loads weighing more than 2 kg and up to 25 kg?':
		'¿Transportar manualmente cargas de peso superior a 2 kg y hasta 25 kg?',
	'Does the worker move while manually holding the load over a distance greater than 1 meter?':
		'¿El trabajador se desplaza sosteniendo manualmente la carga recorriendo una distancia mayor a 1 metro?',
	'Is it performed daily in a cyclical manner? (if sporadic, indicate "No")':
		'¿Realizarla diariamente en forma cíclica? (Si es esporádica, consignar “No”)?',
	'Is manual transport of loads over a distance greater than 20 meters?':
		'¿Se transporta manualmente cargas a una distancia superior a 20 metros?',
	'Is manual transport of loads weighing more than 25 kg?':
		'¿Se transporta manualmente cargas de peso superior a 25 kg?',
	'Under normal lifting conditions, does the worker transport the load between 1 and 10 meters with a cumulative mass (the product of mass by frequency) greater than 10,000 kg during the usual workday?':
		'¿En condiciones habituales de levantamiento, el trabajador transporta la carga entre 1 y 10 metros con una masa acumulada (el producto de la masa por la frecuencia) mayor que 10.000 kg durante la jornada habitual?',
	'Under normal lifting conditions, does the worker transport the load between 10 and 20 meters with a cumulative mass (the product of mass by frequency) greater than 6,000 kg during the usual workday?':
		'¿En condiciones habituales de levantamiento, el trabajador transporta la carga entre 10 y 20 metros con una masa acumulada (el producto de la masa por la frecuencia) mayor que 6.000 kg durante la jornada habitual?',
	'Standing position': 'Bipedestación',
	'Does the job require standing for 2 consecutive hours or more without the possibility of sitting?':
		'¿El puesto de trabajo se desarrolla en posición de pie, sin posibilidad de sentarse, durante 2 horas seguidas o más?',
	'Does the job involve standing for 3 consecutive hours or more without the possibility of sitting and with limited mobility (walking no more than 100 meters/hour)?':
		'¿En el puesto se realizan tareas donde se permanece de pie durante 3 horas seguidas o más, sin posibilidades de sentarse con escasa deambulación (caminando no más de 100 metros/hora)?',
	'Does the job involve standing for 2 consecutive hours or more without the possibility of sitting or moving, or with limited mobility, lifting and/or transporting loads > 2 kg?':
		'¿En el puesto se realizan tareas donde se permanece de pie durante 2 horas seguidas o más, sin posibilidades de sentarse ni desplazarse o con escasa deambulación, levantando y/o transportando cargas > 2 kg?',
	'Are tasks performed with prolonged standing in environments where temperature and humidity exceed legally permissible limits and require physical activity?':
		'¿Trabajos efectuados con bipedestación prolongada en ambientes donde la temperatura y la humedad del aire sobrepasan los límites legalmente admisibles y que demandan actividad física?',
	'Repetitive movements of upper limbs': 'Movimientos repetitivos de miembros superiores',
	'Performing daily, one or more tasks using the upper limbs for 4 or more hours during the regular workday in a cyclical manner (continuously or alternately)?':
		'¿Realizar diariamente, una o más tareas donde se utilizan las extremedidas superiores, durante 4 o más horas en la jornada habitual de trabajo en forma cíclica (en forma continuada o alternada)?',
	'Are the upper limbs active for more than 40% of the total work cycle time?':
		'¿Las extremidades superiores están activas por más del 40% del tiempo total del ciclo de trabajo?',
	'Is there an effort greater than moderate at 3 on the Borg Scale, for more than 6 seconds and more than once per minute?':
		'¿En el ciclo de trabajo se realiza un esfuerzo superior a moderado a 3 según la Escala de Borg, durante más de 6 segundos y más de una vez por minuto?',
	'Is there an effort greater than 7 on the Borg scale?':
		'¿Se realiza un esfuerzo superior a 7 según la escala de Borg?',
	'Does the worker show any early manifestations of the diseases mentioned in Article 1 of this Resolution?':
		'¿El trabajador presenta alguna manifestación temprana de las enfermedades mencionadas en el Artículo 1° de la presente Resolución?',
	'Adopting forced postures regularly during the workday, with or without applying force. (Occasional postures should not be considered)?':
		'¿Adopatar posturas forzadas en forma habitual durante la jornada de trabajo, con o sin aplicación de fuerza. (No se deben considerar  si las posturas son ocasionales)?',
	'Is the neck in extension, flexion, lateralization, and/or rotation?':
		'¿Cuello en extensión, flexión, lateralización y/o rotación?',
	'Are the arms above shoulder level or with movements of supination, pronation, or rotation?':
		'¿Brazos por encima de los hombros o con movimientos de supinación, pronación o rotación?',
	'Are the wrists and hands in flexion, extension, ulnar or radial deviation?':
		'¿Muñecas y manos en flexión, extensión, desviación cubital o radial?',
	'Is the waist in flexion, extension, lateralization, and/or rotation?':
		'¿Cintura en flexión, extensión, lateralización y/o rotación?',
	'Are the lower limbs working in a kneeling or squatting position?':
		'¿Miembros inferiores: trabajo en posición de rodillas o en cuclillas?',
	'Working with tools that produce vibrations (jackhammer, drill, screwdrivers, polishers, grinders, others)?':
		'¿Trabajar con herramientas que producen vibraciones (martillo neumático, perforadora, destornilladores, pulidoras, esmeriladoras, otros)?',
	'Holding pieces with hands while they are being machined?':
		'¿Sujetar piezas con las manos mientras estas son mecanizadas?',
	'Holding levers, steering wheels, etc. that transmit vibrations?':
		'¿Sujetar palancas, volantes, etc. que transmiten vibraciones?',
	'Does the vibration value exceed the limits established in Table I, in the section corresponding to Hand-Arm Vibration, Annex V, Resolution MTEySS N° 295/03?':
		'¿El valor de las vibraciones supera los límites establecidos en la Tabla I, de la parte correspondiente a Vibración (segmental) mano-brazo, del Anexo V, Resolución MTEySS N° 295/03?',
	'Are uncomfortable temperatures perceived in the workplace for performing tasks?':
		'¿En el puesto de trabajo se perciben temperaturas no confortables para la realización de las tareas?',
	'Is the result of using the Fanger Comfort Curve outside the comfort zone?':
		'¿El resultado del uso de la Curva de Confort de Fanger está fuera de la zona de confort?',
	'Is any part of the body resting under pressure against a tool, work surface, machine tool, or parts and materials?':
		'¿Mantener apoyada alguna parte del cuerpo ejerciendo una presión, contra una herramienta, plano de trabajo, máquina herramienta o partes y materiales?',
	'Does the worker rest their wrist, forearm, armpit, thigh, or another body segment on a sharp or edged surface?':
		'¿El trabajador mantiene apoyada la muñeca, antebrazo, axila o muslo u otro segmento corporal sobre una superficie aguda o con canto?',
	'Does the worker use hand tools or manipulate parts that press on their fingers and/or dominant hand palm?':
		'¿El trabajador utiliza herramientas de mano o manipula piezas que presionan sobre sus dedos y/o palma de la mano hábil?',
	'Does the worker perform percussion movements on parts or tools?':
		'¿El trabajador realiza movimientos de percusión sobre piezas o herramientas?',
	'Does the worker show any early signs of the diseases mentioned in Article 1 of this Resolution?':
		'¿El trabajador presenta algún signo temprano de las enfermedades mencionadas en el Artículo 1° de la presente Resolución?',

	'Borg Scale': 'Escala de Borg',
	'No effort': 'Ausencia de esfuerzo',
	'Very low effort, barely perceptible': 'Esfuerzo muy bajo, apenas perceptible',
	'Very weak effort': 'Esfuerzo muy débil',
	'Weak / light effort': 'Esfuerzo débil / ligero',
	'Moderate / regular effort': 'Esfuerzo moderado / regular',
	'Somewhat strong effort': 'Esfuerzo algo fuerte',
	'Strong effort': 'Esfuerzo fuerte',
	'Very strong effort': 'Esfuerzo muy fuerte',
	'Extremely strong effort': 'Esfuerzo extremadamente fuerte',
	'The level of risk is tolerable, so no measures are required. However, a preventive evaluation can be conducted on the next page if requested by any of the responsible parties.':
		'El nivel de riesgo es tolerable, por lo que no se requieren medidas. Sin embargo, se puede realizar una evaluación preventiva en la siguiente página si es solicitada por cualquiera de las partes responsables.',
	'The risk level is not tolerable; therefore, a risk evaluation by a professional knowledgeable in ergonomics is required. Proceed to the next page to conduct the evaluation':
		'El nivel de riesgo no es tolerable; por lo tanto, se requiere una evaluación de riesgo por parte de un profesional con conocimientos en ergonomía. Proceder a la siguiente página para realizar la evaluación.',
	Step: 'Paso',
	'Select an evaluator': 'Seleccionar un evaluador',
	'Select an employer': 'Seleccionar un empleador',
	'Please enter an evaluator': 'Por favor ingresar un evaluador',
	'Please enter an employer': 'Por favor ingresar un empleador',
	'Select activity': 'Seleccionar tarea',
	'Enter activity name': 'Ingresar nombre de tarea',
	'Are you sure you want to delete the action plan': '¿Estás seguro de querer eliminar el plan de acción?',
	'Please develop action plans for all not tolerable and moderate risks before proceeding':
		'Por favor, elabore planes de acción para todos los riesgos no tolerables y moderados antes de continuar',
	'Answer the previous questions, create and review the action plans (corrective and preventive measures)':
		'Responda las preguntas previas, cree y revise los planes de acción (medidas correctivas y preventivas)',
	'General preventive measures': 'Medidas preventivas generales',
	'The worker(s), supervisor(s), engineer(s), and management related to the workstation have been informed about the risk associated with the task of developing MSD':
		'Se ha informado al trabajador/es, supervisor/es, ingeniero/s y directivo/s relacionados con el puesto de trabajo, sobre el riesgo que tiene la tarea de desarrollar TME',
	'The worker(s) and supervisor(s) related to the workstation have been trained on identifying symptoms related to the development of MSD':
		'Se ha capacitado al trabajador/es y supervisore/es relacionados con el puesto de trabajo, sobre la identificación de síntomas relacionados con el desarrollo de TME',
	'The worker(s) and supervisor(s) related to the workstation have been trained on the measures and/or procedures to prevent the development of MSD':
		'Se ha capacitado al trabajador/es y supervisore/es relacionados con el puesto de trabajo, sobre las medidas y/o procedimientos para prevenir el desarrollo de TME',
	'Specific corrective and preventive measures': 'Medidas correctivas y preventivas específicas',
	'Action plans must be developed for risks classified as moderate and not tolerable.':
		'Deben elaborarse obligatoriamente planes de acción para los riesgos clasificados como moderados y no tolerables.',
	'View previous evaluation': 'Ver evaluación anterior',
	'General Preventive Measures and Observations': 'Medidas Preventivas Generales',
	'General Preventive Measures': 'Medidas Preventivas Generales',
	'Specific administrative corrective and preventive measure':
		'Medida corretiva y preventiva específica administrativa',
	'Specific engineering corrective and preventive measure': 'Medida correctiva y preventiva específica de ingenieria',
	'General information': 'Información general',
	'Identification of risk factors': 'Identificación de factores de riesgos',
	'Total exposure time': 'Tiempo total de exposición ',
	'Risk level': 'Nivel de riesgo',
	'Follow-up on preventive measures': 'Seguimiento de medidas preventivas',
	'Implementation Date (Administrative Measure)': 'Fecha de implementación (Medida administrativa)',
	'Implementation Date (Engineering Measure)': 'Fecha de implementación (Medida de ingeniería)',
	'Evaluation date': 'Fecha de evaluación',
	'Lifting and lowering': 'Levantamiento y descenso',
	'Not tolerable risk': 'Riesgo no tolerable',
	'Evaluation completed': 'Evaluación finalizada',
	'Please identify the tasks and evaluate them before continuing':
		'Por favor, identifique las tareas y realice su evaluación antes de continuar',
	'This field is required': 'Este campo es requerido',
	'Enter your observations': 'Ingrese sus observaciones',
	'Please select one or more videos before continuing': 'Por favor, seleccione uno o más videos antes de continuar',
	'Insert a title': 'Insertar un título',
	'Select priority': 'Seleccionar prioridad',
	'Please select a response': 'Por favor, seleccione una respuesta',
	'Push / Pull': 'Empuje / arraste',
	'Date of initial version': 'Fecha de la versión inicial',
	'Name of evaluation': 'Nombre de la evaluación',
	'Location of the symptom': 'Ubicación del sintoma',
	'Activity (task)': 'Actividad (tarea)',
	'Work position': 'Puesto de trabajo',
	'The worker(s), supervisor(s), engineer(s), and management related to the job have been informed about the risks associated with the task of developing MSD':
		'Se ha informado al trabajador/es, supervisor/es, ingeniero/s y directivo/s relacionados con el puesto de trabajo, sobre el riesgo que tiene la tarea de desarrollar TME',
	'The worker(s) and supervisor(s) related to the job have been trained on identifying symptoms related to the development of MSD':
		'Se ha capacitado al trabajador/es y supervisore/es relacionados con el puesto de trabajo, sobre la identificación de síntomas relacionados con el desarrollo de TME',
	'Task Name': 'Nombre de la tarea',
	'Select responsible': 'Seleccionar responsable',
	'Task Name is required': 'El nombre de la tarea es requerido',
	'Attach file': 'Adjuntar archivo',
	'Edit action plan': 'Editar plan de acción',
	'Hand - arm vibration': 'Vibración mano - brazo',
	'Name of worker(s)': 'Nombre del trabajador(es)',
	'Use previous files': 'Usar archivos anteriores',
	filesQuantity: 'Por favor, seleccione {{qty}} archivos antes de continuar',
	'Review not started': 'Revisión no iniciada',
	'Review completed': 'Revisión finalizada',
	Evaluated: 'Evaluado',
	'The worker(s), supervisor(s), engineer(s), and management related to the workstation have been informed about the risks associated with the task of developing MSD':
		'Se ha informado al trabajador/es, supervisor/es, ingeniero/s y directivo/s relacionados con el puesto de trabajo, sobre el riesgo que tiene la tarea de desarrollar TME',
	'No data': 'No hay datos',
	Finished: 'Terminado',
	'Not finished': 'No terminado',
	'General Version': 'Versión general',
	'Risk Factor / Version': 'Factor de riesgo',
	'Lifting loads': 'Levantamiento de cargas',
	'Worst risk level': 'Peor nivel de riesgo',
	'Task evaluations': 'Evaluación de tareas',
	'Attachment I - Spreadsheet 1: Identification of risk factors':
		'Anexo I - Planilla 1: Identificación de factores de riesgo',
	'Spreadsheet 2: Initial risk factor evaluations': 'Planilla 2: Evaluación inicial de factores de riesgo',
	'Spreadsheet 3: Specific corrective and preventive measures':
		'Planilla 3: Identificación de medidas correctivas y preventivas',
	'Spreadsheet 4: Follow-up on preventive measures': 'Planilla 4: Matriz de seguimiento de medidas preventivas',
	'Select the items you want to display in your document':
		'Selecciona los elementos que deseas mostrar en tu documento',
	ErgonomicVibrationTools886: 'Clasificación de riesgo por vibración definida en la norma {{tool_name}}:',
	'Fill out the complete JDS-D86': 'Rellenar el JDS-D86 completo',
	'Edit on JDS-D86': 'Editar en JDS-D86',
	'Invalid workers number':
		'Número de trabajadores inválido, el número de trabajadores debe ser igual al número de trabajadores seleccionados.',
	'Initial version': 'Versión inicial',
	'Fill tool': 'Rellenar herramienta',
	'Fill tool on JDS-D86': 'Rellenar en JDS-D86',
	EvaluationErgonomicRisk886:
		' La herramienta {{ergonomic_tool_name}} puede utilizarse como respaldo técnico en la evaluación.',
	'Backup tool:': 'Herramienta de respaldo:',
	'Vibration risk classification (JDS-D86)': 'Clasificación de riesgo por vibración (JDS-D86)',
	'You must consolidate the last review before creating a new version':
		'Debe consolidar la última revisión antes de crear una nueva versión',
	'You must consolidate the last review before downloading the PDF':
		'Debe consolidar la última revisión antes de descargar el PDF',
	'Error: Report file not found': 'Error: Archivo del informe no encontrado',
	'PDF downloaded successfully': 'PDF descargado exitosamente',
	'Error downloading PDF. Please try again.': 'Error al descargar PDF. Intente nuevamente.',
	'Download PDF Report': 'Descargar Informe PDF',
	'Action plans must be developed obligatorily for risks classified as moderate and not tolerable.':
		'Los planes de acción consisten en medidas correctivas y preventivas frente a este Factor de Riesgo',
	Continue: 'Continuar',
	'Technical support': 'Respaldo técnico',
	'Deconsolidate the report': 'Desconsolidar el informe',
	'Report consolidated successfully': 'Informe consolidado con éxito',
	'Report desconsolidated successfully': 'Informe desconsolidado con éxito',
	'Worker created successfully': 'Trabajador creado con éxito',
	'Employer created successfully': 'Contratante creado con éxito',
	'Overview of risk factors': 'Identificación de factores de riesgo',

	// ROSA - Rapid Office Strain Assessment
	'Generate action plan': 'Generar plan de acción',
	Section: 'Sección',
	'Create actions to address the problems encountered.': 'Crea acciones para resolver los problemas encontrados.',
	'Create actions to address the problems encountered': 'Crea acciones para resolver los problemas encontrados',
	Evaluation: 'Evaluación',
	'Pre-set specific characteristics': 'Pre-establecer características específicas',
	Chair: 'Silla',
	chair: 'silla',
	'Monitor and Phone': 'Monitor y Teléfono',
	'Mouse and Keyboard': 'Ratón y Teclado',
	'Peripherals and Monitor': 'Periféricos y Monitor',
	'Final score': 'Puntuación final',
	'Analysis date': 'Fecha de análisis',
	'Enter the date of analysis': 'Ingrese la fecha de análisis',
	'Please enter a report name': 'Por favor, ingrese un nombre de informe',
	'Enter the data related to the new analysis below':
		'Ingrese los datos relacionados con el nuevo análisis a continuación',
	'Other elements': 'Otros elementos',
	'New element': 'Nuevo elemento',
	Priority: 'Prioridad',
	Provide: 'Proporcionar',
	'Failed to create elements': 'Error al crear elementos',
	'Required elements': 'Elementos requeridos',
	'Prioritize the required elements': 'Priorizar los elementos requeridos',
	Maintenance: 'Mantenimiento',
	'Upload image': 'Subir imagen',
	'Upload images of the activity being evaluated': 'Subir imágenes de la actividad que se está evaluando',
	Image: 'Imagen',
	Images: 'Imágenes',
	'Do you really want to delete this image?': '¿Realmente desea eliminar esta imagen?',
	'Add file': 'Agregar archivo',
	'General information': 'Información general',

	CHANGE: 'CAMBIAR',
	MAINTENANCE: 'MANTENIMIENTO',
	PROVIDE: 'PROPORCIONAR',

	'Knees at 90°': 'Rodillas en 90°',
	'Very low - Knee angle < 90°': 'Muy bajo - Ángulo de rodilla < 90°',
	'Very high - Knee angle > 90º': 'Muy alto - Ángulo de rodilla > 90º',
	'No foot contact with the floor': 'Sin contacto de pie con el suelo',
	'Insufficient space at the bottom of the desk - No leg mobility':
		'Espacio insuficiente en la parte baja del escritorio - No hay movilidad para las piernas',
	'Not adjustable': 'No ajustable',
	'Approximately 8 centimeters of space between the knee and the edge of the seat or chair':
		'Aproximadamente 8 centímetros de espacio entre la rodilla y el borde del asiento o silla',
	'Very long - Less than 8 centimeters of space': 'Muy largo - Menos de 8 centímetros de espacio',
	'Very short - More than 8 centimeters spacing': 'Muy corto - Más de 8 centímetros de espacio',
	'Elbows supported in line with the shoulder - Shoulders relaxed':
		'Codos apoyados en línea con el hombro - Hombros relajados',
	'Very high (Shoulders shrugged) / Low (Unsupported arms)':
		'Muy alto (Hombros encogidos) / Bajo (brazos no apoyados)',
	'Very hard or damaged surface': 'Superficie muy dura o dañada',
	'Very wide': 'Muy ancha',
	'Adequate lumbar support - Chair reclines between 95° and 110º':
		'Soporte lumbar adecuado - Silla reclina entre 95° y 110º',
	'No lumbar support or lumbar support not positioned on the lower back':
		'Sin apoyo lumbar o apoyo lumbar no posicionado en la espalda baja',
	'Backrest angle too far back (greater than 110º) or angle too far forward (less than 95º)':
		'Ángulo del respaldo demasiado lejos de atrás (mayor que 110º) o ángulo demasiado lejos hacia adelante (menor que 95º)',
	'Without backrest or lumbar support (e.g. on a stool or leaning forward)':
		'Sin respaldo o soporte lumbar (ex: en una silla o agacharse hacia adelante)',
	'Backless back - Non-adjustable': 'Respaldo de trás - No ajustable',
	'Length or distance measured with the arm (40 to 75 cms) / Screen at eye level':
		'Medida de longitud o distancia medida con el brazo (40 a 75 cms) / Pantalla en nivel de ojo',
	'Very low (Below 30º)': 'Muy bajo (Abajo de 30º)',
	'Far away': 'Muy lejos',
	'Very high (Neck in extension)': 'Muy alto (Cuello en extensión)',
	'Neck rotated more than 30º': 'Cuello rotado más de 30º',
	'Glare on the screen': 'Brillo en la pantalla',
	'No use of lecterns or document holders, if required': 'Sin uso de atriles o porta documentos, si es necesario',
	'Very high (Neck in extension) / Very low (Below 30º)': 'Muy alto (Cuello en extensión) / Muy bajo (Abajo de 30º)',
	'Very high work surface (shrugged shoulders)': 'Superficie de trabajo muy alta (hombros encogidos)',
	'Headphones with microphones, one hand on the phone and neutral neck posture':
		'Auriculares con micrófonos, una mano en el teléfono y postura de cuello neutral',
	'Too far for the range (More than 30cms separation)': 'Muy lejos para el alcance (Más de 30cms de separación)',
	'Holding the phone with the neck and shoulder': 'Sosteniendo el teléfono con el cuello y el hombro',
	'No hands-free option': 'Sin opción de manos libres',
	'Mouse in line with shoulder': 'Ratón en línea con el hombro',
	'Reaching for the mouse / Arm in abduction': 'Alcanzar el ratón / Brazo en abducción',
	'Mouse and keyboard on surfaces of different levels': 'Ratón y teclado en superficies de diferentes niveles',
	'Gripper grip on the mouse': 'Agarre de pinza en el ratón',
	'Wrist rest in front of the mouse': 'Descanso de muñeca frente al ratón',
	'Wrists straight - Shoulders relaxed': 'Muñecas rectas - Hombros relajados',
	'Wrists extended - Keyboard at positive angle ( > 15º Extension of wrists)':
		'Muñecas extendidas - Teclado en ángulo positivo ( > 15º Extensión de muñecas)',
	'Deviation of the wrists during transcription or typing':
		'Desviación de las muñecas durante la transcripción o el tecleo',
	'Keyboard too high, shoulders shrugged': 'Teclado demasiado alto, hombros encogidos',
	'Reaching for items or objects overhead': 'Alcanzar objetos o elementos sobre la cabeza',
	'Non-adjustable keyboard platform': 'Plataforma de teclado no ajustable',

	'Element deleted successfully': 'Elemento eliminado con éxito',
	'Image deleted successfully': 'Imagen eliminada con éxito',
	'Rosa report updated successfully!': '¡Informe ROSA actualizado con éxito!',
	'Fail to save the comments': 'Error al guardar los comentarios',
	'Error save duration!': '¡Error al guardar la duración!',
	'Error save element!': '¡Error al guardar el elemento!',
	'Image updated successfully': 'Imagen actualizada con éxito',

	'Select options for category': 'Seleccione opciones para la categoría',
	'Select one element of the first line of subcategory':
		'Seleccione un elemento de la primera línea de la subcategoría',

	'Chair height': 'Altura de la silla',
	'Chair Height': 'Altura de la silla',
	'Seat depth': 'Profundidad del asiento',
	Armrests: 'Reposabrazos',
	'Seat backrest': 'Respaldo del asiento',
	Mouse: 'Ratón',
	Keyboard: 'Teclado',
	Monitor: 'Monitor',
	Phone: 'Teléfono',

	'Final score ROSA': 'Puntuación final ROSA',
	'Scoring by section': 'Puntuación por sección',
	'Seat Backrest': 'Respaldo del asiento',
	Footrest: 'Reposapiés',
	Headband: 'Diadema',
	'Fixed monitor base': 'Base de monitor fija',
	'Portable monitor stand': 'Soporte de monitor portátil',
	'Channeling cables': 'Canalización de cables',
	'Priority level of the demand, being 1 medium priority and 2 high priority.':
		'Nivel de prioridad de la demanda, siendo 1 prioridad media y 2 prioridad alta.',
	'Low priority': 'Prioridad baja',
	'Medium priority': 'Prioridad media',
	'High priority': 'Prioridad alta',
	'Select a priority': 'Seleccione una prioridad',
	'Administrative activities analysis': 'Análisis de actividades administrativas',
	'Do you really want to delete this element?': '¿Realmente desea eliminar este elemento?',
	'Select the items you want to present in your document':
		'Seleccione los elementos que desea presentar en su documento',
	'Filling details': 'Completando detalles',
	'Image description': 'Descripción de la imagen',
	'Generate document': 'Generar documento',
	Filename: 'Nombre del archivo',

	'Task already exist': 'Tarea ya existe',
	'Task not created': 'Tarea no creada',

	// ROSA Action Plan
	'Action plan generated': 'Plan de acción generado',
	'Add action': 'Agregar acción',
	'Action title': 'Título de la acción',
	'Add action title': 'Agregar título de la acción',
	'Responsible user': 'Usuario responsable',
	'Select a responsible user': 'Seleccione un usuario responsable',
	Deadline: 'Fecha límite',
	'Select a deadline': 'Seleccione una fecha límite',
	'Action description': 'Descripción de la acción',
	'Add action description': 'Agregar descripción de la acción',
	'Task title': 'Título de la tarea',
	'Add a task title': 'Agregar título de tarea',
	'Add task': 'Agregar tarea',
	Tasks: 'Tareas',
	'No tasks': 'Sin tareas',
	'Delete action': 'Eliminar acción',
	'Do you really want to delete this action?': '¿Realmente desea eliminar esta acción?',
	'Action deleted successfully': 'Acción eliminada con éxito',
	'Failed to delete action': 'Error al eliminar la acción',
	'Action created successfully': 'Acción creada con éxito',
	'Failed to create action': 'Error al crear la acción',
	'Action updated successfully': 'Acción actualizada con éxito',
	'Failed to update action': 'Error al actualizar la acción',

	// ROSA Result
	Result: 'Resultado',
	Comments: 'Comentarios',
	'Add comments': 'Agregar comentarios',
	'Section A': 'Sección A',
	'Section B': 'Sección B',
	'Section C': 'Sección C',
	'Section D': 'Sección D',
	'Chair section': 'Sección de silla',
	'Monitor and phone section': 'Sección de monitor y teléfono',
	'Mouse and keyboard section': 'Sección de ratón y teclado',
	'Download PDF': 'Descargar PDF',
	'Generating PDF...': 'Generando PDF...',
	'PDF generated successfully': 'PDF generado con éxito',
	'Failed to generate PDF': 'Error al generar PDF',
	'Include images': 'Incluir imágenes',
	'Include action plans': 'Incluir planes de acción',
	'Include comments': 'Incluir comentarios',

	// ROSA Hierarchy (John Deere specific - using Line instead of Cellule)
	Line: 'Línea',
	'Select a line': 'Seleccione una línea',
	'Line name': 'Nombre de la línea',

	// ROSA Risk levels
	'Negligible risk': 'Riesgo insignificante',
	'Low risk': 'Riesgo bajo',
	'Medium risk': 'Riesgo medio',
	'High risk': 'Riesgo alto',
	'Very high risk': 'Riesgo muy alto',
	Acceptable: 'Aceptable',
	'Investigate further': 'Investigar más',
	'Investigate and change': 'Investigar y cambiar',

	// ROSA Duration
	'Duration (hours)': 'Duración (horas)',
	'Enter the duration': 'Ingrese la duración',
	'Duration must be a number': 'La duración debe ser un número',
	'Duration must be greater than 0': 'La duración debe ser mayor a 0',
	'Duration must be less than 24': 'La duración debe ser menor a 24',
	'Task not created': 'Tarea no creada',
	'Category value not found': 'Valor de categoría no encontrado',
	'Failed to update frame': 'Error al actualizar frame',
	'Frames not created': 'Error al crear frames',
	'Frame not found': 'Frame no encontrado',
	'Frame not updated': 'Frame no actualizado',
	'Frame updated successfully': 'Frame actualizado exitosamente',
	'There is frames not evaluated': 'Hay frames no evaluados',

	// OWAS
	'Highest score': 'Pontuación más alta',
	'Analysis date': 'Fecha del análisis',
	'Activity description': 'Descripcion de la actividad',
	Productivity: 'Productividad',
	'Number of exposed': 'Número de expuestos',
	'Capture interval': 'Intervalo de captura',
	'in seconds': 'en segundos',
	'Enter the report name': 'Insertar el nombre del informe',
	'Enter the sector': 'Insertar el sector',
	'Enter the activity': 'Insertar la actividad',
	'Enter the evaluator': 'Insertar el evaluador',
	'Enter the analysis date': 'Insertar la fecha de análisis',
	'Enter the activity description': 'Insertar descripción de la actividad',
	'Number of exposed must be greater than 0': 'El número de expuestos debe ser superior a 0',
	'Enter the capture interval': 'Insertar el intervalo de captura',
	'Set the time interval, in seconds, for capturing video frames.':
		'Establezca el intervalo de tiempo, en segundos, para capturar cuadros de vídeo.',

	'Report deconsolidated successfully': 'Reporto desconsolidado exitosamente',
	'Report consolidated but PDF not generated': 'Reporto consolidado, pero PDF no generado',

	'Description of the activity': 'Descripción de la actividad',
	'Overall task risk': 'Riesgo global de la actividad',

	Explanation: 'Explicación',
	'No action required': 'No requiere acción',
	'Normal and natural posture without harmful effects on the musculoskeletal system':
		'Postura normal y natural sin efectos dañinos en el sistema músculo-esquelético',
	'Corrective actions required in the near future': 'Se requieren acciones correctivas en un futuro cercano',
	'Posture with the possibility of causing damage to the musculoskeletal system':
		'Postura con posibilidad de causar daño al sistema músculo-esquelético',
	'Corrective actions are required as soon as possible': 'Se requiere acciones correctivas lo antes posible',
	'Posture with harmful effects on the musculoskeletal system':
		'Postura con efectos dañinos sobre el sistema músculo-esquelético',
	'Corrective actions need to be taken immediately': 'Se requiere tomar acciones correctivas inmediatamente',
	'The load caused by this posture has extremely harmful effects on the musculoskeletal system':
		'La carga causada por esta postura tiene efectos sumamente dañinos sobre el sistema músculo-esquelético',
	'Tasks with the most serious risks': 'Tareas con los riesgos más graves',
	'Risk of the tasks': 'Riesgo de las tareas',
	'Manual tools': 'Herramientas manuales',
	'Category 1': 'Categoría 1',
	'Category 2': 'Categoría 2',
	'Category 3': 'Categoría 3',
	'Category 4': 'Categoría 4',
	'Risk by segment and exposure time': 'Riesgo por segmento y tiempo de exposición',

	'Upper limbs': 'Miembros superiores',
	'Lower limbs': 'Miembros inferiores',

	'Computer vision identified the positions of each task, review and add the required information':
		'La visión por computadora identificó las posiciones de cada tarea, revise y agregue la información necesaria',
	'Search for a task': 'Buscar una tarea',
	'All tasks': 'Todas las tareas',
	'Tasks not analyzed': 'Tareas no analizadas',
	'Task name': 'Nombre de la tarea',
	'Overall risk of the task': 'Riesgo global de la postura:',
	'The colors shown do not refer to the OWAS tool.':
		'Los colores representados no hacen referencia a la herramienta OWAS.',
	'Computer vision does not detect back twisting.': 'La visión por computadora no detecta la torsión de la espalda.',
	Straight: 'Recta',
	Bent: 'Flexionada',
	'Straight and rotated': 'Recta y con giro',
	'Bent and rotated': 'Flexionada y con giro',
	'Two arms down': 'Dos brazos abajo',
	'One arm up': 'Un brazo arriba',
	'Two arms up': 'Dos brazos arriba',
	Sitting: 'Sentado',
	'Standing on two straight legs': 'De pie sobre dos piernas rectas',
	'Standing on one straight legs': 'De pie sobre una pierna estirada',
	'Standing or squatting on two flexed legs': 'De pie o en cuclillas sobre dos piernas flexionadas',
	'Standing or squatting on one bent leg': 'De pie o en cuclillas sobre una pierna flexionada',
	Walking: 'Caminando',
	'Task risk': 'Riesgo de la tarea',
	'Less than 10kg': 'Menos de 10 kilogramos',
	'Between 10kg and 20kg': 'Entre 10 y 20 kilogramos',
	'More than 20kg': 'Más de 20 kilogramos',
	'Select the task name': 'Seleccione el nombre de la tarea',
	'Enter the manual tools': 'Insertar las herramientas manuales',
	'Perform the evaluation of the tables': 'Realice la evaluación de los cuadros',
	'Capture interval should be less than the file duration':
		'El intervalo de captura debe ser menor que la duración del vídeo',
	'5 and 6': '5 y 6',
	'7, 8 and 9': '7, 8 y 9',
	'Due date': 'Fecha de vencimiento',
	'Lifting and transportation': 'Levantamiento y transporte',
	'Load transport in pairs?': 'Transporte de carga en pares?',
	'Workday duration': 'Duración del dia de trabajo',
	'Activity duration': 'Duración de la actividad',
	'Select activity': 'Seleccione la actividad',
	'Please select an activity': 'Por favor, seleccione una actividad',
	'Collect date': 'Fecha de coleta',
	'The field requires an answer': 'El campo requiere una respuesta',
	'To proceed, please fill in all required information':
		'Para continuar, por favor, complete toda la información requerida',
	'Women:': 'Mujeres:',
	'Men:': 'Hombres:',
	'Start/End': 'Inicio/Término',
	'End/Start': 'Término/Inicio',
	'KIM LHC: Manual lifting, holding, and carrying of loads':
		'KIM LHC: Levantamiento, sostención y transporte de cargas',
	'Work Organization': 'Organización del trabajo',
	'Work organization': 'Organización del trabajo',
	'Partial result': 'Resultado parcial',
	Unfavorable: 'Desfavorable',
	'Frequent variation of the physical load situation due to other activities (including other types of physical load) / without a rigid sequence of heavy physical loads within a single type of physical load during a single working day':
		'Variación frecuente de la situación de carga física debido a otras actividades (incluidos otros tipos de carga física) / sin una secuencia rígida de cargas físicas elevadas dentro de un mismo tipo de carga física durante un solo día de trabajo',
	'Rare variation of the physical load situation due to other activities (including other types of physical load) / occasional sequence of heavy physical loads within a single type of physical load during a single working day':
		'Variación rara de la situación de carga física debido a otras actividades (incluidos otros tipos de carga física) / secuencia ocasional de cargas físicas elevadas dentro de un mismo tipo de carga física durante un solo día de trabajo',
	'No or almost no variation of the physical load situation due to other activities (including other types of physical load) / frequent sequence of heavy physical loads within a single type of physical load during a single working day, with simultaneous load peaks':
		'Ninguna o casi ninguna variación de la situación de carga física debido a otras actividades (incluidos otros tipos de carga física) / secuencia frecuente de cargas físicas elevadas dentro de un mismo tipo de carga física durante un solo día de trabajo, con picos de carga simultáneos',
	'Error loading result': 'Error al cargar resultado',
	'Unknown error': 'Error desconocido',
	'No data available': 'No hay datos disponibles',
	'Score for men': 'Puntuación para hombres',
	'Score for women': 'Puntuación para mujeres',
	'Probability of physical overload': 'Probabilidad de sobrecarga física',
	'Possible health consequences': 'Posibles consecuencias para la salud',
	Measures: 'Medidas',
	Results: 'Resultados',
	'KIM LHC: Manual Lifting, Holding and Carrying': 'KIM LHC: Levantamiento, sostención y transporte manual de cargas',
	'CLIENT LOGO': 'LOGO DEL CLIENTE',
	'General information': 'Información general',
	'Collection date:': 'Fecha de recolección:',
	'Report date:': 'Fecha del informe:',
	'Transporting cargo in pairs:': 'Transporte de carga en parejas:',
	Yes: 'Sí',
	No: 'No',
	'Work day duration:': 'Duración del día de trabajo:',
	minutes: 'minutos',
	'Activity duration:': 'Duración de la actividad:',
	'Score men:': 'Puntuación hombre:',
	'Score women:': 'Puntuación mujer:',
	'Score:': 'Puntuación:',
	'Score by category': 'Puntuación por categoría',
	'Close all': 'Cerrar todo',
	Comment: 'Comentario',
	'Add your comments here': 'Agregue sus comentarios aquí',
	'Transporting cargo in pairs': 'Transporte de carga en parejas',
	'Inclined weight': 'Peso inclinado',
	'Effective load:': 'Carga efectiva:',
	Frequency: 'Frecuencia',
	'Body posture': 'Postura corporal',
	'Work organization / time distribution': 'Organización del trabajo / distribución temporal',
	Posture: 'Postura',
	Result: 'Resultado',
	Results: 'Resultados',
	'KIM LHC: Manual Lifting, Holding and Carrying':
		'KIM LHC: Levantamiento, sustentación y transporte manual de cargas',
	'General information': 'Informaciones generales',
	'Collection date:': 'Fecha de recolección:',
	'Report date:': 'Fecha del informe:',
	'Transporting cargo in pairs:': 'Transporte de carga en parejas:',
	'Work day duration:': 'Duración del día de trabajo:',
	'Activity duration:': 'Duración de la actividad:',
	minutes: 'minutos',
	'CLIENT LOGO': 'LOGO CLIENTE',
	'Client Logo': 'Logo del cliente',
	'Score for men': 'Puntuación para hombres',
	'Score for women': 'Puntuación para mujeres',
	'Probability of physical overload': 'Probabilidad de sobrecarga física',
	'Possible health consequences': 'Posibles consecuencias para la salud',
	Measures: 'Medidas',
	'Low risk': 'Riesgo bajo',
	'Slightly elevated risk': 'Riesgo ligeramente elevado',
	'Substantially elevated risk': 'Riesgo sustancialmente elevado',
	'High risk': 'Riesgo alto',
	'Score by category': 'Puntuación por categoría',
	'Close all': 'Cerrar todo',
	'Score:': 'Puntuación:',
	'Score men:': 'Puntuación hombre:',
	'Score women:': 'Puntuación mujer:',
	Frequency: 'Frecuencia',
	'Load weight': 'Peso de la carga',
	'Cargo handling conditions': 'Condiciones de manejo de carga',
	'Body posture': 'Postura corporal',
	'Unfavorable working conditions': 'Condiciones de trabajo desfavorables',
	'Work organization / time distribution': 'Organización del trabajo / distribución temporal',
	'Up to 300 times per activity and work shift': 'Hasta 300 veces por actividad y turno de trabajo',
	'Between 300 and 1500 times per activity and work shift': 'Entre 300 y 1500 veces por actividad y turno de trabajo',
	'More than 1500 times per activity and work shift': 'Más de 1500 veces por actividad y turno de trabajo',
	'Effective load:': 'Peso efectivo:',
	'The effective load weight corresponds to the physical effort actually exerted. When tilting a box, 50% of the weight is applied when transporting in pairs, 60% affects each person':
		'*El peso efectivo de la carga corresponde al esfuerzo físico realmente ejercido. Al inclinar una caja, se aplica el 50% del peso al transportar en parejas, el 60% afecta a cada persona',
	'Transport in pairs': 'Transporte en parejas',
	'The load can be handled close to the body': 'La carga puede ser manejada cerca del cuerpo',
	'The load cannot be handled close to the body': 'La carga no puede ser manejada cerca del cuerpo',
	'The load is temporarily handled with one hand and/or asymmetrically, with unequal weight distribution between both hands':
		'La carga se maneja temporalmente con una mano y/o de forma asimétrica, con distribución desigual del peso entre las dos manos',
	'Start/End': 'Inicio/Fin',
	'End/Start': 'Fin/Inicio',
	'Frequent or constant twisting and/or lateral bending of the trunk identifiable':
		'Torsión y/o inclinación lateral frecuente o constante del tronco identificable',
	'Load center and/or hands frequently or constantly away from the body':
		'Centro de carga y/o manos frecuentemente o constantemente alejados del cuerpo',
	'Arms frequently or constantly elevated, with hands between elbow and shoulder level':
		'Brazos frecuentemente o constantemente elevados, con las manos entre el nivel del codo y el hombro',
	'Hands frequently or constantly above shoulder height':
		'Manos frecuentemente o constantemente por encima de la altura del hombro',
	'No unfavorable condition marked': 'Ninguna condición desfavorable marcada',
	'Up to': 'Hasta',
	'times per activity and work shift': 'veces por actividad y turno de trabajo',
	'with load inclination': 'con inclinación de la carga',
	'transported in pairs': 'transportado en pareja',
	'Effective weight': 'Peso efectivo',
	'The effective weight is the adjusted load weight used in the risk score calculation':
		'El peso efectivo es el peso de la carga ajustado utilizado en el cálculo de la puntuación de riesgo',
	'No unfavorable conditions reported': 'No hay condiciones desfavorables reportadas',
	'No work organization data available': 'No hay datos de organización del trabajo disponibles',
	'No additional posture factors reported': 'No hay factores adicionales de postura reportados',
	'Restricted: Rare variation of the physical load situation due to other activities (including other types of physical load) / occasional sequence of high physical loads within the same type of physical load during a single working day':
		'Restringido: Variación rara de la situación de carga física debido a otras actividades (incluidos otros tipos de carga física) / secuencia ocasional de cargas físicas elevadas dentro de un mismo tipo de carga física durante un único día de trabajo',
	'Significantly restricted: Rare variation of the physical load situation due to other activities (including other types of physical load) and occasional sequence of high physical loads within the same type of physical load during a single working day':
		'Significativamente restringido: Variación rara de la situación de carga física debido a otras actividades (incluidos otros tipos de carga física) y secuencia ocasional de cargas físicas elevadas dentro de un mismo tipo de carga física durante un único día de trabajo',
	Comment: 'Comentario',
	Text: 'Texto',
	'Error loading result': 'Error al cargar resultado',
	'Unknown error': 'Error desconocido',
	'No data available': 'No hay datos disponibles',
	'Load weight:': 'Peso de la carga:',
	Posture: 'Postura',
	'Inclined weight': 'Peso inclinado',
	'Add your comments here': 'Agregue sus comentarios aquí',
	'Slightly elevated risk': 'Riesgo ligeramente elevado',
	'Substantially elevated risk': 'Riesgo sustancialmente elevado',
	'High risk': 'Riesgo alto',
	'Industrial site': 'Planta industrial',
	'Deadline:': 'Fecha de vencimiento:',
	View: 'Visualizar',
	'Please enter the title': 'Por favor, ingrese el título',
	'Please select a responsible user': 'Por favor, seleccione un responsable',
	'Please select the due date': 'Por favor, seleccione la fecha límite',
	'Action plan priority level': 'Nivel de prioridad del plan de acción',
	'Estimated investment range': 'Rango de inversión estimado',
	'No action plan created': 'Ningún plan de acción creado',
	of: 'de',
	'Task responsible is required': 'El responsable de la tarea es obligatorio',
	'Task title is required': 'El título de la tarea es obligatorio',
	'New task': 'Nueva tarea',
	Doing: 'En progreso',
	Done: 'Completado',
	Showing: 'Mostrando',
	Risk: 'Riesgo',
	'Enter the data related to the new analysis below':
		'Ingrese los datos relacionados con el nuevo análisis a continuación',
	'Report name is required': 'El nombre del informe es obligatorio',
	'Enter the report name': 'Ingrese el nombre del informe',
	'Organization is required': 'La organización es obligatoria',
	'Select an organization': 'Seleccione una organización',
	'Company is required': 'La empresa es obligatoria',
	'Evaluator is required': 'El evaluador es obligatorio',
	'Analysis date': 'Fecha de análisis',
	'Analysis date is required': 'La fecha de análisis es obligatoria',
	'Create report': 'Crear informe',
	'Saving...': 'Guardando...',
	'Please select an organization': 'Seleccione una organización',
	'Enter the analysis date': 'Ingrese la fecha de análisis',
	Activities: 'Actividades',
	'Select the activities that will compose your EWA': 'Seleccione las actividades que compondrán su AET',
	'All activities': 'Todas las actividades',
	'Selected activities': 'Actividades seleccionadas',
	'Evaluate the activities that compose your analysis': 'Evalúe las actividades que componen su análisis',
	'Detail the analysis': 'Detalle el análisis',
	'Analysis exceeds limit number of characters': 'El análisis excede el límite de caracteres',
	'Created by': 'Creado por',
	'Last consolidation by': 'Última consolidación por',
	'Last consolidation date': 'Fecha de la última consolidación',
	'N/A': 'N/A',
	'Detail the conclusion': 'Detalle la conclusión',
	'Conclusion exceeds limit number of characters': 'La conclusión excede el límite de caracteres',
	'Risk matrix': 'Matriz de riesgo',
	'Image Upload': 'Carga de imagen',
	'Demand and method': 'Demanda y método',
	'Inform demand and the method used in the evaluation': 'Informe demanda y el método utilizado en la evaluación',
	Demand: 'Demanda',
	'Detail the demands of the analysis': 'Detalle las demandas del análisis',
	'Demand exceeds limit number of characters': 'La demanda excede el límite de caracteres',
	'Select the method of the analysis': 'Seleccione el método del análisis',
	Public: 'Público',
	Custom: 'Personalizado',
	'Detail the method of the analysis': 'Detalle el método del análisis',
	'Method exceeds limit number of characters': 'El método excede el límite de caracteres',
	'Use pre-existing model as basis for new model': 'Utilice un modelo existente como base para un nuevo modelo',
	'Enter the method name': 'Ingrese el nombre del método',
	'Give a new name for the template': 'Asigne un nuevo nombre a la plantilla',
	'Do you really want to delete the template': '¿Realmente desea eliminar la plantilla',
	'Select the working conditions and job characteristics fields you wish to enter':
		'Seleccione los campos de condiciones de trabajo y características del puesto de trabajo que desea informar',
	'Working Conditions': 'Condiciones de trabajo',
	'Characteristic information is linked to the activity with the worst risk':
		'La información de características está vinculada a la actividad con peor riesgo',
	'Working conditions information is linked to the activity with the highest risk':
		'La información de condiciones de trabajo está vinculada a la actividad con mayor riesgo',
	'Insert the working hours': 'Ingrese las horas de trabajo',
	'Insert the working minutes': 'Ingrese los minutos de trabajo',
	'Simplified description of the performed task': 'Descripción simplificada de la tarea realizada',
	'Working hours': 'Horario de trabajo',
	'Insert a summary description of the workstation': 'Ingrese una descripción resumida del puesto de trabajo',
	'Detail a simplified description of the planned task':
		'Detalle una descripción simplificada de la tarea planificada',
	'Select the self-assessment of stress level': 'Seleccione la autoevaluación del nivel de estrés',
	'What level of stress does the worker perceive when carrying out the task?':
		'¿Cuál es el nivel de estrés que percibe el trabajador al realizar la tarea?',
	'Error creating method': 'Error al crear el método',
	'Error updating method': 'Error al actualizar el método',
	'Error deleting method': 'Error al eliminar el método',
	'Kinebot Method': 'Método Kinebot',
	'<p>This EWA was built using the Kinebot platform, which is a system that includes movement assessment using computer vision algorithms for movement evaluations, and allows for the implementation of PEA (Preliminary Ergonomic Assessment) and EWA according to ABNT ISO/TS 20646:2017 standard, covering the following aspects:</p><ul><li>Work schedule and concentration</li><li>Type of work</li><li>Postures and movements</li><li>Influence of workspace and task factors</li><li>Influence of psychosocial factors</li><li>Influence of environmental factors</li><li>Influence of organizational factors</li></ul><br><h3><strong>Demand Analysis</strong></h3><p>Initially, demand analysis was performed where the factors that demanded the need for EWA implementation were observed, as well as the possible causative factors that deserved attention and analysis.</p><br><h3><strong>Selection of Evaluated Aspects</strong></h3><p>After analyzing the demand, the Preliminary Ergonomic Assessments (PEAs) of activities related to this Ergonomic Work Analysis (EWA) were selected. Among all evaluated aspects, those correlated with the EWA demand were also chosen.</p><br><h3><strong>Ergonomic Assessment</strong></h3><p>To map movements and conduct the kinesiological study of postures and movements, the Kinebot platform was used. This computer vision system assists in human movement measurement processes. Using machine learning resources, a branch of artificial intelligence study, Kinebot employs algorithms that allow identifying patterns in data, building models, and performing assessments of postural and movement demands for each activity.</p><p>According to the demand and evaluated aspects, the following ergonomic tools were used:</p><ul><li>Repetitiveness assessment:<ul><li>Revised Strain Index</li></ul></li><li>Postural demands assessment:<ul><li>RULA (Rapid Upper Limb Assessment)</li><li>REBA (Rapid Entire Body Assessment)</li></ul></li><li>Load handling and transport:<ul><li>NIOSH / ISO 11228</li><li>KIM-MHO - Tool handling assessment</li><li>KIM-PP - Push and pull assessment</li><li>Liberty Mutual - Load handling assessment</li></ul></li></ul><br><h3><strong>Data Collection</strong></h3><p>Data were collected during workplace visits, through filming activities, observing aspects of work organization, workplace, equipment, load handling, and postures used, guided interviews were conducted with workers from each evaluated activity, the interview is conducted to avoid worker embarrassment, who are questioned about work routine and organization, operating methods, and general information about performed activities.</p><br><h3><strong>Image Collection</strong></h3><p>Image collection was performed through photos and videos demonstrating the main characteristics of the analyzed workstations and to enable the use of the Kinebot platform.</p>':
		'<p>Esta AET se desarrolló con la plataforma Kinebot, un sistema que incluye evaluación de movimientos con algoritmos de visión por computadora y permite realizar AEP (Evaluación Ergonómica Preliminar) y AET según la norma ABNT ISO/TS 20646:2017, cubriendo:</p><ul><li>Jornada y concentración de trabajo</li><li>Tipo de trabajo</li><li>Posturas y movimientos</li><li>Influencia de factores del puesto y de la tarea</li><li>Influencia de factores psicosociales</li><li>Influencia de factores ambientales</li><li>Influencia de factores organizacionales</li></ul><br><h3><strong>Análisis de la demanda</strong></h3><p>Se realizó un análisis de la demanda observando los factores que motivaron la AET y los posibles factores causales que requerían atención.</p><br><h3><strong>Selección de aspectos evaluados</strong></h3><p>Tras analizar la demanda, se seleccionaron las Evaluaciones Ergonómicas Preliminares (AEP) de las actividades relacionadas con esta AET. De todos los aspectos evaluados, se eligieron los correlacionados con la demanda.</p><br><h3><strong>Evaluación ergonómica</strong></h3><p>Para mapear movimientos y realizar el estudio cinesiológico de posturas y movimientos, se utilizó la plataforma Kinebot. Este sistema de visión por computadora ayuda en la medición de movimientos. Con recursos de aprendizaje automático, Kinebot identifica patrones, genera modelos y realiza evaluaciones de las exigencias posturales y de movimiento de cada actividad.</p><p>Según la demanda y los aspectos evaluados, se utilizaron las siguientes herramientas ergonómicas:</p><ul><li>Evaluación de repetitividad:<ul><li>Strain Index Revisado</li></ul></li><li>Evaluación de exigencias posturales:<ul><li>RULA (Rapid Upper Limb Assessment)</li><li>REBA (Rapid Entire Body Assessment)</li></ul></li><li>Manipulación y transporte de cargas:<ul><li>NIOSH / ISO 11228</li><li>KIM-MHO - Evaluación de manejo de herramientas</li><li>KIM-PP - Evaluación de empujar y tirar</li><li>Liberty Mutual - Evaluación de manejo de cargas</li></ul></li></ul><br><h3><strong>Recolección de datos</strong></h3><p>Los datos se recopilaron en visitas al puesto de trabajo, filmando actividades, observando organización del trabajo, entorno, equipos, manejo de cargas y posturas. Se realizaron entrevistas guiadas con los trabajadores, evitando incomodidad, sobre rutina, organización, métodos de trabajo e información general de las actividades.</p><br><h3><strong>Recolección de imágenes</strong></h3><p>La recolección de imágenes se realizó con fotos y videos de las principales características de los puestos analizados para permitir el uso de la plataforma Kinebot.</p>',
	'Item filter': 'Filtro de artículos',
	'Select the items you want to make up your EWA': 'Seleccione los ítems que compondrán su AET',
	'Please select at least one criteria for each activity': 'Seleccione al menos un criterio para cada actividad',
	'Upload image': 'Subir imagen',
	'Upload images of the activity being evaluated': 'Subir imágenes de la actividad que se está evaluando',
	Image: 'Imagen',
	'Add file': 'Agregar archivo',
	Section: 'Sección',
	Criteria: 'Criterios',
	'Selected items': 'Elementos seleccionados',
	'Type of work': 'Tipo de trabajo',
	'Activity risk': 'Riesgo de actividad',
	'Recommended weight limit': 'Límite de peso recomendado',
	'Lifting index': 'Índice de levantamiento',
	'Select a hand coupling': 'Seleccione un acoplamiento de mano',
	'of men': 'de hombres',
	'of women': 'de mujeres',
	'Action plans created': 'Planos de acción creados',
	'Force transfer': 'Transferencia de fuerza',
	'Force exerted (Left)': 'Fuerza ejercida (Izquierda)',
	'Force exerted (Right)': 'Fuerza ejercida (Derecha)',
	'Uploaded by': 'Creado por',

	'Physical overload is unlikely': 'Sobrecarga física improbable',
	'No health risks are expected': 'No se esperan riesgos para la salud',
	'No action is required': 'No son necesarias medidas',

	'Possible for less resilient individuals': 'Es posible para personas menos resilientes',
	'Fatigue, low-level adaptation issues that can be compensated during down time':
		'Fatiga, problemas de adaptación de bajo nivel que pueden compensarse durante el tiempo de descanso',
	'For less resilient individuals, workplace redesign and other preventive measures may be helpful':
		'Para personas menos resilientes, el rediseño del lugar de trabajo y otras medidas preventivas pueden ser útiles',

	'Physical overload is also possible even for normally resilient individuals':
		'La sobrecarga física también es posible incluso para personas normalmente resistentes',
	'Disorders (pain), possibly including dysfunctions, reversible in most cases, without morphological manifestation':
		'Trastornos (dolor), posiblemente incluyendo disfunciones, reversibles en la mayoría de los casos, sin manifestación morfológica',
	'Workplace redesign measures and other preventive measures must be considered':
		'Deben considerarse medidas de rediseño del puesto de trabajo y otras medidas preventivas',

	'Physical overload is likely': 'Sobrecarga física probable',
	'More pronounced disorders and/or dysfunctions, with structural damage of pathological relevance':
		'Trastornos y/o disfunciones más pronunciados, con daño estructural de relevancia patológica',
	'Workplace redesign measures are necessary. Other preventive measures must be considered':
		'Son necesarias medidas de rediseño del puesto de trabajo. Deben considerarse otras medidas preventivas',

	'Duration of the workday': 'Duración de la jornada laboral',
	'Duration of the activity': 'Duración de la actividad',
	'Activity duration cannot be greater than day duration':
		'La duración de la actividad no puede ser mayor que la duración de la jornada',
	'Men score': 'Puntuación hombres',
	'Women score': 'Puntuación mujeres',
	'The movement can occur in both directions; postures may indicate the beginning or end of the operation. When there are multiple postures in the same option, they all represent the same condition.':
		'El movimiento puede ocurrir en ambas direcciones; las posturas pueden indicar el inicio o el final de la operación. Cuando hay varias posturas en la misma opción, todas representan la misma condición.',
	'Video file': 'Archivo de video',

	'No ENS Workstations': 'Postos de trabajo no ENS',
	'ENS Workstations': 'Postos de trabajo ENS',
	ENS: 'ENS',
	'No ENS': 'No ENS',
	'Not Evaluated': 'No evaluado',
	'Ergonomic Neutral Station': 'Estación Neutra Ergonómica',
	'Workstations with an RPN equal to or less than 15 are classified as ENS.':
		'Los postos de trabajo con RPN igual o menor a 15 se clasifican como ENS.',
	'Workstations with an RPN greater than 15 are classified as non-ENS.':
		'Los postos de trabajo con RPN mayor a 15 se clasifican como no ENS.',
	'New activity name': 'Nuevo nombre de actividad',
	'New sector name': 'Nuevo nombre de sector',
	'New line name': 'Nuevo nombre de línea',
	'New workstation name': 'Nuevo nombre de puesto de trabajo',
	'New evaluator name': 'Nuevo nombre de evaluador',

	'The dimensions and clearances of the controls or work surface are inadequate (unified)':
		'Las dimensiones y holguras de los controles o de la superficie de trabajo son inadecuadas',
	'The workstation involves working squatting or kneeling':
		'La estación de trabajo implica trabajar en cuclillas o de rodillas',
	'The highest level of shelves and flow rack is inadequate for vertical reach':
		'El nivel más alto de las estanterías y flow rack es inadecuado para el alcance vertical',
	'Highest shelf height': 'Altura del estante más alto',
	'Empty container top height (KLT, Tote)': 'Altura de la parte superior del recipiente vacío (KLT, Tote)',

	Action: 'Acción',
	Position: 'Posición',
	'Use of gloves': 'Uso de guantes',
	Height: 'Altura',
	Width: 'Ancho',
	Diameter: 'Diámetro',

	'Two fingers': 'Dos dedos',
	'Flat empty hand': 'Mano vacía, plana',
	'Empty hand, bent thumb': 'Mano vacía, pulgar doblado',
	'Clenched fist': 'Mano cerrada, puño',
	'Hand plus 25 mm object': 'Mano más objeto de 25 mm',
	'Hand plus X mm object up to the wrist': 'Mano más objeto de X mm hasta la muñeca',
	'Arm to shoulder': 'Brazo hasta el hombro',
	'Both arms to shoulder': 'Ambos brazos hasta el hombro',
	'Leg width': 'Ancho de la pierna',
	'Foot clearance': 'Holgura para los pies',

	Kneeling: 'De rodillas',
	Squatting: 'En cuclillas',

	'With one hand': 'Con una mano',
	'With two hands': 'Con dos manos',

	'For one-handed lifts above 3 kg, the KIM LHC is recommended. For two-handed lifts above 4.5 kg, the KIM LHC and NIOSH are recommended.':
		'Para levantamientos con 1 mano, por encima de 3 kg, se recomienda el KIM LHC. Para levantamientos con dos manos, por encima de 4,5 kg, se recomiendan el KIM LHC y NIOSH.',
	Handling: 'Manejo',
	'Occasional reach to retrieve parts, tools, or small objects < 1 kg (2.2 lb), which presents no risk to the process or to the object being handled':
		'Alcance ocasional para recuperar piezas, herramientas u objetos pequeños < 1 kg (2,2 lb), que no presenta riesgo en el proceso ni en el objeto que se está manipulando'
};

Object.assign(dictionary, {
	'Include all employees in this line': 'Incluir a todos los empleados de esta línea',
	'Eligible employees': 'Empleados elegibles',
	'Employee code': 'Código de empleado',
	'Selected rows will be excluded from the invitation': 'Las filas seleccionadas se excluirán de la invitación',
	'Only selected rows will be invited': 'Solo se invitará a los empleados seleccionados',
	'Create HSE-IT survey': 'Crear encuesta HSE-IT',
	'Survey identifier': 'Identificador de la encuesta',
	'Anonymous survey': 'Encuesta anónima',
	'Notify participants by email': 'Notificar participantes por correo',
	'Participants with an email address will receive their survey invitation':
		'Los participantes con correo recibirán la invitación',
	'Create survey': 'Crear encuesta',
	'Employees imported': 'Empleados importados',
	'Import CSV or XLSX': 'Importar CSV o XLSX',
	'Download template': 'Descargar plantilla',
	'Review employee import': 'Revisar importación de empleados',
	Import: 'Importar',
	'Name, employee code and line are required. Dates use YYYY-MM-DD.':
		'Nombre, código de empleado y línea son obligatorios. Fechas en formato AAAA-MM-DD.',
	Row: 'Línea',
	Field: 'Field',
	Error: 'Error',
	'Create employee': 'Crear empleado',
	Employee: 'Employee',
	'Delete employee?': '¿Eliminar empleado?',
	Surveys: 'Encuestas',
	'Risk matrix category': 'Categoría de la matriz de riesgo',
	'General survey action plan': 'Plan de acción general de la encuesta',
	Questions: 'Preguntas',
	Mean: 'Mean',
	Answers: 'Respuestas',
	Benchmark: 'Benchmark',
	Interpretation: 'Interpretación',
	Anonymous: 'Anónimo',
	'Notifications queued': 'Notificaciones en cola',
	Participants: 'Participants',
	'Notify selected participants': 'Notificar a participantes seleccionados',
	'Notified at': 'Notificado el',
	'Use 1 to 6 for each factor, or zero for every factor to leave the risk unassessed':
		'Use de 1 a 6 en cada factor, o cero en todos para dejar el riesgo sin evaluar',
	'Notify pending participants': 'Notificar a participantes pendientes',
	'Close this survey?': '¿Cerrar esta encuesta?',
	'Complete survey': 'Cerrar encuesta',
	Ongoing: 'Ongoing',
	'Survey type': 'Tipo de encuesta',
	Identified: 'Identificada',
	'Completion start date': 'Finalización desde',
	'Completion end date': 'Finalización hasta',
	'Apply filters': 'Aplicar filtros',
	'Clear filters': 'Limpiar filtros',
	'Try again': 'Intentar otra vez',
	'Access denied': 'Acceso denegado',
	'Select an industrial site to continue': 'Seleccione una planta para continuar',
	Psychosocial: 'Psicosocial',
	'Overall results': 'Resultados generales',
	Employees: 'Empleados',
	'Something went wrong': 'Algo salió mal',
	'Generate PIN': 'Generar PIN',
	'Check your email for the PIN': 'Revise el PIN en su correo',
	'Start survey': 'Iniciar encuesta',
	'Thank you for completing the survey': 'Gracias por completar la encuesta',
	'Your answers are saved as you progress': 'Sus respuestas se guardan a medida que avanza',
	'Your answer could not be saved. Retry before continuing.':
		'No se pudo guardar su respuesta. Inténtelo de nuevo antes de continuar.',
	'Submit survey': 'Enviar encuesta',
	'After submitting, your answers cannot be changed.': 'Después del envío, no se podrán modificar sus respuestas.',
	'At work, different groups make demands on me that are difficult to reconcile':
		'En el trabajo, diferentes grupos me hacen demandas que son difíciles de conciliar',
	'I have impossible deadlines to meet': 'Tengo plazos imposibles de cumplir',
	'I have to work very hard': 'Tengo que trabajar muy intensamente',
	'I need to put some tasks aside because I have too many things to do':
		'Necesito dejar de lado algunas tareas porque tengo demasiadas cosas que hacer',
	"I can't take enough breaks": 'No puedo tomar suficientes pausas',
	'I am under pressure to work for long stretches': 'Estoy bajo presión para trabajar por largos períodos',
	'I have to work very fast': 'Tengo que trabajar muy rápido',
	'I suffer absurd time pressures': 'Sofro presiones de tiempo absurdas',
	'I can decide when to take a break': 'Puedo decidir cuándo tomar una pausa',
	'I can set my own work pace': 'Puedo decidir sobre mi ritmo de trabajo',
	'I can decide how to approach my work': 'Puedo elegir cómo abordar mi trabajo',
	'I can choose what to do at work': 'Puedo elegir qué hacer en el trabajo',
	'I have some decision-making power over my way of working':
		'Tengo algún poder de decisión sobre mi manera de trabajar',
	'My work schedule can be flexible': 'Mi horario de trabajo puede ser flexible',
	'I am subject to personal harassment in the form of verbal or behavioral abuse':
		'Estoy sujeto a acoso personal en forma de palabras o comportamientos groseros',
	'There is friction or animosity among coworkers': 'Existe atrito o animosidad entre los colegas de trabajo',
	'I am subject to uncomfortable situations or pressures at work':
		'Estoy sujeto a situaciones incómodas o presiones en el trabajo',
	'Work relationships are tense': 'Los relaciones en el trabajo son tensas',
	'I know clearly what is expected of me at work': 'Sé claramente lo que se espera de mí en el trabajo',
	'I know how to do my job': 'Sé cómo hacer mi trabajo',
	'I am aware of my responsibilities and duties': 'Estoy consciente de mis responsabilidades y deberes',
	"I am familiar with my department's goals": 'Conozco los objetivos y metas de mi departamento',
	"I understand how my work aligns with the organization's objectives":
		'Comprendo cómo mi trabajo se integra con los objetivos de la organización',
	'I have ample opportunities to ask leadership about changes at work':
		'Tengo suficientes oportunidades para preguntar a la dirección sobre cambios en el trabajo',
	'The team is always involved in discussions about changes at work':
		'El equipo siempre está involucrado en discusiones sobre cambios en el trabajo',
	'When changes occur at work, I am informed about how they will work in practice':
		'Cuando ocurren cambios en el trabajo, me informan de cómo funcionarán en la práctica',
	'I receive feedback on the work I do': 'Recibo retroalimentación sobre los trabajos que realizo',
	'I can rely on my immediate supervisor for support in resolving work issues':
		'Puedo hablar con mi jefe inmediato sobre algo que me molesta en el trabajo',
	'I can discuss with my immediate supervisor something that concerns me at work':
		'Puedo discutir con mi jefe inmediato algo que me preocupa en el trabajo',
	'I receive support when performing emotionally demanding tasks':
		'Recibo apoyo cuando realizo trabajos que pueden ser emocionalmente desgastantes',
	'My immediate supervisor motivates me at work': 'Mi jefe inmediato me motiva en el trabajo',
	'When the work gets tough, my colleagues help me': 'Cuando el trabajo se vuelve difícil, mis colegas me ayudan',
	'I get the help and support I need from my colleagues': 'Recibo la ayuda y el apoyo que necesito de mis colegas',
	'I am treated with the respect I deserve by my colleagues': 'Soy respetado como me merezco por mis colegas',
	'My colleagues are willing to listen to my work-related issues':
		'Mis colegas están dispuestos a escuchar mis problemas relacionados al trabajo',
	Never: 'Nunca',
	Rarely: 'Raramente',
	Sometimes: 'A veces',
	Often: 'Frecuentemente',
	Always: 'Siempre',
	Demands: 'Demanda',
	'Management support': 'Apoyo gerencial',
	'Peer support': 'Apoyo de compañeros',
	Relationships: 'Relationships',
	gender: 'Género',
	role: 'Cargo',
	education: 'Escolaridad',
	'work shift': 'Turno',
	'employee code': 'Código de empleado',
	email: 'Correo',
	'birth date': 'Fecha de nacimiento',
	'admission date': 'Fecha de ingreso',
	'birth date start': 'Nacimiento desde',
	'birth date end': 'Nacimiento hasta',
	'admission date start': 'Ingreso desde',
	'admission date end': 'Ingreso hasta',
	severity: 'Severidad',
	exposure: 'Exposición',
	probability: 'Probabilidad',
	MALE: 'Masculino',
	FEMALE: 'Femenino',
	OTHER: 'Otro',
	ongoing: 'En curso',
	completed: 'Completada',
	alphabetical_asc: 'Nombre ascendente',
	alphabetical_desc: 'Nombre descendente',
	highest_load: 'Mayor carga',
	lowest_load: 'Menor carga'
});

Object.assign(dictionary, {
	'Compare results': 'Comparar resultados',
	'Group by': 'Agrupar por',
	Compare: 'Compare',
	'Order by': 'Ordenar por',
	Order: 'Orden'
});

Object.assign(dictionary, {
	'Save a category assessment to link an action plan':
		'Guarde la evaluación de una categoría para vincularla a un plan de acción',
	'HSE risk level': 'Nivel de riesgo HSE',
	'low-stress-risk': 'Bajo riesgo de estrés',
	'medium-stress-risk': 'Riesgo medio de estrés',
	'moderate-stress-risk': 'Riesgo moderado de estrés',
	'high-stress-risk': 'Alto riesgo de estrés'
});
Object.assign(dictionary, {
	'CSV or XLSX, up to 10000 employees and 20 MB': 'CSV o XLSX, hasta 10000 empleados y 20 MB',
	'Reading employee file': 'Leyendo archivo de empleados',
	'Validating employee records': 'Validando registros de empleados',
	'Importing employee records': 'Importando registros de empleados',
	'Employee files must be 20 MB or smaller': 'El archivo de empleados debe tener como máximo 20 MB',
	'A file can contain at most 10000 employees': 'Un archivo puede contener como máximo 10000 empleados',
	'Unable to read employee file': 'No se pudo leer el archivo de empleados',
	'Unable to start the employee file reader. Please try again.':
		'No se pudo iniciar la lectura del archivo. Inténtelo de nuevo.'
});
Object.assign(dictionary, {
  "Employees management": "Gestión de empleados",
  "employees selected": "empleados seleccionados",
  "Questionnaires": "Cuestionarios",
  "The questionnaire consists of 35 questions distributed across seven dimensions": "El cuestionario contiene 35 preguntas distribuidas en siete dimensiones",
  "Review the current HSE-IT questions and their answer options before creating this survey.": "Revise las preguntas HSE-IT y las opciones de respuesta antes de crear la encuesta.",
  "Unable to load questionnaire": "No se pudo cargar el cuestionario",
  "The personalized email message is too long": "El mensaje de correo personalizado es demasiado largo",
  "Create new survey": "Crear nueva encuesta",
  "Application limit date": "Fecha límite de aplicación",
  "Select the tool for the survey": "Seleccione la herramienta para la encuesta",
  "View surveys": "Ver encuestas",
  "Survey description": "Descripción de la encuesta",
  "Notify employees": "Notificar empleados",
  "Personalized email message": "Mensaje de correo electrónico personalizado",
  "View message layout": "Ver diseño del mensaje",
  "Message layout": "Vista previa del mensaje",
  "Survey link": "Enlace de la encuesta",
  "Included in the invitation": "Incluido en la invitación",
  "Update employee": "Actualizar empleado",
  "Employee email": "Correo electrónico del empleado",
  "Employee name": "Nombre del empleado",
  "Education": "Nivel educativo",
  "Employee role": "Cargo del empleado",
  "Admission date": "Fecha de ingreso",
  "Work shift": "Turno de trabajo",
  "Birth date": "Fecha de nacimiento",
  "Feminine": "Femenino",
  "Masculine": "Masculino",
  "Other": "Otro",
  "Import employee list": "Importar lista de empleados",
  "Choose file": "Elegir archivo",
  "To import a list of employees, select a file in CSV or XLSX format. The spreadsheet must contain the following columns:": "Para importar empleados, seleccione un archivo CSV o XLSX. La hoja debe contener las siguientes columnas:",
  "Required": "Requerido",
  "Export model": "Exportar modelo",
  "Optional": "Opcional",
  "Edit employee": "Editar empleado",
  "Delete employee": "Eliminar empleado",
  "Ordination": "Ordenación",
  "Name Z–A": "Nombre Z–A",
  "Newest": "Más reciente",
  "Search name or employee code": "Buscar nombre o código de empleado",
  "Birth date from": "Fecha de nacimiento desde",
  "Birth date to": "Fecha de nacimiento hasta",
  "Admission date from": "Fecha de contratación desde",
  "Admission date to": "Fecha de contratación hasta",
  "Comparative results": "Resultados comparativos",
  "General": "General",
  "Select groups to compare": "Seleccione los grupos para comparar",
  "Completed Surveys": "Encuestas completadas",
  "Result (risk matrix)": "Resultado (matriz de riesgo)",
  "No completed surveys": "No hay encuestas completadas",
  "Surveys on time": "Encuestas a tiempo",
  "Final result": "Resultado final",
  "Performance relative to the comparative sample": "Desempeño en relación a la muestra comparativa",
  "The comparative sample is the HSE benchmark for 2025.": "La muestra comparativa utiliza la referencia HSE de 2025.",
  "Category / Evaluation": "Categoría / Evaluación",
  "Alphabetical A–Z": "Alfabético A–Z",
  "Alphabetical Z–A": "Alfabético Z–A",
  "Highest load": "Mayor carga",
  "Lowest load": "Menor carga",
  "Search by name": "Buscar por nombre",
  "Completion Date": "Fecha de finalización",
  "Employees count": "Número de empleados",
  "Answered surveys": "Encuestas respondidas",
  "Participation": "Participación",
  "All categories": "Todas las categorías",
  "Search category or question": "Buscar categoría o pregunta",
  "Not Assessed": "No evaluado",
  "View questions by category": "Ver preguntas por categoría",
  "Final results": "Resultados finales",
  "Survey link copied to clipboard": "Enlace de la encuesta copiado al portapapeles",
  "Failed to copy survey link": "Error al copiar el enlace de la encuesta",
  "Copy link": "Copiar enlace",
  "QR Code": "Código QR",
  "Delete survey?": "¿Eliminar la encuesta?",
  "Delete survey": "Eliminar encuesta",
  "Favorable": "Favorable",
  "Neutral": "Neutral",
  "Legend for the categories": "Legenda para las categorías",
  "Legend for the category": "Legenda para la categoría",
  "Relationship": "Relación",
  "Relationship responses are shown separately so reports of bullying or harassment remain visible.": "Las respuestas sobre relaciones se muestran por separado para mantener visibles los reportes de acoso.",
  "Link copied": "Enlace copiado",
  "Complete survey?": "¿Completar la encuesta?",
  "Survey": "Encuesta",
  "Evaluated Hierarchy": "Jerarquía evaluada",
  "Share": "Compartir",
  "Copy survey link": "Copiar enlace de la encuesta",
  "Show QR code": "Mostrar código QR",
  "Highest risk (risk matrix)": "Mayor riesgo (matriz de riesgo)",
  "Add New Survey": "Crear nueva encuesta",
  "Creation date (newest)": "Fecha de creación más reciente",
  "Creation date (oldest)": "Fecha de creación más antigua",
  "Newest completion date": "Fecha de finalización más reciente",
  "Oldest completion date": "Fecha de finalización más antigua",
  "Name A–Z": "Nombre A–Z",
  "Search survey": "Buscar encuesta",
  "Survey Type": "Tipo de encuesta",
  "Non-anonymous": "No anónimo",
  "Both": "Ambos",
  "Creation date from": "Fecha de creación desde",
  "Creation date to": "Fecha de creación hasta",
  "Completion date from": "Fecha de finalización desde",
  "Completion date to": "Fecha de finalización hasta",
  "Survey QR code": "Código QR de la encuesta",
  "Hello! Welcome to your psychosocial evaluation.": "¡Hola! Bienvenido a su evaluación psicosocial.",
  "Enter the employee code": "Ingrese el código de empleado",
  "Access evaluation": "Acceder a la evaluación",
  "Review your answers. Click on any question to edit.": "Revise sus respuestas. Haga clic en cualquier pregunta para editar.",
  "Not answered": "Sin respuesta",
  "LUCCA, Sergio Roberto de; SOBRAL, Renata Cristina. Aplicação de instrumento para o diagnóstico dos fatores de risco psicossociais nas organizações. Campinas: Universidade Estadual de Campinas, 2017": "LUCCA, Sergio Roberto de; SOBRAL, Renata Cristina. Aplicação de instrumento para o diagnóstico dos fatores de risco psicossociais nas organizações. Campinas: Universidade Estadual de Campinas, 2017",
  "Scroll to bottom": "Desplazarse hacia abajo",
  "Access PIN": "PIN de acceso",
  "Questionnaire": "Encuesta",
  "Filling progress": "Progreso de relleno",
  "Indicate the frequency of the following statements on the scale:": "Indique en la escala la frecuencia de las siguientes afirmaciones:",
  "Your answers have been saved": "Sus respuestas se han guardado",
  "Survey completed successfully!": "¡Su evaluación ha sido completada con éxito!",
  "Save answers": "Guardar respuestas"
});
Object.assign(dictionary, {
  "Ongoing Surveys": "Encuestas en curso",
  "Risk classification is carried out using the method of Willian T. Fine.": "La clasificación de riesgo se realiza a partir del método de Willian T. Fine.",
  "Biggest risk found": "Mayor riesgo encontrado",
  "Unassessed": "No evaluado"
});
Object.assign(dictionary, {
  "Add Employee": "Añadir empleado",
  "Added least recently": "Añadido menos recientemente",
  "Alphabetical": "Alfabético",
  "Complete university education": "Educación universitaria completa",
  "Create a new education title": "Crear un nuevo título de educación",
  "Create a new work shift": "Crear un nuevo turno de trabajo",
  "Enter the employee name": "Ingrese el nombre del empleado",
  "Import file": "Importar archivo",
  "Invalid email": "Correo electrónico inválido",
  "Line 1": "Línea 1",
  "Longest service in the company": "Mayor tiempo en la empresa",
  "Morning": "Matutino",
  "Most recently added": "Añadido más recientemente",
  "Shortest service in the company": "Menor tiempo en la empresa",
  "Want to": "Desea",
  "the employee": "el empleado"
});
Object.assign(dictionary, {
  "Optimal sample size": "Tamaño óptimo de muestra",
  "Trust level reached": "Nivel de confianza alcanzado",
  "Trust level not reached": "No alcanzó el nivel de confianza",
  "Favorable health situation": "Situación favorable para la salud",
  "Intermediate situation": "Situación intermedia",
  "Health risk": "Riesgo para la salud",
  "Legend for the dimension": "Legenda para la dimensión",
  "Never/almost never": "Nunca/casi nunca",
  "Default": "Por defecto",
  "Highest favorable": "Mayor situación favorable",
  "Highest neutral": "Mayor situación intermedia",
  "Highest risk": "Mayor situación de riesgo",
  "Result by question": "Resultado por pregunta",
  "Highest load found": "Mayor carga encontrada",
  "Lowest load found": "Menor carga encontrada",
  "Your score is below the 25th percentile, which suggests that your employees perceptions are more negative than in 25% of organizations.": "Su puntuación está por debajo del percentil 25, lo que sugiere que las percepciones de sus empleados son más negativas que en el 75% de las organizaciones.",
  "Your score is between the 25th and 75th percentile, suggesting that your employees perceptions are in line with the middle group (50%).": "Su puntuación está entre el percentil 25 y el 75, lo que sugiere que las percepciones de sus empleados están alineadas con el grupo intermedio (50%).",
  "Your score is above the 75th percentile, which suggests that your employees perceptions are more positive than in 75% of organizations.": "Su puntuación está por encima del percentil 75, lo que sugiere que las percepciones de sus empleados son más positivas que en el 75% de las organizaciones.",
  "In Relationship, the score is presented in response categories. This is because answers like “sometimes” may indicate bullying or harassment, and any report of such behavior must be considered serious by the organization.": "En Relaciones, la puntuación se presenta en categorías de respuesta. Esto es porque respuestas como “a veces” pueden indicar acoso o acoso, y cualquier informe de tales comportamientos debe considerarse grave por la organización.",
  "The comparative sample corresponds to a benchmark carried out in 2025 by the Health and Safety Executive (HSE), in the United Kingdom, with 165 private sector organizations.": "La muestra comparativa corresponde a un benchmark realizado en 2025 por la Health and Safety Executive (HSE), en el Reino Unido, con 165 organizaciones del sector privado.",
  "Average score (survey)": "Puntuación media (encuesta)",
  "Average score (benchmark)": "Puntuación media (muestra comparativa)",
  "Average survey score": "Puntuación media de la encuesta",
  "Average benchmark score": "Puntuación media del benchmark",
  "25th percentile": "Percentil 25",
  "75th percentile": "Percentil 75",
  "Totally disagree / Never": "Totalmente en desacuerdo / Nunca",
  "Disagree / Rarely": "En desacuerdo / Raramente",
  "Neutral / Sometimes": "Neutro / A veces",
  "Agree / Often": "De acuerdo / Frecuentemente",
  "Totally agree / Always": "Totalmente de acuerdo / Siempre",
  "Duty": "Cargo",
  "Management Support": "Apoyo gerencial",
  "Colleagues Support": "Apoyo de colegas"
});
Object.assign(dictionary, {
	"Number of Surveys": "Cantidad de encuestas",
	"The displayed risk corresponds to the highest risk found among the categories, according to the method of Willian T. Fine.": "El riesgo mostrado corresponde al mayor riesgo encontrado entre las categorías, según el método de Willian T. Fine.",
	"Highest favorable risk": "Mayor riesgo favorable",
	"Highest neutral risk": "Mayor riesgo neutro",
	"Highest unfavorable risk": "Mayor riesgo desfavorable",
	"Overall average": "Promedio general",
	"Hierarchy/ Category": "Jerarquía/ Categoría",
	"Reference period": "Período de referencia",
	"Severe and Imminent Risk": "Riesgo grave e inminente"
});
Object.assign(dictionary, {
  "Classification": "Clasificación",
  "Marked response": "Respuesta marcada",
  "Enter the survey identifier": "Ingrese el identificador de la encuesta",
  "Select the application limit date": "Seleccione la fecha límite de aplicación",
  "Enter the survey description": "Ingrese la descripción de la encuesta",
  "Preview of the layout": "Vista previa del diseño",
  "Usage recommendations": "Recomendaciones de uso",
  "Its validation study can be accessed": "Su estudio de validación puede consultarse",
  "here": "aquí",
  "Content": "Contenido",
  "The questionnaire consists of 35 questions distributed across seven dimensions:": "El cuestionario consta de 35 preguntas distribuidas en siete dimensiones:",
  "Filling": "Cumplimentación",
  "Each dimension is measured with 3 to 8 questions using one of two 5-point Likert scales:": "Cada dimensión se mide con 3 a 8 preguntas utilizando una de dos escalas Likert de 5 puntos:",
  "Never and Rarely / Frequently and Always": "Nunca y Raramente / Frecuentemente y Siempre",
  "(1) Never": "(1) Nunca",
  "(2) Rarely": "(2) Raramente",
  "(3) Sometimes": "(3) A veces",
  "(4) Frequently": "(4) Frecuentemente",
  "(5) Always": "(5) Siempre",
  "(1) Strongly disagree": "(1) Totalmente en desacuerdo",
  "(2) Disagree": "(2) En desacuerdo",
  "(3) Neutral": "(3) Neutro",
  "(4) Agree": "(4) De acuerdo",
  "(5) Strongly agree": "(5) Totalmente de acuerdo",
  "The HSE-IT is an internationally validated instrument for assessing psychosocial risks in the workplace, including workload, leadership support, role clarity, and interpersonal relationships. Developed by the UK government, it is one of the most comprehensive tools for understanding the collective psychosocial environment. Kinebot selected the HSE-IT for its robustness and ease of large-scale application, making it ideal for organizations aiming to identify group-level risks and implement systemic improvements.": "El HSE-IT es un instrumento validado internacionalmente para evaluar los riesgos psicosociales en el entorno laboral, como la carga de trabajo, el apoyo de los líderes, la claridad de los roles y las relaciones interpersonales. Desarrollado por el gobierno del Reino Unido, es una de las herramientas más completas para entender el entorno psicosocial colectivo. Kinebot eligió el HSE-IT por su solidez y facilidad de aplicación a gran escala, siendo ideal para organizaciones que buscan identificar riesgos a nivel grupal e implementar mejoras sistémicas.",
  "The result of each dimension corresponds to the incidence of the three available classifications and is obtained from the count of all employees' responses, classifying them as favorable, neutral, or unfavorable. The classification of results requires interpretation factor by factor, because the values can have different meanings depending on the dimension.": "El resultado de cada dimensión corresponde a la incidencia de las tres clasificaciones disponibles y se obtiene a partir del recuento de las respuestas de todos los empleados, clasificándolas como favorables, neutras o desfavorables. La clasificación de los resultados requiere una interpretación factor por factor, ya que los valores pueden tener diferentes significados según la dimensión.",
  "The \"Relationships\" dimension measures the occurrence of specific and serious events. Since any report of bullying or harassment behavior must be considered serious by the organization, its risk will directly reflect the occurrence of the response options: \"Strongly disagree/Never\", \"Disagree/Rarely\", \"Neutral/Sometimes\", \"Agree/Frequently\" and \"Strongly agree/Always\".": "La dimensión \"Relaciones\" mide la ocurrencia de eventos específicos y graves. Dado que cualquier denuncia de comportamientos de acoso o intimidación debe ser considerada grave por la organización, su riesgo reflejará directamente la ocurrencia de las opciones de respuesta: \"Totalmente en desacuerdo/Nunca\", \"En desacuerdo/Raramente\", \"Neutro/A veces\", \"De acuerdo/Frecuentemente\" y \"Totalmente de acuerdo/Siempre\".",
  "Select between 2 and 5 groups": "Seleccione entre 2 y 5 grupos"
});
Object.assign(dictionary, {
	"Questions by category": "Preguntas por categoría",
	"Please fill all fields before finishing the survey.": "Complete todos los campos antes de finalizar la encuesta.",
	"HSE-IT": "HSE-IT",
	"Empty file": "Archivo vacío",
	"Choose a CSV or XLSX file": "Elija un archivo CSV o XLSX",
	"Unclosed quoted CSV field": "Campo del CSV con comillas sin cerrar",
	"No worksheet found": "No se encontró ninguna hoja de cálculo",
	"File reading cancelled": "Lectura del archivo cancelada",
	"Access your test through your credentials.": "Acceda a su prueba mediante sus credenciales.",
	"To access your test, generate an automatic PIN.": "Para acceder a su prueba, genere un PIN automático.",
	"No registered email was found to send the PIN. It was generated and filled automatically.": "No se encontró ningún correo electrónico registrado para enviar el PIN. Se generó y completó automáticamente.",
	"Totally disagree": "Totalmente en desacuerdo",
	"Disagree": "En desacuerdo",
	"Agree": "De acuerdo",
	"Totally agree": "Totalmente de acuerdo",
	"Employee not found": "Empleado no encontrado",
	"Invalid employee data": "Datos del empleado no válidos",
	"Employee code already exists in this company": "El código del empleado ya existe en esta empresa",
	"Required text field": "Campo de texto obligatorio",
	"Expected text": "Se esperaba texto",
	"Text exceeds the maximum length": "El texto supera la longitud máxima",
	"Invalid gender": "Género no válido",
	"Expected valid YYYY-MM-DD date": "Se esperaba una fecha válida en formato AAAA-MM-DD",
	"Line not found in this company": "Línea no encontrada en esta empresa",
	"Line name is ambiguous; provide sector_name or line_id": "El nombre de la línea es ambiguo; indique sector_name o line_id",
	"Workstation not found or ambiguous within selected line": "Puesto de trabajo no encontrado o ambiguo en la línea seleccionada",
	"Employee code already exists in company or import": "El código del empleado ya existe en la empresa o en la importación",
	"Employee email already exists": "El correo electrónico del empleado ya existe",
	"Anonymous participant completion cannot be filtered": "No se puede filtrar la finalización de participantes anónimos",
	"Anonymous surveys do not use a PIN": "Las encuestas anónimas no usan PIN",
	"Answer all questions before submitting": "Responda todas las preguntas antes de enviar",
	"Identity filters are unavailable for anonymous survey results": "Los filtros de identidad no están disponibles para los resultados de encuestas anónimas",
	"Invalid PIN": "PIN no válido",
	"Invalid invitation": "Invitación no válida",
	"Invalid participant": "Participante no válido",
	"Invalid question option": "Opción de pregunta no válida",
	"Line does not belong to the company": "La línea no pertenece a la empresa",
	"PIN expired or already used": "PIN vencido o ya utilizado",
	"Participant not found": "Participante no encontrado",
	"Please wait before requesting another PIN": "Espere antes de solicitar otro PIN",
	"Responsible user must have active access to this company": "El usuario responsable debe tener acceso activo a esta empresa",
	"Risk matrix must belong to the survey; factors must all be zero or between 1 and 6": "La matriz de riesgo debe pertenecer a la encuesta; los factores deben ser todos cero o entre 1 y 6",
	"Select at least one employee": "Seleccione al menos un empleado",
	"Session expired or invalid": "Sesión vencida o no válida",
	"Survey already submitted": "Encuesta ya enviada",
	"Survey expiration must be in the future": "El vencimiento de la encuesta debe ser en el futuro",
	"Survey is closed or expired": "La encuesta está cerrada o vencida",
	"Survey is completed": "La encuesta está finalizada",
	"Survey not found": "Encuesta no encontrada",
	"Survey or action plan not found": "Encuesta o plan de acción no encontrado",
	"Survey results are available once the survey is completed": "Los resultados de la encuesta están disponibles una vez finalizada",
	"The maximum number of responses for this survey has been reached": "Se alcanzó el número máximo de respuestas de esta encuesta",
	"This survey has not yet received responses and it is not possible to close it.": "Esta encuesta aún no ha recibido respuestas y no es posible cerrarla.",
	"This survey requires employee identification": "Esta encuesta requiere la identificación del empleado",
	"Workstation does not belong to the line": "El puesto de trabajo no pertenece a la línea"
});
Object.assign(dictionary, {
	"Download report": "Descargar informe",
	"Failed to export evaluations": "Error al exportar las evaluaciones",
	"Export CSV": "Exportar CSV",
	"responses": "respuestas",
	"Report generated successfully!": "¡Informe generado con éxito!"
});
Object.assign(dictionary, {
	"Export": "Exportar",
	"PDF": "PDF",
	"Export PDF": "Exportar PDF",
	"Filtered visualization": "Visualización filtrada",
	"reflects the filters and sortings applied to the sections of results.": "refleja los filtros y ordenaciones aplicados a las secciones de resultados.",
	"Default visualization": "Visualización predeterminada",
	"displays the initial visualization.": "muestra la visualización inicial.",
	"Visualization": "Visualización",
	"Visualization info": "Información de visualización",
	"Survey created successfully!": "¡Encuesta creada con éxito!"
});
Object.assign(dictionary, {
	"Survey completed successfully": "Encuesta finalizada con éxito",
	"Participation deleted successfully": "Participación eliminada con éxito",
	"Survey deleted successfully": "Encuesta eliminada con éxito"
});
Object.assign(dictionary, {
	'Tool results': 'Resultados de herramientas',
	'AEP results': 'Resultados AEP',
	'Individual evaluations': 'Evaluaciones individuales',
	'Attach B: Questions by category': 'Anexo B: Preguntas por categoría',
	'Final result HSE-IT': 'Resultado final HSE-IT',
	'Risk matrix HSE-IT': 'Matriz de riesgo HSE-IT',
	'Keep filters': 'Mantener filtros',
	'AEP Results': 'Resultados AEP',
	'AEP': 'AEP',
	'Not assessed': 'No evaluado',
	'Notifications failed': 'Notificaciones fallidas',
	'Survey created. Email notification failed; retry notification.': 'Encuesta creada. El envío de correos falló; intente notificar nuevamente.',
	'Some participants could not be notified; retry notification.': 'Algunos participantes no pudieron ser notificados; intente notificar nuevamente.',
	'Assessment developed using the Kinebot platform. The collected data is entirely the responsibility of the client. Kinebot is not responsible for any actions taken based on this communication or for any consequences resulting from its use.': 'Evaluación desarrollada utilizando la plataforma Kinebot. Los datos recopilados son de entera responsabilidad del cliente. Kinebot no se responsabiliza por ninguna acción tomada en base a esta comunicación ni por las consecuencias derivadas de su uso.'
});
Object.assign(dictionary, {
	'Question': 'Pregunta',
	'Learn more': 'Más información',
	'Value': 'Valor',
	'Category average': 'Promedio de la categoría',
	'Risk classification': 'Clasificación del riesgo',
	'The risk priority number (RPN) is the product of consequence, exposure and probability, each scored from 1 to 6.': 'El número de prioridad de riesgo (RPN) es el producto de consecuencia, exposición y probabilidad, cada uno puntuado de 1 a 6.',
	'The probability is suggested from the HSE-IT category average and can be adjusted.': 'La probabilidad se sugiere a partir del promedio de la categoría en el HSE-IT y puede ajustarse.',
	'Delete this action plan?': '¿Eliminar este plan de acción?',
	'After saving, add priority, tasks and attachments to the action plan.': 'Después de guardar, agregue prioridad, tareas y adjuntos al plan de acción.',
	'Unanswered surveys': 'Encuestas no respondidas',
	'Results, risk matrix and action plans will be available once the survey is completed.': 'Los resultados, la matriz de riesgo y los planes de acción estarán disponibles cuando la encuesta finalice.',
	"Completion date (earliest)": "Fecha de finalización (más próxima)",
	"Completion date (latest)": "Fecha de finalización (más lejana)",
	"Do you want to complete the survey": "¿Desea completar el levantamiento",
	"Do you want to delete the survey": "¿Desea eliminar el levantamiento",
	"Complete": "Completar",
	"Are you sure you want to delete the participation": "¿Está seguro de que desea eliminar la evaluación",
	"Delete participation": "Eliminar evaluación",
	"QR Code copied to clipboard": "Código QR copiado al portapapeles",
	"Failed to copy QR Code": "Error al copiar el código QR",
	"Copy": "Copiar",
	"Failed to generate QR Code": "Error al generar el código QR",
	"Download QR Code": "Descargar código QR",
	"Survey created. Responses will be accepted until": "Encuesta creada. Las respuestas se aceptarán hasta",
	"Please fill in the required fields": "Complete los campos obligatorios",
	"To ensure anonymity, the sample must have at least 5 employees. Currently, the selection does not meet this requirement. By continuing, the confidentiality of the respondents will be compromised.": "Para garantizar el anonimato, la muestra debe tener al menos 5 empleados. Actualmente, la selección no cumple con este requisito. Al continuar, se comprometerá la confidencialidad de los encuestados.",
});
Object.assign(dictionary, {
	"Your access PIN has been sent by email. It is valid for 10 minutes.": "Su PIN de acceso fue enviado por correo electrónico. Es válido por 10 minutos.",
	"Too many attempts. Please try again in 5 minutes.": "Demasiados intentos. Inténtelo de nuevo en 5 minutos.",
	"Too many attempts. Please try again in a few minutes.": "Demasiados intentos. Inténtelo de nuevo en unos minutos.",
	"Your session has expired. Please access the evaluation again.": "Su sesión ha expirado. Acceda nuevamente a la evaluación.",
	"Available until": "Disponible hasta",
	"Please fill this field": "Complete este campo",
	"PIN digit": "Dígito del PIN",
	"This psychosocial evaluation is no longer available": "Esta evaluación psicosocial ya no está disponible",
	"The evaluation was closed or its deadline has passed.": "La evaluación fue cerrada o su plazo terminó.",
	"Invalid evaluation link": "Enlace de evaluación inválido",
	"Check the link you received or ask the person responsible for the evaluation for a new one.": "Verifique el enlace recibido o solicite uno nuevo al responsable de la evaluación.",
	"You have already answered this evaluation": "Usted ya respondió esta evaluación",
	"Thank you for your participation.": "Gracias por su participación.",
	"This evaluation has already received all expected responses": "Esta evaluación ya recibió todas las respuestas esperadas",
	"Contact the person responsible for the evaluation if you have not answered it yet.": "Comuníquese con el responsable de la evaluación si aún no la respondió.",
	"Your evaluation has been completed! Notify the evaluator": "¡Su evaluación ha sido completada! Avise al evaluador",
	"Open surveys": "Encuestas abiertas",
	"Completed surveys": "Encuestas completadas",
	"You have no open surveys": "No tiene encuestas abiertas",
	"You have not completed any survey yet": "Aún no ha completado ninguna encuesta",
	"Open": "Abierta",
	"Closed": "Cerrada",
	"Completed on": "Completada el",
	"Answer": "Responder",
	"Start individual collection": "Iniciar recolección individual",
	"No email is registered for this employee. Contact the person responsible for the survey.": "No hay correo electrónico registrado para este colaborador. Comuníquese con el responsable de la encuesta."
});
Object.assign(dictionary, {
	"This employee is already in the list": "Este colaborador ya está en la lista",
	"Employees created successfully!": "¡Colaboradores creados con éxito!",
	"Employee updated successfully!": "¡Colaborador actualizado con éxito!",
	"Employee created successfully!": "¡Colaborador creado con éxito!",
	"Leave blank to generate a code automatically": "Déjelo en blanco para generar un código automáticamente",
	"Add employee to list": "Agregar colaborador a la lista",
	"Spreadsheet line": "Línea de la hoja de cálculo",
	"Created employees": "Colaboradores creados",
	"Updated employees": "Colaboradores actualizados",
	"Name and line are required. Employees whose code already exists are updated, and a blank code is generated automatically.": "El nombre y la línea son obligatorios. Los colaboradores cuyo código ya existe se actualizan, y un código en blanco se genera automáticamente.",
	"Download errors": "Descargar errores",
	"Export file": "Exportar archivo",
	"No data to export": "No hay datos para exportar",
	"Employee deleted successfully!": "¡Colaborador eliminado con éxito!",
	"Less than a month": "Menos de un mes",
	"year(s)": "año(s)",
	"month(s)": "mes(es)"
});
Object.assign(dictionary, {
	ControlV2: 'Control',
	ChangeV2: 'Cambio'
});
Object.assign(dictionary, {
	'Survey management': 'Gestión de encuestas',
	'View employee list': 'Ver lista de empleados',
	'Survey information': 'Información de la encuesta',
	'Do you want': '¿Desea',
	'to delete': 'eliminar',
	'the survey': 'la encuesta',
	'to complete': 'finalizar',
	'View survey': 'Ver encuesta',
	'Risk matrix updated successfully!': 'Matriz de riesgo actualizada con éxito!',
	'Action plan updated successfully': 'Plan de acción actualizado con éxito',
	'Employee education created successfully!': '¡Educación del empleado creada con éxito!',
	'Employee work shift created successfully!': '¡Turno de trabajo del empleado creado con éxito!',
	'Unable to export employees': 'No se pudieron exportar los empleados',
	'Export request already in progress': 'Ya hay una exportación en curso'
});
Object.assign(dictionary, {
	'Incomplete elementary school education': 'Educación primaria incompleta',
	'Complete elementary school education': 'Educación primaria completa',
	'Incomplete high school education': 'Educación secundaria incompleta',
	'Complete high school education': 'Educación secundaria completa',
	'Incomplete university education': 'Educación universitaria incompleta',
	'Post-graduation': 'Posgrado',
	'Evening': 'Vespertino',
	'Night': 'Nocturno',
	'Do you want to delete the action plan': '¿Desea eliminar el plan de acción',
	'Answer the survey': 'Responder la encuesta',
	'If the button does not work, copy and paste this link into your browser:': 'Si el botón no funciona, copie y pegue este enlace en su navegador:'
});
export default dictionary;
